<script>
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
import { appConfig } from '../../config.js'
import { mapActions, mapGetters } from 'vuex'
import Axios from 'axios'
import _ from 'lodash'
import draggable from 'vuedraggable'
import { VueContext } from 'vue-context'
import DatePicker from '../utility/date-picker'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import FileUploader from '../utility/file-uploader'
import ImageLightbox from '../utility/image-lightbox/image-lightbox'
import NumberFormatter from '../utility/number-formatter'
import AmazonAds from '../utility/amazon-ads'
import AdvancedSearch from '../utility/advanced-search'
import ImageSelector from '../utility/image-selector'
import SiteFooter from '../common/site-footer'
import ActivityReplyMessage from '../activity-reply-message'
import vue2Dropzone from 'vue2-dropzone'
import GoogleLocation from '../utility/google-location'
import { FormWizard, TabContent, WizardStep } from 'vue-form-wizard'
import Multiselect from 'vue-multiselect'
import ActivityList from '../utility/activity-list/activity-list'
import CardNotes from '../utility/card-notes'
import CardFiles from '../utility/card-files'
import InsuranceBlock from '../utility/insurance.block.vue'
import VehicleBlock from '../utility/vehicle.block'
import EstimateSupplements from '../utility/estimate-supplements'
import { isMobile, isMobileOnly, isTablet } from '../../deviceDetect/index'
import { email, required } from 'vuelidate/lib/validators'
import RsFormWizard from '../rs-form-wizard'
import SmallFormWizard from '../small-form-wizard.vue'
import RsRipple from '../rs-ripple.vue'
import accounting from 'accounting'
import BlockPagination from '../utility/block-pagination'
import AdvertBanner from '../utility/advert-banner'
import WebCamera from '../utility/web-camera/web-camera'
import PdfViewer from '../utility/pdf-viewer'
import QRCode from 'qrcode.vue'
import Vue from 'vue'
import dropdownOptions from '../../mixins/dropdownOptions'
import ItemList from './estimate-edit/item-list'
import AssessmentAuth from './estimate-edit/assessment-auth'
import numeral from 'numeral'
import SearchFilter from '@/components/search-filter/search-filter.vue'
import SearchFilter2 from '@/components/search-filter/search-filter-2.vue'
import assignToModal from '@/components/utility/assign-to-modal.vue'
import CarScheme from '@/components/estimates/estimate-edit/car-scheme.vue'
import ModalNote from '../../components/utility/modal-note.vue'
import EstimateRates from './estimate-edit/estimate-rates'

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
})

export default {
  name: 'estimates-edit',
  mixins: [
    dropdownOptions,
  ],
  data () {
    return {
      forcedSelectCard: null,
      tabsTopPosition: 0,
      loadResAi: false,
      copyEstimate: {
        copyToCardId: '',
        isCopyImages: false,
        isCopyFiles: false,
        copyToCard: {},
        isCopyEstimateValuesOnly: true,
      },
      loadingEstimate: false,
      isShowQrCode: false,
      contextOpenEvent: null,
      activeCarScheme: false,
      assignToActive: false,
      searchFilter: '',
      isShowCamera: false,
      tabsArrowLeftVisible: false,
      tabsArrowRigthVisible: true,
      ordersUpdater: 0,
      computedOnSiteSelect: 0,
      manualOrdersUpdater: 0,
      categories: [],
      currentBoards: [],
      schedulingUpdate: {},
      plannerBoardGroupId: null,
      isArrivedDateFromUpdater: false,
      isPickUpDateFromUpdater: false,
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1', '#2196F3', '#3F51B5', '#673AB7', '#00BCD4', '#4CAF50', '#FF9800', '#757575'],
      rentalDateHireStart: null,
      rentalDateHireEnd: null,
      isShowScanner: false,
      hideWarningAuthorisationModal: false,
      boardIn: {
        id: null,
        updatedDate: null,
        createdDate: null,
      },
      isShowGallery: false,
      boardDeparture: {
        id: null,
        updatedDate: null,
        createdDate: null,
      },
      lastTimestampImages: 0,
      intervalUpdateImages: null,
      rentalType: '',
      isCheckedEmail: true,
      isItemListLoaded: false,
      selectedVehicleSubTab: 'estimates-values',
      allowShowImportPdfParts: {},
      isShowNotCompressed: {},
      itemsList: [],
      selectedSchemeParts: [],
      selectedEstimateItem: {
        part: {},
        type: '',
      },
      isCanDrag: true,
      isNeedCopy: false,
      selectedText: '',
      currentItemListId: null,
      selectedCard: {}, //ToDo temp var
      repairCategory: null,
      properties: {
        audaUrl: '',
        isAutoSave: true,
        isCanSendToClaimlinq: false,
        isFromClaimlinq: false,
        isFromEio: false,
        isFromAudaBridge: false,
        isFromAudaNet: false,
        isCanSendToPartssearch: false,
        isFromIag: false,
        isRegoAlwaysLookup: false,
        isRegoLookup: false,
        isRegoLookupWithCompliance: false,
        isVinAlwaysLookup: false,
        isVinLookup: false,
        isVinLookupWithCompliance: false,
        isHideSeries: false,
        isRatesRREditable: true,
        isRatesRepairEditable: true,
        isRatesPaintEditable: true,
        isRatesEditable: true,
        isSmsFeatureEnabled: false,
        production: {
          categories: [],
          numberOfDays: {
            weld: 0,
            mechanical: 0,
            hail: 0,
            electrical: 0,
            ppf: 0,
            accessories: 0,
          }
        },
        isBlockByAuda: false,
        isAudaContractedCompany: false,
      },
      filterAssignTo: '',
      fileTypeOptions: [
        {
          value: 'miscellaneous',
          label: 'Miscellaneous',
        },
        {
          value: 'jobRequest',
          label: 'Job Request',
        },
        {
          value: 'assessorAdjustment',
          label: 'Assessor Adjustment',
        },
        {
          value: 'authority',
          label: 'Authority',
        },
        {
          value: 'subletInvoice',
          label: 'Sublet Invoice',
        },
        {
          value: 'supplierInvoice',
          label: 'Supplier Invoice',
        },
        {
          value: 'supplierCredit',
          label: 'Supplier Credit',
        },
        {
          value: 'mechanical',
          label: 'Mechanical',
        },
      ],
      newTask: {
        name: '',
        date: '',
        time: '00:00',
        notes: '',
        type: { key: 'to-do', value: 'ToDo' },
        assignedTo: { id: '-1', name: 'Estimators' },
        status: { key: 'none', value: 'None' },
      },
      note: '',
      note_id: null,
      note_type: '',
      activeNote: null,
      isOpenNewTaskForm: false,
      showAddEnvironmentLevy: false,
      showAddPaintSetup: false,
      backdoor: 0,
      backdoorButterflyCustomMatrix: 0,
      paintMaterials: [
        { key: 'not_set', value: '' },
        { key: 'S1', value: 'S1' },
        { key: 'S2', value: 'S2' },
        { key: 'M1', value: 'M1' },
        { key: 'M2', value: 'M2' },
        { key: 'M3', value: 'M3' },
        { key: 'M3PLUS', value: 'M3+' },
      ],
      estimateMethodologies: [
        { key: 'custom', value: 'Custom' },
        { key: 'ntar', value: 'NTAR' },
        { key: 'ltar', value: 'LTAR' },
        { key: 'zi', value: 'Zurich' },
        { key: 'dollars', value: 'Dollars' },
      ],
      classTabContent: 'tab-content',
      isHiddenOptions: false,
      isHiddenNewNote: true,
      isSentToInsurer: false,
      isLoadedEstimate: false,
      isLoadTimesForItemPart: false,
      notes: [],
      heightOptions: '',
      computedOnSiteSelect: 0,
      isAttendedBookingYes: false,
      isAttendedBookingNo: false,
      currentNewPaintCode: '',
      vehiclePaintCodes: [],
      currentNewMake: '',
      currentNewModel: '',
      currentNewSeries: '',
      currentNewScheduleNumber: '',
      newVehiclePaintCode: {},
      isShowPaintMaterialNotification: false,
      showEnviromentLevy: true,
      showPaintSetupTime: true,
      isShowNewPaintColourNotification: false,
      timesForItemPart: {},
      estimateAmount: {
        estimate_number: '',
        supplement_number: 0,
        parent_estimate_id: 0,
        state: '',
        amount: '',
        amount_str: '',
        tech_assigned: 'None',
        assignedTo: { id: null, name: null },
        parts_purchase_order: '',
        parts_markup_profit: '',
      },
      filesAfterUpload: [],
      imagesAfterUpload: [],
      isAutoSave: false,
      isAuthorisePage: {},
      addTemplateHeight: 1000,
      saveTemplateHeight: 1000,
      autoSaveMessage: '',
      originalData: '',
      updateData: {},
      updateData2: {},
      autoUpdateItemsList: {},
      manualUpdateItemsList: {},
      activitySortTypes: {
        email: 'Email',
        sms: 'SMS',
        external: 'External',
        assignment: 'Assignment',
        status_change: 'Status/Change',
        show_all: 'Show All',
      },
      activitySortTypeText: 'Sort By',
      isMobile,
      isMobileOnly,
      imageUploadDropzoneOptions: {
        headers: { 'Authorization': localStorage.getItem('token') },
        resizeWidth: 1500,
        resizeQuality: 0.7,
        capture: 'camera',
        clickable: '.drop-clickable',
        url: appConfig.baseAPIURL + '/fe/card/uploadImagesDropzone',
        method: 'post',
        maxFilesize: 50,
        // maxFiles: 2,     //Can be used to limit the maximum number of files that will be handled by this Dropzone
        thumbnailWidth: 200,
        timeout: 300000,
        addRemoveLinks: false,
        acceptedFiles: 'image/jpeg, image/jpg, image/png',
        dictFileTooBig: 'Your image has exceeded the maximum limit of 5MB per image. Please reduce the image size and upload again',
      },
      fileUploadDropzoneOptions: {
        headers: { 'Authorization': localStorage.getItem('token') },
        url: appConfig.baseAPIURL + '/fe/card/uploadFilesDropzone',
        method: 'post',
        maxFilesize: 50,
        timeout: 300000,
        clickable: '.browse-btn-files',
        // maxFiles: 2,     //Can be used to limit the maximum number of files that will be handled by this Dropzone
        thumbnailWidth: 200,
        addRemoveLinks: false,
        acceptedFiles: 'application/pdf, .doc, .docx',
        dictFileTooBig: 'Your doc has exceeded the maximum limit of 5MB per doc. Please reduce the file size and upload again',
      },
      itemsListImageUploadDropzoneOptions: {
        headers: { 'Authorization': localStorage.getItem('token') },
        resizeWidth: 1500,
        resizeQuality: 0.7,
        url: appConfig.baseAPIURL + '/fe/card/uploadImagesDropzone',
        method: 'post',
        maxFilesize: 5,
        thumbnailWidth: 160,
        thumbnailHeight: 160,
        addRemoveLinks: false,
        acceptedFiles: 'image/jpeg, image/jpg, image/png',
        dictFileTooBig: 'Your image has exceeded the maximum limit of 5MB per image. Please reduce the file size and upload again',
      },
      changeEstimentChapter: 'All',
      currentTab: 'vehicleDetails',
      prevTab: null,
      selectedVehicleMake: {},
      selectedVehicleModel: {},
      count: 0,
      estimateToCustomer: null,
      status: '',
      newImageAdded: false,
      newFileAdded: false,
      customerContacts: Array(),
      new_customer_email: '',
      new_customer_name: '',
      new_insurer_name: '',
      new_insurer_email: '',
      supplements: [],
      activity: [],
      countries: {
        'AU': 'Australia',
        'NZ': 'New Zealand'
      },
      states: {
        QLD: 'Queensland',
        NT: 'Northern Territory',
        NSW: 'New South Wales',
        VIC: 'Victoria',
        TAS: 'Tasmania',
        SA: 'South Australia',
        WA: 'Western Australia'
      },
      image: '',
      images: [],
      image_ids: [],
      image_categories: [],
      selectedImages: [],
      file: '',
      files: [],
      file_ids: [],
      draft: 'N',
      insurers: [],
      assessors: [],
      card_id: '',
      cardProgress: {
        startIndex: 0,
        color: '#142742',
        stepSize: 'xs',
        width: '',
        widthActiveProgress: '',
      },
      cardProgressSmall: {
        startIndex: 0,
        color: '#142742',
        stepSize: 'xs',
        width: '',
        widthActiveProgress: '',
      },
      state: '',
      plannerBoard: {
        onSite: {
          "id": 0,
          "name": "",
          "groupId": 0,
          "type": "on-site",
          "onsiteEstimateBookingDate": "",
          "isAttendedBooking": null,
          "reason": "",
          "attempt": "",
          "isRebooked": "",
          "followUpAction": ""
        }
      },
      isAttendedBookingYes: false,
      isAttendedBookingNo: false,
      onSiteFollowUpAction: 'default',
      onSiteReason: null,
      onSiteAttempt: null,
      card: {
        customer: {
          customer_id: null,
          name: '',
          mobile: '',
          email: '',
          customer_type: '',
          abn: '',
          address: '',
          level_unit_lot: '',
          street_name: '',
          suburb: '',
          state: '',
          postcode: '',
          country: '',
          phone: '',
        },
        vehicle: {
          customer_vehicle_id: null,
          dom: '',
          complianceDate: '',
          rego_number: '',
          make: '',
          model: '',
          series: '',
          series_shedule_number: '',
          colour: '',
          colour_variant: '',
          vin: '',
          odometer: '',
          transmission: ''
        },
        insurance: {
          id: null,
          insurance_claim_type: null,
          insurer_id: null,
          insurer_name: '',
          insurer_location: '',
          insurer_assessor_id: null,
          assessor_name: '',
          assessor_email: '',
          assessor_phone: '',
          policy_number: '',
          claim_number: '',
          assessment_date: '',
          excess: '',
          contribution: '',
          discount: '',
          market_value: '',
          agreed_value: '',
          accidentDescription: '',
          sumInsured: '',
          pav: '',
          rates: {
            estimate_methodology: 'custom',
            estimate_rates_rr: null,
            estimate_rates_repair: null,
            estimate_rates_paint: null,
            estimate_rates_rs_paint_percentage: 20,
            estimate_rates_rs_rr_percentage: 20,
          },
          custom_paint_times: {
            s1: 0,
            s2: 0,
            m1: 0,
            m2: 0,
            m3: 0,
            m3plus: 0
          },
        },
        customer_contact_2: '',
        insurance_repair: '',
        booking_date: '',
        completion_date: '',
        card_number: '',
        card_id: '',
        card_status: '',
        statuses: [],
        isTotalLoss: false,
        vehicleDriverName: '',
        contactNumber1: '',
        contactNumber2: '',
        contactEmail: '',
      },
      invoice: {
        id: null,
        status: '',
        number: '',
      },
      excess_invoice: {
        id: null,
        status: '',
        number: '',
      },
      completion_date: '',
      booking_date: '',
      arrivedDate: '',
      pickUpDate: '',
      pickUpTime: '',
      defaultValues: {
        rates: {
          custom: {
            default_rates_estimate_methodology: '',
            default_rates_paint_material: '',
            default_rates_rr: '',
            default_rates_repair: '',
            default_rates_paint: '',
            default_rates_mechanical: '',
            is_active: false,
          },
          ntar: {
            default_rates_estimate_methodology: '',
            default_rates_paint_material: '',
            default_rates_rr: '',
            default_rates_repair: '',
            default_rates_paint: '',
            default_rates_mechanical: '',
            is_active: false,
          },
          ltar: {
            default_rates_estimate_methodology: '',
            default_rates_paint_material: '',
            default_rates_rr: '',
            default_rates_repair: '',
            default_rates_paint: '',
            default_rates_mechanical: '',
            is_active: false,
          },
          rs: {
            default_rates_estimate_methodology: '',
            default_rates_paint_material: '',
            default_rates_rr: '',
            default_rates_repair: '',
            default_rates_paint: '',
            default_rates_mechanical: '',
            default_rates_rs_rr_percentage: 20,
            default_rates_rs_paint_percentage: 20,
            is_active: false,
          },
          zi: {
            default_rates_estimate_methodology: '',
            default_rates_paint_material: '',
            default_rates_rr: '',
            default_rates_repair: '',
            default_rates_paint: '',
            default_rates_mechanical: '',
            is_active: false,
          },
          active: 'custom',
        }
      },
      estimateRatesUpdater: 0,
      callApproximateDaysComputed: 0,
      productionTime: {
        category: null,
        isCheckWeld: false,
        weldQty: 1,
        isCheckMechanical: false,
        isCheckHail: false,
        isCheckElectrical: false,
        isCheckPpf: false,
        isCheckAccessories: false,
      },
      callRatesUpdate: 0,
      selectedFile: null,
      documentHeight: 0,
      documentWidth: 0,
      onSiteReason: null,
      onSiteAttempt: null,
      plannerBoard: {
        'vehicle': {
          groupId: null,
          id: null,
          name: '',
        },
        'onSite': {
          groupId: null,
          attempt: null,
          isAttendedBooking: false,
          onsiteEstimateBookingDate: null,
          reason: null,
          id: null,
          name: '',
        },
      },
      estimate: {
        id: 0,
        rental: {
          isRequired: false,
          type: '',
          hirerName: '',
          hireStart: '',
          hireEnd: '',
          rentalCompany: null,
          leadDate: '',
        },
        templateId: 0,
        shop: {},
        isEstimateForButterfly: true,
        isShowEnvironmentLevyCalculation: true,
        isShowPaintSetupCalculation: true,
        dateCreated: '',
        isSentToIntegrationSystem: false,
      },
      estimateRates: {
        estimate_methodology: 'custom',
        rr: 95,
        repair: 95,
        paint: 95,
        partmarkup: 0,
        paint_material: 'not_set',
        material_use_levy: 'Y',
        subtotal: 0,
        adjSubtotal: 0,
        mechanical: 0,
        rs_rr_percentage: 20,
        rs_paint_percentage: 20,
      },
      iagOrmItems: {
        'RR': [],
        'Repair': [],
        'Paint': [],
        'Part': [],
        'Materials': [],
        'MaterialsCalc': [],
        'Sublet': [],
        'Other': [],
        'PDR': [],
      },
      estimateParts: {
        'RR': [],
        'Repair': [],
        'Paint': [],
        'Part': [],
        'Materials': [],
        'MaterialsCalc': [],
        'Sublet': [],
        'Other': [],
        'PDR': [],
      },
      removeEstimateParts: {
        'RR': [],
        'Repair': [],
        'Paint': [],
        'Part': [],
        'Materials': [],
        'Sublet': [],
        'Other': [],
        'PDR': [],
      },
      overrideIndex: -1, // override index in items list -> material tab -> total
      estimate_number: '',
      supplement_number: 0,
      parent_estimate_id: 0,
      drImageOptions: {
        messages: {
          'default': 'Drag and drop an image here or click to select it from your computer',
          'replace': 'Drag and drop or click to add new image',
          'remove': 'Remove',
          'error': 'Ooops, something went wrong.'
        }
      },
      drFilesOptions: {
        messages: {
          'default': 'Drag and drop a file here or click to select it from your computer',
          'replace': 'Drag and drop or click to add new file',
          'remove': 'Remove',
          'error': 'Ooops, something went wrong.'
        }
      },
      error: {
        exists: false,
        messages: []
      },
      pinImage: false,
      pinImagePage: false,
      assignedToUsers: [],
      assignedToUser: '',
      assignedTo: '',
      assignedToArr: [],
      assignedName: '',
      assignedToText: '',
      loaderAssignTo: false,
      resultSortingImages: {},
      uploadImageCategories: ['Uncategorised', 'Vehicle ID', 'Accident Damage', 'Supplementary Damage', 'Existing Damage', 'Final Inspection'],
      fields: [
        {
          label: 'Doc Name',
          key: 'name',
          sortable: true,
          tdClass: 'file-name',
          thClass: 'file-name'
        },
        {
          label: 'Type',
          key: 'type',
          sortable: true,
          tdClass: 'file-type',
          thClass: 'file-type'
        },
        {
          label: 'Uploaded By',
          key: 'user',
          sortable: true,
          tdClass: 'uploaded-by',
          thClass: 'uploaded-by'
        },
        {
          label: 'Date',
          key: 'sortDate',
          sortable: true,
          tdClass: 'uploaded-date',
          thClass: 'uploaded-date'
        },
        {
          label: 'Doc Size',
          key: 'fileSize',
          sortable: true,
          tdClass: 'file-size',
          thClass: 'file-size'
        },
        {
          label: 'Action',
          key: 'action',
          tdClass: 'action',
          thClass: 'action'
        }
      ],
      cardsPerPage: 10,
      cardsCurrentPage: 1,
      topSticky: 0,
      selectedPcName: null,
      selectedPcId: null,
      intervalUpdateScannerFiles: null,
      checkConnectedPcsIntervalId: null,
      checkConnectedPcsInterval: 10000,
      isTablet,
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!_.isEmpty(this.updateData2)) {
      if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
        return
      }
    }

    let isHasNotConfirmAuth = _.some(this.itemsList, (item) => {
      return this.isAuthorisePage[item.id]
    })
    if (isHasNotConfirmAuth) {
      if (!confirm('Do you really want to lose the page? Estimate has unconfirmed authorization')) {
        return
      }
    }

    this.$storage.remove('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView')
    next()
  },
  filters: {
    valuePDRMaterial: function (value) {
      if (value === 'PushToPaint') {
        return 'Push To Paint'
      }
      return value
    }
  },
  validations: {
    new_customer_email: {
      email,
    },
    new_insurer_email: {
      email,
    },
    card: {
      customer: {
        email: {
          email,
        }
      },
      contactEmail: {
        email,
      },
      insurance: {
        assessor_email: {
          email,
        }
      },
      vehicle: {
        rego_number: {
          required,
        },
        make: {
          required,
        },
        model: {
          required,
        },
      },
    }
  },
  methods: {
    ...mapActions([
      'clearFileIdsInCardEdit',
      'updateFiles',
      'unshiftFileInCardEdit',
      'setButterflyMatrixOrder',
      'addToButterflyCustomMatrix',
      'removeFromButterflyCustomMatrix',
      'getConnectedPcs'
    ]),
    onDelAssessment (id) {
      this.forcedSelectCard = null
      this.$nextTick(() => {
        this.forcedSelectCard = 'Part'
      })
      let vm = this
      this.loadItemsList(this.$route.params.estimate_id, (items) => {
        _.forEach(items, function (item) {
          if (item?.AI) {
            const i = vm.itemsList.find((i) => i.id == item.id)
            vm.$set(i, 'AI', item?.AI)
          }
        })
      }, false)

      // console.log('onDelAssessment',id)
      // const estimate = this.itemsList.find(item => item.id == id)
      // this.$set(estimate, 'AI', null)

    },
    handleReloadEstimate () {
      this.loadItemsList(this.$route.params.estimate_id)
      this.loadEstimate(this.$route.params.estimate_id, false, true, false)
      this.setTitle()
      this.loadActivity()
      this.$nextTick(() => {
        if (this.$refs.itemList && this.$refs.itemList[0] && this.$refs.itemList[0].selectCard) {
          this.$refs.itemList[0].selectCard('RR')
        }
      })
    },
    handleVehicleUpdate () {
      this.loadEstimate(this.estimate.id, (data) => {
        this.card.vehicle = data?.card?.vehicle
      })
      this.loadNotes()
      this.loadItemsList(this.$route.params.estimate_id)
    },
    async viewInAudaNet () {
      if (this.properties?.audaUrl == '') {
        return
      }
      const url = this.properties?.audaUrl;
      //empty line
      (async (url) => {
        const popup = window.open('', '_blank')
        if (popup) {
          popup.location.href = url
        }
      })(url)
    },
    async sendPartsToAudaQuote () {
      const toastId = 'send-parts-to-auda'
      const loadingMessage = 'Sending Part Pricing to AUDANET quote. Please wait...'

      // Show loading notification
      const toast = toastr.info(loadingMessage, '', {
        timeOut: 0,
        extendedTimeOut: 0,
        closeButton: true,
        tapToDismiss: false
      })

      const autosave = this.isAutoSave
      this.isAutoSave = false

      try {
        const resp = await Axios({
          url: `/fe/estimate/${this.estimate.id}/send-parts-to-auda-quote`,
          method: 'POST'
        })

        // Remove the loading notification
        if (toast && typeof toast.remove === 'function') {
          toast.remove()
        } else {
          // Fallback method if remove() is not available
          $('#' + toastId).remove()
        }

        if (resp.data?._status) {
          toastr.success('Part Pricing sent to AUDANET quote successfully!')
          this.autoSaveMessage = ''
          this.debouncedUnsavedChanges.cancel()
          // Optionally reload data if needed
          await this.loadItemsList(this.$route.params.estimate_id)
          await this.loadEstimate(this.$route.params.estimate_id, false, true, true)
        } else {
          const errorMessage = resp.data?.message || 'Failed to send Part Pricing to AUDANET quote. Please check activity log for details.'
          throw new Error(errorMessage)
        }
      } catch (error) {
        // Remove the loading notification on error
        if (toast && typeof toast.remove === 'function') {
          toast.remove()
        } else {
          // Fallback method if remove() is not available
          $('#' + toastId).remove()
        }

        console.error('Error sending parts to AUDANET quote:', error)
        const errorMessage = error.response?.data?.message ||
            error.message ||
            'Failed to send Part Pricing to AUDANET quote. Please check activity log for details.'
        toastr.error(errorMessage)
        throw error // Re-throw the error if you want calling code to handle it
      } finally {
        this.isAutoSave = autosave
      }
    },
    async downloadAudaQuote () {
      const toastId = 'auda-quote-download'
      const loadingMessage = 'Sending request for download AUDA quote. Please wait...'

      // Show loading notification
      const toast = toastr.info(loadingMessage, '', {
        timeOut: 0,
        extendedTimeOut: 0,
        closeButton: true,
        tapToDismiss: false
      })

      const autosave = this.isAutoSave
      this.isAutoSave = false

      try {
        const response = await Axios({
          url: `/fe/estimate/${this.estimate.id}/download-auda-quote`,
          method: 'POST'
        })

        // Remove the loading notification
        if (toast && typeof toast.remove === 'function') {
          toast.remove()
        } else {
          // Fallback method if remove() is not available
          $('#' + toastId).remove()
        }

        if (response.data._status) {
          toastr.success('AUDA quote downloaded successfully!')
          await this.loadItemsList(this.$route.params.estimate_id)
          await this.loadEstimate(this.$route.params.estimate_id, false, true, true)
          this.setTitle()
          await this.loadActivity()
          this.$nextTick(() => {
            this.autoSaveMessage = ''
          })
          this.debouncedUnsavedChanges.cancel()
          setTimeout(() => {
            this.autoSaveMessage = ''
          }, 200)
        }

        return response
      } catch (error) {
        // Remove the loading notification on error
        if (toast && typeof toast.remove === 'function') {
          toast.remove()
        } else {
          // Fallback method if remove() is not available
          $('#' + toastId).remove()
        }

        const errorMessage = error.response?.data?.message ||
            error.message ||
            'Failed to download AUDA quote. Please check activity log for details.'
        toastr.error(errorMessage)
        console.error('downloadAudaQuote error:', error)
        throw error
      } finally {
        this.isAutoSave = autosave
      }
    },
    async downloadAudaParts () {
      const toastId = 'auda-parts-download'
      const loadingMessage = 'Sending request for download AUDA Parts List. Please wait...'

      // Show loading notification
      const toast = toastr.info(loadingMessage, '', {
        timeOut: 0,
        extendedTimeOut: 0,
        closeButton: true,
        tapToDismiss: false
      })

      const autosave = this.isAutoSave
      this.isAutoSave = false

      try {
        const response = await Axios({
          url: `/fe/estimate/${this.estimate.id}/download-auda-parts`,
          method: 'POST'
        })

        // Remove the loading notification
        if (toast && typeof toast.remove === 'function') {
          toast.remove()
        } else {
          // Fallback method if remove() is not available
          $('#' + toastId).remove()
        }

        if (response.data._status) {
          toastr.success('AUDA Parts List downloaded successfully!')
          await this.loadItemsList(this.$route.params.estimate_id)
          await this.loadEstimate(this.$route.params.estimate_id, false, true, true)
          this.setTitle()
          await this.loadActivity()
          this.$nextTick(() => {
            this.autoSaveMessage = ''
          })
          this.debouncedUnsavedChanges.cancel()
          setTimeout(() => {
            this.autoSaveMessage = ''
          }, 200)
        }

        return response
      } catch (error) {
        // Remove the loading notification on error
        if (toast && typeof toast.remove === 'function') {
          toast.remove()
        } else {
          // Fallback method if remove() is not available
          $('#' + toastId).remove()
        }

        const errorMessage = error.response?.data?.message ||
            error.message ||
            'Failed to download AUDA Parts List. Please check activity log for details.'
        toastr.error(errorMessage)
        console.error('downloadAudaParts error:', error)
        throw error
      } finally {
        this.isAutoSave = autosave
      }
    },
    async onRunVehicleIdentifier () {
      const cardId = Number(this.card.card_id)

      // Set request status in Vuex store (persists across navigation)
      this.$store.commit('aiVehicle/createRequest', cardId)

      try {
        await Axios({
          url: '/fe/card/ai-vehicle-info',
          data: {
            existImages: true,
            cardId: this.card.card_id,
          },
          method: 'POST'
        })

        // Mark as done in store
        this.$store.commit('aiVehicle/setRequestDone', cardId)
      } catch (err) {
        console.error('AI vehicle info request failed:', err)
        this.$store.commit('aiVehicle/setRequestError', cardId)
      } finally {
        // Clean up after 2 seconds
        setTimeout(() => {
          this.$store.commit('aiVehicle/removeRequest', cardId)
        }, 2000)
      }
    },
    // async onRunVehicleIdentifier () {
    //   this.loadResAi = true
    //   await Axios({
    //     url: '/fe/card/ai-vehicle-info',
    //     data: {
    //       existImages: true,
    //       cardId: this.card.card_id,
    //     },
    //     method: 'POST'
    //   })
    //       .then(resp => {
    //             if (resp.data && resp.data._status === true) {
    //               const vehicle = resp.data.vehicle
    //               Object.assign(
    //                   this.card.vehicle,
    //                   _.pickBy({
    //                     rego_number: vehicle.rego,
    //                     make: vehicle.make,
    //                     model: vehicle.model,
    //                     complianceDate: vehicle.compliance_date,
    //                     series: vehicle.series,
    //                     vin: vehicle.vin,
    //                     odometer: vehicle.odometer,
    //                     transmission: vehicle.transmission,
    //                     dom: vehicle.build_date,
    //                     series_shedule_number: vehicle.model_code_number ?? null,
    //                   }, (value, key) => {
    //                     if (value === undefined) return false
    //                     const current = this.card.vehicle[key]
    //                     return current === null || current === undefined || current === ''
    //                   })
    //               )
    //               this.$refs['vehicle-block'].autoUpdateCardVehicle()
    //               this.loadNotes()
    //             } else {
    //               toastr.error(resp.data.message)
    //             }
    //
    //           }
    //       )
    //       .catch(err => {
    //         console.log(err)
    //       }).finally(() => {
    //         this.loadResAi = false
    //       })
    // },
    navTabsTopStyle (id) {
      if (document.getElementById('pageHeaderEst')) {
        if (id == 'chevron') {
          return { top: document.getElementById('pageHeaderEst').offsetHeight + 65 + 'px' }
        }
        if (id == 'tabs') {
          return { top: document.getElementById('pageHeaderEst').offsetHeight + 60 + 'px' }
        }
      }
    },
    addToSupplement (data) {
      let supplement = null
      if (this.itemsList && this.itemsList.length >= 2) {
        let lastSupplement = this.itemsList[this.itemsList.length - 1]
        if (lastSupplement && lastSupplement.type === 'supplement' && !lastSupplement.isAuthorised) {
          supplement = lastSupplement
        }
      }

      if (!supplement) {
        this.createSupplement(data)
      } else {
        if (data && data.type) {
          this.addNewPartToSupplement(data.type, data.elem, supplement.id)
        }
      }
    },
    addNewPartToSupplement (card, item, suppId) {
      let newItem = {}
      let data = {
        partId: item.id,
        partType: card,
        from: this.currentItemListId
      }
      if (card == 'RR') {
        newItem = {
          hrs: 0,
          id: null,
          name: item.name,
          rate: this.estimateRates.rr ? this.estimateRates.rr : 0,
          rate2: 0,
          total: 0,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
        }
      } else if (card == 'Repair') {
        newItem = {
          hrs: 0,
          id: null,
          name: item.name,
          rate: this.estimateRates.repair ? this.estimateRates.repair : 0,
          rate2: 0,
          total: 0,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
        }
      } else if (card == 'Paint') {
        newItem = {
          hrs: 0,
          id: null,
          name: item.name,
          paint_type: this.estimateRates.paint_material ? this.estimateRates.paint_material : 'not_set',
          rate: this.estimateRates.paint,
          total: 0,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
        }
      } else if (card == 'Sublet') {
        newItem = {
          hrs: 0,
          id: null,
          name: item.name,
          rate: 0,
          total: 0,
          adj_rate: null,
          adj_price: null,
          is_show_in_jobcard: true,
          comments: {},
          adj_approve_status: 'none',
        }
      } else if (card == 'Other') {
        newItem = {
          hrs: 0,
          id: null,
          name: item.name,
          rate: 0,
          total: 0,
          adj_rate: null,
          adj_price: null,
          adj_mup: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
        }
      } else if (card == 'Part') {
        newItem = {
          part_num: '',
          type: item.type ? item.type : 'New',
          mup: this.estimateRates.partmarkup ? this.estimateRates.partmarkup : 0,
          qty: 1,
          id: null,
          name: item.name,
          rate: 0,
          total: 0,
          adj_price: null,
          adj_total: null,
          adj_rate: null,
          adj_mup: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
        }
      }
      this.saveNewPart(card, data, newItem, suppId)
    },
    saveNewPart: function (card, data, newObj = null, estimateId = null) {
      this.autoSaveMessage = 'Saving...'
      let itemList = this.getItemList(estimateId)
      var vm = this
      Axios({
        method: 'post',
        responseType: 'json',
        headers: { 'addPart': true },
        url: `/fe/estimate/${estimateId}`,
        validateStatus: function (status) {
          return status < 500
        },
        data: data
      })
          .then(response => {
            if (response.status === 200) {
              if (response.data.result.id) {
                vm.autoSaveMessage = 'Saved'
                if (response.data.result.calculation) {
                  vm.updateCalculation(response.data.result.calculation, estimateId)
                }
                if (newObj) {
                  newObj.id = response.data.result.id
                  if (response?.data?.result?.part) {
                    newObj = response?.data?.result?.part
                  }
                  itemList.parts[card].push(newObj)
                  // vm.orderItemParts()
                }
              } else {
                vm.autoSaveMessage = 'Unsaved Changes'
              }
            } else {
              vm.autoSaveMessage = 'Unsaved Changes'
            }
          })
          .catch(error => {
            vm.autoSaveMessage = 'Unsaved Changes'
          })
    },
    hideQrCode () {
      if (this.isShowQrCode) {
        this.isShowQrCode = false
      }
    },
    checkIsAttendYes (v, isSave = true) {
      if (v) {
        this.isAttendedBookingYes = v
        this.isAttendedBookingNo = false
        this.plannerBoard.onSite.isAttendedBooking = v
      } else {
        this.isAttendedBookingYes = v
        this.isAttendedBookingNo = v
        this.plannerBoard.onSite.isAttendedBooking = null
      }
      this.computedOnSiteSelect++
      if (isSave) {
        this.saveOnsiteData()
      }
    },
    checkIsAttendNo (v, isSave = true) {
      if (v) {
        this.isAttendedBookingYes = false
        this.isAttendedBookingNo = v
        this.plannerBoard.onSite.isAttendedBooking = false
      } else {
        this.isAttendedBookingYes = v
        this.isAttendedBookingNo = v
        this.plannerBoard.onSite.isAttendedBooking = null
      }
      this.computedOnSiteSelect++
      if (isSave) {
        this.saveOnsiteData()
      }

    },
    saveOnsiteData () {
      let update = {}
      update.plannerBoard = {}
      update.plannerBoard.onSite = {
        attempt: this.onSiteAttempt,
        isAttendedBooking: this.plannerBoard?.onSite?.isAttendedBooking,
        // onsiteEstimateBookingDate: this.plannerBoard?.onSite?.onsiteEstimateBookingDate,
        reason: this.onSiteReason,
      }

      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    goToOnSiteEvent () {
      this.$router.push({
        name: 'planner',
        params: {
          onSiteEventId: this.plannerBoard.onSite.id,
          cardId: this.card.card_id,
          date: this.plannerBoard.onSite?.onsiteEstimateBookingDate
        }
      })
    },
    setHeightForAddTemplateMenu () {
      let el = document.getElementById('add-template')
      if (el) {
        this.addTemplateHeight = window.innerHeight - el.getBoundingClientRect().y - 15
      }
    },
    setHeightForSaveTemplateMenu () {
      let el = document.getElementById('save-template')
      if (el) {
        this.saveTemplateHeight = window.innerHeight - el.getBoundingClientRect().y - 15
      }
    },
    contextOpen: function (event, w, e) {
      this.contextOpenEvent = event
    },
    contextClose: function () {
      let event = this.contextOpenEvent
      if (event) {
        let row = event.target.parentElement
        let rows = row.parentElement.rows
        if (rows) {
          for (let i = 0; i < rows.length; i++) {
            let elem = rows[i]
            elem.style.backgroundColor = ''
          }
        }
      }
    },
    openFileViewer (item) {
      if (item.isPdf) {
        this.selectedFile = item
      }
    },
    editFile (item) {
      this.$set(item, 'isEdit', !item.isEdit)
      if (item.isEdit) {
        let name = _.cloneDeep(item.name)
        if (item.isPdf) {
          if (_.includes(name, '.pdf')) {
            name = name.replace('.pdf', '')
            this.$set(item, 'fileType', '.pdf')
          }
        } else {
          if (_.includes(name, '.docx')) {
            name = name.replace('.docx', '')
            this.$set(item, 'fileType', '.docx')
          }
          if (_.includes(name, '.doc')) {
            name = name.replace('.doc', '')
            this.$set(item, 'fileType', '.doc')
          }
        }
        this.$set(item, 'name2', name)
      }

      this.contextClose()
    },
    getFiles (v) {
      let r = []
      _.forEach(v, (f) => {
        let orig = _.find(this.files, (file) => {
          return Number(file.id) == Number(f.id)
        })
        if (orig && orig.isEdit) {
          f.isEdit = true
        }
        if (orig && orig.fileType) {
          f.fileType = orig.fileType
        }
        if (orig && orig.name2) {
          f.name2 = orig.name2
        }
        r.push(f)
      })
      return r
    },
    getFileTypeLabel (v) {
      return _.find(this.fileTypeOptions, (o) => {
        return o.value == v
      })?.label || ''
    },
    saveFile (item) {
      NProgress.start()
      Axios({
        method: 'put',
        responseType: 'json',
        url: `/fe/estimate/${this.$route.params.estimate_id}/file/${item.id}`,
        data: {
          id: item.id,
          type: item.type,
          name: item.name2 + item.fileType
        }
      }).then((r) => {
        if (r?.data?._status) {
          toastr.success('Saved!')
        }
      }).finally(() => {
        NProgress.done()
      })
    },
    onClosePdf () {
      this.selectedFile = null
      this.getPdfViewerParameters()
    },
    getPdfViewerParameters () {
      this.documentHeight = window.innerHeight - document.getElementsByClassName('site-header')?.[0]?.clientHeight -
          document.getElementsByClassName('page-header')?.[0]?.clientHeight -
          document.getElementsByClassName('tabs-component')?.[0]?.clientHeight - 14

      this.documentWidth = window.innerWidth - document.getElementsByClassName('site-sidebar')?.[0]?.clientWidth
    },
    printKeyTicket () {
      const routeData = this.$router.resolve(
          {
            name: 'QRCode',
            query: {
              cardNumber: this.card.card_number,
              customer: this.card.customer.name,
              insurer: this.card.insurance.insurer_name,
              buildDate: this.card.vehicle.dom,
              make: this.card.vehicle.make,
              model: this.card.vehicle.model,
              rego: this.card.vehicle.rego_number,
            }
          }
      )
          //empty line
          (async (url) => {
            const popup = window.open('', '_blank')
            if (popup) {
              popup.location.href = url
            }
          })(routeData.href)
    },
    selectedSchemePart (v) {
      this.selectedSchemeParts = v
    },
    capitalizeFirstLetter(v) {
      if (!v) {
        return ''
      }
      return v.charAt(0).toUpperCase() + v.slice(1);
    },
    checkIsAttendYes(v, isSave = true) {
      if (v) {
        this.isAttendedBookingYes = v
        this.isAttendedBookingNo = false
        this.plannerBoard.onSite.isAttendedBooking = v
      } else {
        this.isAttendedBookingYes = v
        this.isAttendedBookingNo = v
        this.plannerBoard.onSite.isAttendedBooking = null
      }
      this.computedOnSiteSelect++;
      if (isSave) {
        this.saveOnsiteData(false)
      }

    },
    checkIsAttendNo(v, isSave = true) {
      if (v) {
        this.isAttendedBookingYes = false
        this.isAttendedBookingNo = v
        this.plannerBoard.onSite.isAttendedBooking = false
      } else {
        this.isAttendedBookingYes = v
        this.isAttendedBookingNo = v
        this.plannerBoard.onSite.isAttendedBooking = null
      }
      this.computedOnSiteSelect++;
      if (isSave) {
        this.saveOnsiteData(false)
      }

    },
    goToEstimateBooking() {
      this.$router.push({
        name: 'planner',
        params: {
          eventId: this.plannerBoard.onSite.id,
          eventDate: this.plannerBoard.onSite.onsiteEstimateBookingDate,
        }
      })
    },
    saveOnSiteEvent(data) {
      this.autoSaveMessage = 'Saving...'
      Axios.post('/fe/planner-board/add', data)
          .then((response) => {
          })
          .finally(() => {
            this.autoSaveMessage = 'Saved'
          });
    },
    saveOnsiteData(data) {
      if (!this.plannerBoard.onSite.id && this.plannerBoard.onSite.onsiteEstimateBookingDate) {
        this.saveOnSiteEvent(
            {
              "cardId": _.toString(this.card.card_id),
              "dateStart": this.plannerBoard.onSite.onsiteEstimateBookingDate,
              "timeStart": '12:00:00',
              "dateEnd": this.plannerBoard.onSite.onsiteEstimateBookingDate,
              "timeEnd": '12:15:00',
              "title": this.card.customer.name  ? this.card.card_number + ' - ' + this.card.customer.name : this.card.card_number,
              type: 'on-site'
            }
        )
        return
      }
      console.log(data, 'data')
      let update = {}
      let isRebooking = !!(data.prev && this.plannerBoard.onSite.onsiteEstimateBookingDate
          && data.prev !== this.plannerBoard.onSite.onsiteEstimateBookingDate && this.onSiteReason &&  this.onSiteAttempt)

      if (this.plannerBoard.onSite.isRebooked) {
        isRebooking = true
      } else if (isRebooking) {
        this.onSiteAttempt = null;
        this.plannerBoard.onSite.isAttendedBooking = null
        this.onSiteReason = null
        this.isAttendedBookingYes = null;
        this.isAttendedBookingNo = null;
        this.onSiteFollowUpAction = 'default';
      }
      update.plannerBoard = {}
      update.plannerBoard.onSite = {
        attempt: this.onSiteAttempt,
        followUpAction: this.onSiteFollowUpAction,
        isAttendedBooking: this.plannerBoard.onSite.isAttendedBooking,
        onsiteEstimateBookingDate: this.plannerBoard.onSite.onsiteEstimateBookingDate,
        reason: this.onSiteReason,
      }
      if (!this.plannerBoard.onSite.isRebooked && isRebooking) {
        update.plannerBoard.onSite.rebooked = isRebooking
      }
      this.plannerBoard.onSite.isRebooked = isRebooking

      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    onClickNumber (v) {
      window.open('tel:' + v)
    },
    assignToUser (elem) {
      let update = {}
      update.assignedTo = { id: elem.value }
      this.assignedToText = elem.label
      this.assignedToUser = elem.label
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    redirectToEstimateEdit (itm) {
      this.$router.push('/estimates/view/' + itm.value)
    },
    onEnter () {
      if (!_.isEmpty(this.additionalMenu) && !_.isEmpty(this.searchFilter)) {
        if (this.additionalMenu.length == 1) {
          this.redirectToEstimateEdit(this.additionalMenu[0])
        } else {
          this.$store.commit('setEstimateFilter', this.searchFilter)
          this.$router.push('/estimates')
        }
      }
    },
    getImagesForCamera () {
      if (this.images) {
        let images = _.orderBy(this.images, ['id'], ['desc'])
        images = _.orderBy(images, [(itm) => Number(itm.sort)], ['asc'])
        return _.map(images, (i) => {return i.id})
      }
      return []
    },
    isArrowActive: function (evt, el) {
      if (evt.srcElement.scrollLeft > 1) {
        this.tabsArrowLeftVisible = true
      }
      if (evt.srcElement.scrollLeft == 0) {
        this.tabsArrowLeftVisible = false
      }
      if (evt.srcElement.scrollLeft + evt.srcElement.offsetWidth != evt.srcElement.scrollWidth) {
        this.tabsArrowRigthVisible = true
      }
      if (evt.srcElement.scrollLeft + evt.srcElement.offsetWidth == evt.srcElement.scrollWidth) {
        this.tabsArrowRigthVisible = false
      }
    },
    setRatesAfterInsuranceChanged (v) {
      let rates = v.rates
      this.estimateRates.estimate_methodology = _.toLower(rates.estimate_methodology)
      this.estimateRates.rr = rates.estimate_rates_rr || 0
      this.estimateRates.mechanical = rates.estimate_rates_mechanical || 0
      this.estimateRates.repair = rates.estimate_rates_repair || 0
      if (_.toLower(rates.estimate_methodology) === 'custom') {
        if (this.estimateRates.paint_material == 'not_set' || !(this.estimateRates.paint_material)) {
          this.estimateRates.paint = 0
        } else {
          this.estimateRates.paint = v.custom_paint_times[this.estimateRates.paint_material.toLowerCase()] || 0
        }
      } else {
        this.estimateRates.paint = rates.estimate_rates_paint || 0
      }
      this.estimateRates.rs_rr_percentage = rates.estimate_rates_rs_rr_percentage || this.defaultValues.rates.rs.default_rates_rs_rr_percentage
      this.estimateRates.rs_paint_percentage = rates.estimate_rates_rs_paint_percentage || this.defaultValues.rates.rs.default_rates_rs_paint_percentage
      this.backdoor++
      // this.autoUpdateRates()
    },
    moveToCategory (v) {
      let array = _.concat(v.ids, _.filter(this.images, (im) => {return im.category == v.category && !_.includes(v.ids, im.id)}))
      let images = _.cloneDeep(this.images)
      _.forEach(images, (img) => {
        if (_.includes(v?.ids, img.id)) {
          img.category = v.category
        }
      })
      _.forEach(array, (itm, index) => {
        if (itm.id) {
          let image = _.find(images, (i) => {
            return Number(i.id) == Number(itm.id)
          })
          if (image) {
            image.sort = index
          }
        } else if (itm) {
          let image = _.find(images, (i) => {
            return Number(i.id) == Number(itm)
          })
          if (image) {
            image.sort = index
          }
        }
      })
      this.$nextTick(() => {
        this.$set(this, 'images', images)
      })

      let update = {
        imageCategories: [],
      }

      _.forEach(v.ids, (id) => {
        update.imageCategories.push({
          file_id: id,
          category: v.category
        })
      })

      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    showOrHideGallery (v) {
      this.isShowGallery = v
      if (!this.isShowGallery && this.prevTab) {
        this.currentTab = _.cloneDeep(this.prevTab)
        this.prevTab = null
      }
    },
    onClickCompressBtn (id, v) {
      this.$set(this.isShowNotCompressed, id, v)
    },
    loadCategories () {
      Axios.get('/fe/planner-board/groups')
          .then(response => {
            if (response.data.groups && response.data._status) {
              this.categories = response.data.groups
            }
          })
          .finally(() => {})
    },
    onlyNumber (event) {
      let keyCode = (event.keyCode ? event.keyCode : event.which)
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 32 && keyCode !== 45 && keyCode !== 43 && keyCode !== 40 && keyCode !== 41) {
        event.preventDefault()
      }
    },
    autoUpdateBookingDate: function () {
      let update = {}
      update.booking_date = this.booking_date
      this.queueSchedulingUpdate(update)
    },
    queueSchedulingUpdate (v) {
      if (!this.isAutoSave) {
        return
      }
      let uid = Math.random().toString(36).substr(2, 9) + Date.now()
      let update = {}
      update[uid] = v
      this.schedulingUpdate = Object.assign({}, this.schedulingUpdate, update)
      this.beforeDebouncedAutoSaveScheduling()
    },
    beforeDebouncedAutoSaveScheduling () {
      if (!this.isAutoSave) {
        return
      }
      if (this.debouncedAutoSaveScheduling) {
        this.debouncedAutoSaveScheduling()
      } else {
        this.flushSchedulingUpdate()
      }
    },
    flushSchedulingUpdate () {
      const data = _.cloneDeep(this.schedulingUpdate)
      this.schedulingUpdate = {}
      if (!_.isEmpty(data)) {
        this.saveCardData(data)
      }
    },
    setBoardPresence (label, present) {
      const idx = this.currentBoards.indexOf(label)
      if (present) {
        if (idx === -1) this.currentBoards.push(label)
      } else {
        if (idx !== -1) this.currentBoards.splice(idx, 1)
      }
    },
    syncBoardsSelection () {
      const next = []
      if (this.boardIn && this.boardIn.updatedDate && this.boardIn.id) {
        next.push('Vehicle In Board')
      }
      if (this.boardDeparture && (this.boardDeparture.updatedDate || this.boardDeparture.departureDate) && this.boardDeparture.id) {
        next.push('Departure Board')
      }
      if (this.plannerBoard && this.plannerBoard?.vehicle?.id) {
        next.push('Bookings Board')
      }
      const currSorted = _.sortBy(this.currentBoards)
      const nextSorted = _.sortBy(next)
      if (!_.isEqual(currSorted, nextSorted)) {
        this.currentBoards.splice(0, this.currentBoards.length)
        next.forEach(b => this.currentBoards.push(b))
      }
    },
    autoUpdateArrivedDate: function () {
      if (this.isArrivedDateFromUpdater) {
        this.isArrivedDateFromUpdater = false
        return
      }
      let update = {}
      update.arrivedDate = this.arrivedDate
      this.queueSchedulingUpdate(update)

      if (_.isEmpty(this.arrivedDate)) {
        if (this.boardIn && this.boardIn.updatedDate && this.boardIn.id) {
          this.removeVehicle(this.boardIn.id)
        }
        if (this.boardDeparture && (this.boardDeparture.updatedDate || this.boardDeparture.departureDate) && this.boardDeparture.id) {
          this.removeVehicle(this.boardDeparture.id)
        }
        this.setBoardPresence('Vehicle In Board', false)
        this.setBoardPresence('Departure Board', false)
      } else {
        if (!(this.boardIn && this.boardIn.updatedDate && this.boardIn.id)) {
          this.addedToVehicleInBoard()
        }
        if (!(this.boardDeparture && (this.boardDeparture.updatedDate || this.boardDeparture.departureDate) && this.boardDeparture.id)) {
          this.addToDepartureBoard()
        }
        this.setBoardPresence('Vehicle In Board', true)
        this.setBoardPresence('Departure Board', true)
      }
    },
    autoUpdatePickUpDate: function () {
      if (this.isPickUpDateFromUpdater) {
        this.isPickUpDateFromUpdater = false
        return
      }
      let update = {}
      update.pickUpDate = this.pickUpDate
      this.queueSchedulingUpdate(update)

      if (!_.isEmpty(this.pickUpDate)) {
        if (this.boardIn && this.boardIn.updatedDate && this.boardIn.id) {
          this.removeVehicle(this.boardIn.id)
        }
        if (this.boardDeparture && (this.boardDeparture.updatedDate || this.boardDeparture.departureDate) && this.boardDeparture.id) {
          this.removeVehicle(this.boardDeparture.id)
        }
        this.setBoardPresence('Vehicle In Board', false)
        this.setBoardPresence('Departure Board', false)
      } else if (!_.isEmpty(this.arrivedDate)) {
        if (!(this.boardIn && this.boardIn.updatedDate && this.boardIn.id)) {
          this.addedToVehicleInBoard()
        }
        if (!(this.boardDeparture && (this.boardDeparture.updatedDate || this.boardDeparture.departureDate) && this.boardDeparture.id)) {
          this.addToDepartureBoard()
        }
        this.setBoardPresence('Vehicle In Board', true)
        this.setBoardPresence('Departure Board', true)
      }
    },
    autoUpdateCompletionDate: function () {
      let update = {}
      update.completion_date = this.completion_date
      this.queueSchedulingUpdate(update)
    },
    autoUpdatePickUpTime (val, clear) {
      if (clear && val.displayTime == '' || !clear) {
        let update = {}
        update.pickUpTime = this.pickUpTime
        this.queueSchedulingUpdate(update)
      }
    },
    addCardToBoardFromMultiselect (opt) {
      if (opt === 'Vehicle In Board') {
        this.addedToVehicleInBoard()
      } else if (opt === 'Departure Board') {
        this.addToDepartureBoard()
      } else if (opt === 'Bookings Board') {
        this.addToBookingBoard()
      }
    },
    removeCardToBoardFromMultiselect (opt) {
      if (opt === 'Vehicle In Board') {
        if (this.boardIn?.id) this.removeVehicle(this.boardIn.id, 'Vehicle In Board')
        else this.setBoardPresence('Vehicle In Board', false)
      } else if (opt === 'Departure Board') {
        if (this.boardDeparture?.id) this.removeVehicle(this.boardDeparture.id, 'Departure Board')
        else this.setBoardPresence('Departure Board', false)
      } else if (opt === 'Bookings Board') {
        this.removeFromBookingBoard()
        this.setBoardPresence('Bookings Board', false)
      }
    },
    removeVehicle (id, label = null) {
      NProgress.start()
      Axios({
        method: 'post',
        responseType: 'json',
        url: `/fe/board/remove`,
        validateStatus: function (status) {
          return status < 500
        },
        data: {
          boardId: id,
        },
      }).then(response => {
        if (response.status === 200 && response.data._status) {
          toastr.success('Removed successfully')
          if (label) this.setBoardPresence(label, false)
          if (this.boardIn && Number(this.boardIn.id) === Number(id)) {
            this.boardIn.id = null
            this.boardIn.updatedDate = null
          }
          if (this.boardDeparture && Number(this.boardDeparture.id) === Number(id)) {
            this.boardDeparture.id = null
            this.boardDeparture.updatedDate = null
            if (this.boardDeparture.departureDate) this.boardDeparture.departureDate = null
          }
          // this.loadEstimate(this.$route.params.estimate_id, false, false, false)
        } else {
          toastr.error(response.data.msg)
        }
      })
          .catch(() => {})
          .finally(() => {
            NProgress.done()
          })
    },
    addedToVehicleInBoard () {
      NProgress.start()
      Axios({
        method: 'post',
        responseType: 'json',
        url: `/fe/board/in/add-card`,
        validateStatus: function (status) {
          return status < 500
        },
        data: {
          cardId: this.card.card_id,
        },
      }).then(response => {
        if (response.status === 200 && response.data._status) {
          toastr.success('File ' + this.card.card_number + ' added successfully to the Vehicle In Board')
          this.setBoardPresence('Vehicle In Board', true)
        } else {
          toastr.error(response.data.msg)
        }
      })
          .catch(error => {
            toastr.error(error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    addToDepartureBoard () {
      NProgress.start()
      Axios({
        method: 'post',
        responseType: 'json',
        url: `/fe/board/departure/add-card`,
        validateStatus: function (status) {
          return status < 500
        },
        data: {
          cardId: this.card.card_id,
        },
      }).then(response => {
        if (response.status === 200 && response.data._status) {
          toastr.success('File ' + this.card.card_number + ' added successfully to the Departure Board')
          this.setBoardPresence('Departure Board', true)
        } else {
          toastr.error(response.data.msg)
        }
      })
          .catch(error => {
            toastr.error(error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    addToBookingBoard () {
      if (!this.booking_date || !this.completion_date) {
        toastr.error('\'Date Booked (Start)\' and \'Date Completed\' must not be empty')
        setTimeout(() => {
          if (this.currentBoards.includes('Bookings Board')) {
            let index = _.findIndex(this.currentBoards, (itm) => {
              return itm === 'Bookings Board'
            })
            if (index !== -1) {
              this.currentBoards.splice(index, 1)
            }
          }
        }, 300)
        return
      }
      NProgress.start()
      let [dayS, monthS, yearS] = this.booking_date.split('/')
      let [dayE, monthE, yearE] = this.completion_date.split('/')
      let title = ''
      if (this.card.card_number) {
        title += this.card.card_number
        if (this.card.vehicle.rego_number || this.card.vehicle.make || this.card.vehicle.model) {
          title += ' - '
        }
      }
      if (this.card.vehicle.rego_number) {
        title += this.card.vehicle.rego_number + ' '
      }
      if (this.card.vehicle.make) {
        title += this.card.vehicle.make + ' '
      }
      if (this.card.vehicle.model) {
        title += this.card.vehicle.model
      }
      Axios.post(
          '/fe/planner-board/add',
          {
            type: 'vehicle',
            cardId: this.card.card_id,
            dateStart: yearS + '-' + monthS + '-' + dayS,
            timeStart: '00:00:00',
            dateEnd: yearE + '-' + monthE + '-' + dayE,
            timeEnd: '00:15:00',
            title: title,
            note: '',
            color: this.colors[this.getRandomNumber(0, 13)],
          }
      ).then(() => {
        toastr.success('Added successfully')
        // this.loadEstimate(this.$route.params.estimate_id, false, false, false)
      })
          .finally(() => {
            NProgress.done()
          })
    },
    getRandomNumber (min, max) {
      let rand = min - 0.5 + Math.random() * (max - min + 1)
      return Math.round(rand)
    },
    removeFromBookingBoard () {
      if (!(this.plannerBoard?.vehicle?.id)) {
        return
      }
      NProgress.start()
      Axios.post(
          '/fe/planner-board/delete',
          {
            id: this.plannerBoard.vehicle.id,
          }
      ).then(() => {
        toastr.success('Removed successfully')
        this.plannerBoardGroupId = null
        this.setBoardPresence('Bookings Board', false)
        if (this.plannerBoard && this.plannerBoard.vehicle) {
          this.plannerBoard.vehicle.id = null
        }
        // this.loadEstimate(this.$route.params.estimate_id, false, false, false)
      })
          .finally(() => {
            NProgress.done()
          })
    },
    changedBookingCategory () {
      Axios.put(
          '/fe/planner-board',
          {
            id: this.plannerBoard?.vehicle?.id,
            groupId: this.plannerBoard?.vehicle?.groupId,
            color: this.plannerBoardGroupId?.color,
            type: 'vehicle'
          }
      )
    },
    onRepairCategoryChange (v) {
      this.productionTime.category = v
      this.callApproximateDaysComputed++
      this.autoUpdateProductionTime()
    },
    onProductionCheckboxesChange () {
      this.callApproximateDaysComputed++
      this.autoUpdateProductionTime()
    },
    autoUpdateProductionTime () {
      let update = {}
      update.productionTime = {}
      update.productionTime.category = this.productionTime.category
      update.productionTime.isCheckWeld = this.productionTime.isCheckWeld
      update.productionTime.weldQty = this.productionTime.weldQty
      update.productionTime.isCheckMechanical = this.productionTime.isCheckMechanical
      update.productionTime.isCheckHail = this.productionTime.isCheckHail
      update.productionTime.isCheckElectrical = this.productionTime.isCheckElectrical
      update.productionTime.isCheckPpf = this.productionTime.isCheckPpf
      update.productionTime.isCheckAccessories = this.productionTime.isCheckAccessories
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    getGroup (v) {
      let r = _.find(this.properties?.production?.definitions?.categories, (c) => {
        return c.id == v
      })
      if (r) {
        let color = _.find(this.categories, (g) => {
          return Number(g.id) == Number(r.colorId)
        })
        return {
          name: r.name,
          color: color ? color.color : '',
        }
      }
      return {
        color: '',
        name: '',
      }
    },
    getTotal (card) {
      return numeral(r).format('0,0.00')
    },
    totalHrsFormat (v) {
      return numeral(v).format('0,0.00')
    },
    calculatedTotalHrs (itemList, card, isNumber = false) {
      let a = 0
      _.forEach(itemList.parts[card], (p) => {
        if ((_.isString(p['adj_hrs']) || _.isNumber(p['adj_hrs'])) && !_.isNaN(p['adj_hrs'])) {
          a += Number(p['adj_hrs'])
        } else if ((_.isString(p['hrs']) || _.isNumber(p['hrs'])) && !_.isNaN(p['hrs'])) {
          a += Number(p['hrs'])
        }
      })

      if (isNumber) {
        return Number(numeral(a).format('0,0.00'))
      }
      return numeral(a).format('0,0.00')
    },
    calculatedTotalAll (itemList) {
      let a = 0
      let cards = ['RR', 'Repair', 'Paint', 'Materials', 'Sublet', 'Other', 'PDR', 'Part']
      _.forEach(cards, (c) => {
        a += this.calculatedAdjTotal(itemList, c)
      })
      return a
    },
    calculatedAdjTotal (itemList, card) {
      return this.getAdjTotalForItemList(itemList, card)
    },
    getAdjTotalForItemList (itemList, card) {
      let a = 0
      for (let i = 0; i < itemList.parts[card].length; i++) {
        let item = itemList.parts[card][i]

        if (item.adj_approve_status == 'reported' || item?.adj_approve_status == 'denied') {
          continue
        }
        switch (card) {
          case 'Paint':
          case 'Repair':
          case 'RR':
            if (item.isSupplementDeletion) {
              break
            }
            if (this.isEstimateMethodologyDollars) {
              a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
              break
            }
            if (item.adj_rate !== null && item.adj_rate !== undefined && item.adj_rate !== '') {
              a += this.pT(item.adj_rate)
              break
            }
            if (item.adj_hrs != null) {
              a += this.pT(this.pT(item.adj_hrs) * this.pT(item.rate))
              break
            }
            if (item.total_manual != null) {
              a += this.pT(item.total_manual)
              break
            }
            a += this.pT(item.total)
            break
          case 'Part':
            if (item.isSupplementDeletion) {
              break
            }
            if (item.adj_rate != null) {
              a += this.pT(item.adj_rate)
            } else {
              a += this.pT(item.total)
            }
            break
          case 'Material':
          case 'Materials':
            let isUseCalcValue = false
            if ((this.properties.isFromEio || this.properties.isFromIag || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && item.type == 'calculation') {
              let r = 0
              if (item.adj_rate && item.original_total && item.adj_rate == item.original_total) {
                r = 0
              } else if (item.adj_rate) {
                r = item.adj_rate
              } else if (item.original_total) {
                r = item.original_total
              }
              if (r) {
                isUseCalcValue = true
                a += this.pT(r)
              }
            }

            if (!isUseCalcValue) {
              let adj_rate = item.adj_rate
              if (item.subtype !== 'EnvironmentLevy') {
                let hrs = null
                if (item.type === 'manual') {
                  hrs = item.hrs
                } else {
                  if (item.original_hrs && item.original_hrs !== null) {
                    hrs = item.original_hrs
                  } else if (item.rs_hrs && item.rs_hrs !== null) {
                    hrs = item.rs_hrs
                  } else {
                    hrs = item.hrs
                  }
                }

                let rate = item.material_rate

                if (item.adj_hrs == null) {
                  adj_rate = null
                } else if (item.adj_hrs == 0) {
                  adj_rate = 0
                } else if (hrs != '' && hrs != null && hrs > 0) {
                  adj_rate = accounting.toFixed(rate * item.adj_hrs, 2)
                } else {
                  adj_rate = 0
                }
              }
              if (item.subtype == 'PaintSetupTime' && item.adj_hrs == null && item.adj_rate !== null) {
                adj_rate = item.adj_rate
              }
              if (adj_rate !== null && adj_rate !== undefined && adj_rate !== '' && !isNaN(parseFloat(adj_rate))) {
                a += this.pT(adj_rate)
              } else if (item.original_total !== null && item.original_total !== undefined && item.original_total !== '' && !isNaN(parseFloat(item.original_total))) {
                a += this.pT(item.original_total)
              } else if (item.rs_rate !== null && item.rs_rate !== undefined && item.rs_rate !== '' && !isNaN(parseFloat(item.rs_rate))) {
                a += this.pT(item.rs_rate)
              } else if (!isNaN(parseFloat(item.rate))) {
                a += this.pT(item.rate)
              } else {
              }
            }
            break
          case 'PDR':
            if (item.isSupplementDeletion) {
              break
            }
            if (item.adj_price !== null && item.adj_price !== undefined && item.adj_price !== '') {
              a += this.pT(item.adj_price)
            } else {
              a += this.pT(this.pT(item.price) * this.pT(item.qty))
            }
            break
          case 'Other':
            if (item.isSupplementDeletion) {
              break
            }
            a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
            break
          case 'Sublet':
            if (item.isSupplementDeletion) {
              break
            }
            a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.total)
            break
        }
      }

      return a
    },
    selectImageGallery (v) {
      if (!this.prevTab) {
        this.prevTab = _.cloneDeep(this.currentTab)
      }
      this.currentTab = 'images'
      this.isShowGallery = true
      this.$nextTick(() => {
        this.$refs.imageLightbox.setGallery(v)
      })
    },
    pinImageOnBigImageView () {
      let body = document.querySelector('body')

      if (!_.includes(body.classList, 'compact-sidebar')) {
        this.pinImage = false
      } else {
        this.pinImage = true
      }

      body.classList.toggle('compact-sidebar')
    },
    getActivePcs (pcs) {
      return _.filter(pcs, (pc) => {
        return pc.active
      })
    },
    selectPc (pc) {
      this.isShowScanner = false
      this.selectedPcName = pc.pc_name
      this.selectedPcId = pc.id
      if (this.intervalUpdateScannerFiles) {
        clearInterval(this.intervalUpdateScannerFiles)
      }

      let lastTimestamp = this.$store.getters['updater/lastTimestamp']
      this.getFilesScanner({
        pcId: pc.id,
        time: lastTimestamp
      })
      this.intervalUpdateScannerFiles = setInterval(() => {
        this.getFilesScanner({
          pcId: pc.id,
          time: lastTimestamp
        })
      }, 5000)
    },
    getFilesScanner (data) {
      Axios.post('/fe/scanner-service/get-files-list', data).then((r) => {
        if (r.data._status && !_.isEmpty(r.data.files)) {
          _.forEach(r.data.files, (f) => {
            if (f.status == 'found') {
              this.uploadScannerFile({
                fileId: f.id,
                estimateId: this.estimate.id,
              })
            }
          })
        }
      })
    },
    uploadScannerFile (data) {
      Axios.post('/fe/scanner-service/request-file-upload', data).then((r) => {
        if (r.data._status) {

        }
      })
    },
    addReload () {
      console.log(isMobile)
    },
    isShowHrsMaterialsPreview (line) {
      let r = null
      if (line.adj_rate && line.original_total && line.adj_rate == line.original_total) {
        r = null
      } else if (line.adj_rate) {
        r = line.adj_rate
      } else if (line.original_total) {
        r = line.original_total
      }
      return !(line.isCalculation && (this.properties.isFromEio || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && r)
    },
    changeSubParts (v) {
      console.log('changeSubParts', v)
      this.timesForItemPart[v.type][v.mainCategory] = v.data
    },
    setTitle (isNeedToClear = false) {
      let text = !isNeedToClear && (!_.isEmpty(this.estimate_number) || !_.isEmpty(this.card.vehicle.rego_number) || !_.isEmpty(this.card.vehicle.model)) ? '' : appConfig.appName
      if (!isNeedToClear && !_.isEmpty(this.estimate_number)) {
        text += this.estimate_number
      }
      if (!isNeedToClear && !_.isEmpty(this.card.vehicle.rego_number)) {
        if (!_.isEmpty(this.estimate_number)) {
          text += ' - '
        }
        text += this.card.vehicle.rego_number
      }
      if (!isNeedToClear && !_.isEmpty(this.card.vehicle.model)) {
        if (!_.isEmpty(this.card.vehicle.rego_number) || !_.isEmpty(this.estimate_number)) {
          text += ' - '
        }
        text += this.card.vehicle.model
      }
      let title = document.getElementsByTagName('title')
      if (title?.[0]) {
        title[0].innerText = text
      }
    },
    loadItemListAfterAuthorisation () {
      let vm = this
      this.loadEstimate(this.estimate.id, data => {
        this.isAutoSave = false
        this.estimateRates.rr = data.rates.rr
        this.estimateRates.repair = data.rates.repair
        this.estimateRates.paint = data.rates.paint
        this.isAutoSave = true
      }, false)
      this.loadItemsList(this.estimate.id, function (items) {
        let item = _.find(items, (i) => {
          return Number(i.id) == Number(vm.currentItemListId)
        })
        if (item) {
          let currentItemList = _.find(vm.itemsList, (list) => {
            return Number(list.id) === Number(item.id)
          })
          if (currentItemList) {
            currentItemList.isAuthorised = item.isAuthorised
            currentItemList.authorityDate = item.authorityDate
          }
          vm.updateItemList(item.parts, item.id,)
        }
      })
    },
    updateItemList: function (parts, estimateId = false) {
      _.forEach(['RR', 'Repair', 'Paint', 'Part', 'Sublet', 'Other', 'PDR',], (c) => {
        this.updateCard(c, parts[c], estimateId)
      })
      this.updateCalculation({
        Materials: parts.Materials,
        MaterialsCalc: parts.MaterialsCalc
      }, estimateId)
    },
    updateCard (c, data, estimateId) {
      if (!estimateId) {
        estimateId = this.estimate.id
      }
      let estimate = this.getItemList(estimateId)
      this.updateRRRepairPaint(c, data, estimate)
    },
    showWarningModalForAuthoriseEstimate () {
      this.$refs.warningAuthorisationModal.hide()
      this.hideWarningAuthorisationModal = true
      this.authoriseEstimate(true)
    },
    addToWebtrim () {
      NProgress.start()
      Axios.post('/fe/estimate/send-to-webtrim', { cardId: this.card.card_id, })
          .then(response => {
            if (response.data._status) {
              toastr.success('Estimate ' + this.estimate_number + ' added successfully to the Webtrim')
            }
          })
          .catch(error => {
            NProgress.done()
            toastr.error(error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    isAIDamageStatusCompleted (aiRes) {
      if (!aiRes) return false
      const status = aiRes?.status
      const damage = aiRes?.damage
      if (damage && status == 'completed') {
        return true
      }
      return false
    },
    isAIDamageAvailableByCount () {
      const id = this.$route.params.estimate_id
      const estimate = this.itemsList.find(item => item.id == id)
      const aiRes = estimate?.AI
      if (!aiRes) return true
      const isDALimitReached = aiRes?.isDALimitReached
      return !(isDALimitReached && isDALimitReached === true)
    },
    runDamageAssmnt () {
      if (!this.isViewRunDamageAssmnt) return
      const id = this.$route.params.estimate_id
      const estimate = this.itemsList.find(item => item.id == id)
      const aiRes = estimate?.AI
      if (this.isAIDamageStatusCompleted(aiRes)) {
        this.$set(aiRes, 'damage', null)
      }
      if (!aiRes) {
        this.$set(estimate, 'AI', {})
      }
      this.forcedSelectCard = null
      this.tabEstimateChange('itemList' + id, id)
      this.$nextTick(() => {
        this.forcedSelectCard = 'Assessment'
      })
    },
    authoriseEstimate (v) {
      if (v && (this.properties.isFromIag || this.properties.isFromClaimlinq || this.properties.isFromEio || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && !this.hideWarningAuthorisationModal) {
        this.$refs.warningAuthorisationModal.show()
        return
      }
      let id = this.currentItemListId
      if (!this.isItemListTab) {
        id = this.itemsList[0]?.id
        this.tabEstimateChange('itemList' + id, id)
      }
      this.$set(this.isAuthorisePage, id, v)
      // this.isAuthorisePage[this.currentItemListId] = v
    },
    pT (value) {
      return parseFloat(accounting.toFixed(parseFloat(value), 2))
    },
    getImages (v) {
      let r = []
      _.forEach(_.cloneDeep(v), (itm) => {
        if (!_.includes(itm.src, 'at=')) {
          itm.src += '/?at=' + localStorage.getItem('token')
        }
        if (!_.includes(itm.previewW220, 'at=')) {
          itm.previewW220 += '/?at=' + localStorage.getItem('token')
        }
        r.push(itm)
      })
      return r
    },
    checkUpdate () {
      Axios.get(`/fe/updater/estimate/${this.$route.params.estimate_id}/${this.lastTimestampImages}`)
          .then((response) => {
            this.lastTimestampImages = response.data._timestamp
            if (response.data._status && response.data._update && (response.data._update.orders)) {
              this.ordersUpdater++
            }
            if (response.data._status && response.data._update && (response.data._update.manualOrders)) {
              this.manualOrdersUpdater++
            }
            if (response.data._status && response.data._update && (response.data._update.images > 0 || response.data._update.deletedImages > 0)) {
              this.loadEstimate(this.$route.params.estimate_id, data => {
                this.images = this.getImages(data.images)
              }, false, false)
            }
            if (response.data._status && response.data._update?.activity > 0) {
              this.loadActivity()
            }
            if (response.data._status && (response.data._update?.files > 0 || response.data._update?.deletedFiles > 0)) {
              this.loadEstimate(this.$route.params.estimate_id, data => {
                this.files = this.getFiles(data.files)
              }, false)
            }
            if (response.data._status && response.data._update && response.data._update.parts > 0) {
              let vm = this
              this.loadItemsList(this.estimate.id, function (items) {
                _.forEach(items, item => {
                  let currentItemList = _.find(vm.itemsList, (list) => {
                    return Number(list.id) === Number(item.id)
                  })
                  if (currentItemList && currentItemList.parts) {
                    for (let partType in currentItemList.parts) {
                      _.forEach(currentItemList.parts[partType], (part, index) => {
                        let newPart = _.find(item.parts[partType], nPart => {
                          return Number(nPart.id) === Number(part.id)
                        })
                        if (newPart && !_.isEqual(part.comments, newPart.comments)) {
                          let comments = newPart.comments
                          if (vm.isAuthorisePage[currentItemList.id] && comments) {
                            comments.manualComment = part.comments.manualComment
                            comments.manualCommentAuthor = part.comments.manualCommentAuthor
                            comments.adjComment = part.comments.adjComment
                          }
                          vm.$set(currentItemList.parts[partType][index], 'comments', comments)
                        }
                        if (newPart && !_.isEqual(part.adj_changed_rate, newPart.adj_changed_rate)) {
                          vm.$set(currentItemList.parts[partType][index], 'adj_changed_rate', newPart.adj_changed_rate)
                        }
                      })
                    }
                  }
                  if (currentItemList && !_.isEqual(currentItemList.rates, item.rates)) {
                    vm.$set(currentItemList, 'rates', item.rates)
                    // let adjRates = currentItemList.adjRates;
                    // let rates = currentItemList.rates;
                    // let result = item.adjRates;
                    // if (adjRates.rr !== rates.rr) {
                    //   result.rr = adjRates.rr;
                    // }
                    // if (adjRates.repair !== rates.repair) {
                    //   result.repair = adjRates.repair;
                    // }
                    // if (adjRates.paint !== rates.paint) {
                    //   result.paint = adjRates.paint;
                    // }
                    // vm.$set(currentItemList, 'adjRates', result)
                  }
                  if (currentItemList && !_.isEqual(currentItemList.adjRates, item.adjRates)) {
                    vm.$set(currentItemList, 'adjRates', item.adjRates)
                  }
                  if (currentItemList && !_.isEqual(currentItemList.partssearch) && item.partssearch) {
                    vm.$set(currentItemList, 'partssearch', item.partssearch)
                  }
                })
              }, false)
            }
            if (response.data._status && response.data._update && response.data._update.estimateNeedUpdate && response.data._update.partssearch > 0) {
              let vm = this
              this.loadItemsList(this.estimate.id, function (items) {
                _.forEach(items, item => {
                  let currentItemList = _.find(vm.itemsList, (list) => {
                    return Number(list.id) === Number(item.id)
                  })
                  if (currentItemList && (item?.partssearch?.listPricesReceived || item?.partssearch?.listPricesReceived)) {
                    vm.updatePart(item.parts.Part, currentItemList.id)
                  }
                })
              }, false)
            }

            if (response.data._status && response.data._update && (response.data._update.estimate || response.data._update.card)) {
              this.loadEstimate(this.$route.params.estimate_id, data => {
                this.card.insurance_repair = data.card.insurance_repair
                this.card.isTotalLoss = data.card.isTotalLoss
                this.card.insurance.insurance_claim_type = data.card.insurance.insurance_claim_type
                this.card.customer.name = data.card.customer.name
                this.card.customer.customer_type = data.card.customer.customer_type
                this.card.card_status = data.card.card_status
                this.plannerBoard = data.plannerBoard
                if (data.plannerBoard.onSite) {
                  this.onSiteReason = data.plannerBoard.onSite.reason
                  this.onSiteAttempt = data.plannerBoard.onSite.attempt
                  this.plannerBoard = data.plannerBoard
                  if (this.plannerBoard.onSite.isAttendedBooking) {
                    this.checkIsAttendYes(true, false)
                  } else if (this.plannerBoard.onSite.isAttendedBooking === false) {
                    this.checkIsAttendNo(true, false)
                  } else {
                    this.isAttendedBookingYes = false
                    this.isAttendedBookingNo = false
                  }
                }
              }, false)
            }
          })
    },
    changedEmailAddress () {
      this.checkEmail2()
      this.autoUpdateContacts()
    },
    checkEmail () {
      if (this.card.contactEmail.includes('@')) {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        this.isCheckedEmail = re.test(this.card.contactEmail)
      } else {
        this.isCheckedEmail = true
      }
    },
    checkEmail2 () {
      if (this.card.contactEmail === '' || !(this.card.contactEmail && this.card.contactEmail.trim())) {
        return
      }
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.isCheckedEmail = re.test(this.card.contactEmail)
    },
    setDefaultValues (rates) {
      let type = 'custom'
      let estimateRatesCopy = _.cloneDeep(this.estimateRates)
      if (rates) {
        this.estimateRates.estimate_methodology = rates.estimate_methodology
        this.estimateRates.rr = rates.estimate_rates_rr ? rates.estimate_rates_rr : '0.00'
        this.estimateRates.mechanical = rates.estimate_rates_rr ? rates.estimate_rates_mechanical : '0.00'
        this.estimateRates.repair = rates.estimate_rates_repair ? rates.estimate_rates_repair : '0.00'
        if (!rates.estimate_rates_paint || !(this.estimateRates && this.estimateRates.paint_material)) {
          this.estimateRates.paint = '0.00'
        } else {
          this.estimateRates.paint = this.card.insurance.custom_paint_times[this.estimateRates.paint_material.toLowerCase()] || 0
        }
        this.estimateRates.rs_rr_percentage = rates.estimate_rates_rs_rr_percentage || _.cloneDeep(this.defaultValues.rates.rs.default_rates_rs_rr_percentage)
        this.estimateRates.rs_paint_percentage = rates.estimate_rates_rs_paint_percentage || _.cloneDeep(this.defaultValues.rates.rs.default_rates_rs_paint_percentage)
      } else {
        type = this.estimateRates.estimate_methodology.toLowerCase()
        this.estimateRates.rr = _.cloneDeep(this.defaultValues.rates[type].default_rates_rr)
        this.estimateRates.repair = _.cloneDeep(this.defaultValues.rates[type].default_rates_repair)
        this.estimateRates.paint = _.cloneDeep(this.defaultValues.rates[type].default_rates_paint)
        this.estimateRates.mechanical = _.cloneDeep(this.defaultValues.rates[type].default_rates_mechanical)
        if (type == 'ltar' || type == 'ntar' || type == 'zi') {
          this.estimateRates.paint_material = _.cloneDeep(this.defaultValues.rates[type].default_rates_paint_material)
        }
        if (type == 'dollars') {
          this.$set(this.estimateRates, 'paint_material', 'S1')
        }
        this.estimateRates.rs_rr_percentage = rates.estimate_rates_rs_rr_percentage || _.cloneDeep(this.defaultValues.rates.rs.default_rates_rs_rr_percentage)
        this.estimateRates.rs_paint_percentage = rates.estimate_rates_rs_paint_percentage || _.cloneDeep(this.defaultValues.rates.rs.default_rates_rs_paint_percentage)
      }

      let data = {
        estimateRates: {}
      }

      if (estimateRatesCopy.estimate_methodology !== this.estimateRates.estimate_methodology) {
        data.estimateRates.estimate_methodology = this.estimateRates.estimate_methodology
      }

      if (Number(estimateRatesCopy.rr) !== Number(this.estimateRates.rr) && type !== 'dollars') {
        data.estimateRates.rr = this.estimateRates.rr
      }

      if (Number(estimateRatesCopy.repair) !== Number(this.estimateRates.repair) && type !== 'dollars') {
        data.estimateRates.repair = this.estimateRates.repair
      }

      if (Number(estimateRatesCopy.paint) !== Number(this.estimateRates.paint) && type !== 'dollars') {
        data.estimateRates.paint = this.estimateRates.paint
      }

      if (Number(estimateRatesCopy.mechanical) !== Number(this.estimateRates.mechanical)) {
        data.estimateRates.mechanical = this.estimateRates.mechanical
      }

      if (Number(estimateRatesCopy.rs_rr_percentage) !== Number(this.estimateRates.rs_rr_percentage)) {
        data.estimateRates.rs_rr_percentage = this.estimateRates.rs_rr_percentage
      }

      if (estimateRatesCopy.paint_material !== this.estimateRates.paint_material) {
        data.estimateRates.paint_material = this.estimateRates.paint_material
      }

      if (estimateRatesCopy.rs_paint_percentage !== this.estimateRates.rs_paint_percentage) {
        data.estimateRates.rs_paint_percentage = this.estimateRates.rs_paint_percentage
      }

      if (!_.isEmpty(data.estimateRates)) {
        this.autoUpdateRates(data)
      }
      this.backdoor++
    },
    changedColour (col) {
      let colorOrig = _.cloneDeep(this.estimateRates.paint_material)
      this.backdoor
      this.estimateRates.paint_material = col
      if (colorOrig !== col) {
        this.autoUpdateRates({ estimateRates: { paint_material: this.estimateRates.paint_material } })
      }
      this.backdoor++
    },
    changedSubTabs (selectedTab) {
      this.selectedVehicleSubTab = selectedTab.tab.id
    },
    updateShowImportPdfParts (estimateId, status) {
      this.$set(this.allowShowImportPdfParts, estimateId, status)
    },
    copyToClipboard () {
      let item = document.createElement('textarea')
      document.body.appendChild(item)
      item.value = this.selectedText
      item.select()
      document.execCommand('copy')
      document.body.removeChild(item)
      this.$refs.rightClickMenuForPart.close()
    },
    openMenuForFiles: function (item, index, event) {
      if (!this.isStatusActive) {
        return
      }
      event.preventDefault()
      let row = _.find(document.elementsFromPoint(event.clientX, event.clientY), (el) => {
        return _.toLower(el.tagName) == 'td'
      })
      if (_.isEmpty(row)) {
        return
      }
      row = row.parentElement
      let rows = row.parentElement.rows
      if (rows) {
        for (let i = 0; i < rows.length; i++) {
          let elem = rows[i]
          elem.style.backgroundColor = ''
        }
      }
      if (row) {
        row.style.backgroundColor = '#F3F3F3'
      }
      this.$refs.rightClickMenuForFiles.open(event, item)
    },
    totalParts: function (parts) {
      let result = 0
      if (parts['RR']) {
        result += parts['RR'].length
      }
      if (parts['Repair']) {
        result += parts['Repair'].length
      }
      if (parts['Paint']) {
        result += parts['Paint'].length
      }
      if (parts['Part']) {
        result += parts['Part'].length
      }
      if (parts['Materials']) {
        result += parts['Materials'].length
      }
      if (parts['Sublet']) {
        result += parts['Sublet'].length
      }
      if (parts['Other']) {
        result += parts['Other'].length
      }
      if (parts['PDR']) {
        result += parts['PDR'].length
      }

      return result
    },
    onClickSaveButton () {
      this.manualSave()
    },
    isEmpty (val) {
      return _.isEmpty(val)
    },
    saveNewTask: function (newTask) {
      let update = {}
      update.newTask = newTask
      this.setUpdateData(update)
      //this.autoSave();
      toastr.success('The New Task created')
      this.isOpenNewTaskForm = false
    },
    closeNewTask: function () {
      //this.isOpenNewTask = false;
      this.newTask = {}
      this.isOpenNewTaskForm = false
    },
    closeTask: function () {
    },
    deleteActivity: function (id, isEmail = false) {
      Axios.post('/fe/activity/delete',
          {
            'activityId': id
          }
      )
          .then(response => {
            if (response.data._status) {
              toastr.success('The Activity list entry deleted')
              let removedItem = _.filter(this.activity, function (item) {
                return item.activity_id == id
              })
              let index = this.activity.indexOf(removedItem[0])
              this.activity.splice(index, 1)
              if (isEmail) {
                this.$store.commit('dashboard/deleteEmail', id)
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
    deleteTask: function (task) {
      let update = {}
      update.task = task
      this.setUpdateData(update)
      this.$store.commit('dashboard/deleteTask', task.id)
      this.$store.commit('dashboard/deleteComment', task.id)
      //this.autoSave();
      toastr.success('The Task deleted')
    },
    saveTask: function (task) {
      let update = {}
      update.task = task
      this.setUpdateData(update)
      //this.autoSave();
      //task.newComment = null;
      toastr.success('The Task updated')
    },
    openNewTask: function () {
      const today = new Date()
      let month = ('0' + (today.getMonth() + 1)).slice(-2)
      let date = ('0' + today.getDate()).slice(-2)
      let year = today.getFullYear()

      this.newTask = {
        name: '',
        date: null,
        time: null,
        notes: '',
        type: { key: 'to-do', value: 'ToDo' },
        assignedTo: { id: '-1', name: 'Estimators' },
        status: { key: 'none', value: 'None' },
      }
      this.$refs['activity-tab-link'].click()
      this.isOpenNewTaskForm = true
    },
    importPdfForParts () {
      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to perform this operation? Estimate has unsaved data')) {
          return
        }
      }
      NProgress.start()
      let estimateId = this.computedEstimateId
      let self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            NProgress.done()
            let estimate = this.getItemList(estimateId)
            self.$router.push({
              name: 'parseExternalPdf', params: {
                estimate_id: self.computedEstimateId, tab: self.currentTab, parentId: self.$route.params.estimate_id,
                dataForHeader: {
                  estimateNumber: estimate.supplement_number ? this.estimate_number + ' - ' + estimate.supplement_number : this.estimate_number,
                  ownerName: ' | ' + this.card.customer.name,
                  rego: ' | ' + this.showUpperRegoNumber,
                }
              }
            })
          })
    },
    addTemplateToEstimate (template) {
      // console.log('template', template);
      NProgress.start()
      Axios.post('/fe/estimate/' + this.computedEstimateId + '/apply-template/' + template.id)
          .then(response => {
            if (response.status === 200) {
              this.loadItemsList(this.estimate.id)
              toastr.success(template.name + ' template has been applied successfully')
            }
          })
          .catch(error => {
            toastr.error('The template could not be applied')
            console.log(error)
            NProgress.done()
          })

    },
    removeTemplateFromEstimate (templateId) {
      //console.log('templateId', templateId);
      NProgress.start()
      Axios.post('/fe/estimate/' + this.computedEstimateId + '/remove-template')
          .then(response => {
            if (response.status === 200) {
              this.loadItemsList(this.estimate.id)
              toastr.success('The template has been removed successfully')
              this.currentItemListId = this.$route.params.estimate_id
            }
          })
          .catch(error => {
            toastr.error('The template could not be removed')
            console.log(error)
            NProgress.done()
          })
    },
    moveToCardFiles: function (file) {
      //  console.log(file);
      Axios.put(`/fe/estimate/${this.estimate.id}` + '/file-access/' + file.id, { moveToCard: true })
          .then(response => {
            if (response.status === 200) {
              toastr.success(response.data._msg)
              file.isCardAccess = true
            }
          })
          .catch(error => {
            console.log(error)
          })

      this.contextClose()
    },
    copyToCardFiles: function (file) {
      //  console.log(file);
      Axios.put(`/fe/estimate/${this.estimate.id}` + '/file-access/' + file.id, { copyToCard: true })
          .then(response => {
            if (response.status === 200) {
              toastr.success(response.data._msg)
            }
          })
          .catch(error => {
            console.log(error)
          })

      this.contextClose()
    },
    removeFromCardFiles: function (file) {
      Axios.put(`/fe/estimate/${this.estimate.id}` + '/file-access/' + file.id, { deleteFromCard: true })
          .then(response => {
            if (response.status === 200) {
              toastr.success(response.data._msg)
              file.isCardAccess = false
            }
          })
          .catch(error => {
            console.log(error)
          })
      this.contextClose()
    },

    addNote () {
      this.note_id = null
      this.note = ''
      this.note_type = 'General'
    },
    saveNote (note) {
      console.log('save un estimate note', note)
      NProgress.start()
      let card_id = this.card_id
      let url = ''

      if (note.id == null) {
        url = '/fe/note'
      } else {
        url = `/fe/note/${note.id}`
      }
      Axios({
        method: 'post',
        responseType: 'json',
        url: url,
        validateStatus: function (status) {
          return status < 500
        },
        data: { note: note.note.replace(/<br \/>/g, ''), card_id: card_id, type: note.type }
      })
          .then(response => {
            if (response.status == 200) {
              toastr.success(response.data._msg)
              // if (this.note_id == null) {
              //   this.note_id = response.data.note_id
              // }
              this.notes = response.data.notes
            } else {
              toastr.error(response.data._msg)
            }
            NProgress.done()
          })
          .catch(error => {
            NProgress.done()
            toastr.error(error)
          })
    },
    addNewVehiclePaintCode: function (data) {
      this.newVehiclePaintCode = data
      this.estimateRates.paint_material = ''
      this.isShowNewPaintColourNotification = true
      //   console.log('addNewVehiclePaintCode', data);
      this.$refs['estimate-details'].click()
      this.$refs['RatesPaintMaterial'].scrollIntoView({ block: 'center', inline: 'center' })
      let vm = this
      setTimeout(function () {
        vm.$refs['RatesPaintMaterial'].focus()
      }, 50)
    },
    changeNewPaintColourAfterSetPaintMaterial: function () {
      if (this.estimateRates.paint_material != '' && this.isShowNewPaintColourNotification) {
        // console.log('changeNewPaintColourAfterSetPaintMaterial');
        let data = this.newVehiclePaintCode
        //console.log('newVehiclePaintCode', data);
        if (data.group == '') {
          data.group = this.estimateRates.paint_material
          this.card.vehicle.colour = data.oem_paint_code + ' - ' + data.group
          this.isShowNewPaintColourNotification = false
          this.newVehiclePaintCode = {}
          this.vehiclePaintCodes.push(data)
          this.autoUpdateCardVehicle()
        }
      }
    },
    loadNotes (notes = null) {
      if (notes) {
        this.notes = notes
        return
      }

      let card_id = this.card.card_id
      Axios.get(`/fe/note/${card_id}`)
          .then(response => {
            this.notes = response.data.notes
          })
          .catch(error => {
            NProgress.done()
          })
    },
    saveItemsList (estimateId, data) {
      if (!this.isAutoSave) {
        return
      }
      this.setUpdateData(data, estimateId)
      //  console.log('saveItemsList', estimateId);
    },
    setUpdateData: function (v, estimateId = null) {
      if (!this.isAutoSave) {
        return
      }
      if (!estimateId) {
        estimateId = this.estimate.id
      }
      //   console.log('setUpdateData', v, estimateId)
      let uid = Date.now().toString() + Math.random().toString(36).substr(2, 4)
      if (!this.isAutoSaveEnable && !(this.currentTab === 'notes' || this.currentTab === 'images' || this.currentTab === 'files' || this.currentTab === 'activity')) {
        if (!this.updateData2[estimateId]) {
          this.updateData2[estimateId] = {}
        }
        this.updateData2[estimateId][uid] = v
      } else {
        if (!this.updateData[estimateId]) {
          this.updateData[estimateId] = {}
        }
        this.updateData[estimateId][uid] = v
      }
      this.beforeDebouncedAutoSave()
    },
    labelVehiclePaintCode: function (t) {
      if (t.oem_paint_code == '-1') {
        return t.colour_name + ' - ' + t.group
      }
      return t.oem_paint_code + ' - ' + t.colour_name + ' - ' + t.group
    },
    changePaintMaterial: function (paint_material) {
      //console.log('paint material change', paint_material);
      this.estimateRates.paint_material = paint_material
    },
    loadPaintCodes: function () {
      if (this.isEstimateMethodologyCustom) {
        console.log('not paint code')
        return false
      }
      let make = this.card.vehicle.make
      if (make != '') {
        Axios({
          method: 'get',
          responseType: 'json',
          url: `/fe/vehicle/paint-code/${make}`,
          validateStatus: function (status) {
            return status < 500
          },
        })
            .then(response => {
              if (response.status === 200) {
                this.vehiclePaintCodes = response.data
              }
            })
            .catch(error => {
              console.log('loadPaintCodes')
              console.log(error)
            })
      }
    },
    paintMaterialNotificationCompleted: function () {
      this.isShowPaintMaterialNotification = true
      this.$refs.paintMaterialNotificationModal.hide()
      this.$refs['estimate-details'].click()
      if (this.$refs.RatesPaintMaterial) {
        this.$refs.RatesPaintMaterial.$el.scrollIntoView({ block: 'center', inline: 'center' })
        var vm = this
        setTimeout(function () {
          vm.$refs.RatesPaintMaterial.$el.focus()
        }, 50)
      }
    },
    showPaintMaterialNotification: function () {
      if (this.isShowPaintMaterialNotification || this.isEstimateMethodologyCustom || this.estimateRates.paint_material !== 'not_set') {
        return
      }
      this.$refs.paintMaterialNotificationModal.show()
    },
    isZero: function (item) {
      if (item == 0 || item == '0' || item == '0.0' || item == '0.00') {
        return true
      }
      return false
    },
    onChangeCardProgress: function (id) {
      if (!this.isStatusActive) {
        return
      }
      this.card.card_status = id
      this.autoUpdateCardStatus()
    },

    tabEstimateChange (tab, itemListId = false) {
      if (itemListId) {
        this.currentItemListId = itemListId
      }
      this.currentTab = tab
      this.changeEstimentChapter = 'All'
      this.pinImagePage = true
      this.classTabContent = 'tab-content'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', tab)
    },
    vehicleDetailsTabChange () {
      this.currentTab = 'vehicleDetails'
      this.changeEstimentChapter = 'All'
      this.classTabContent = 'tab-content'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'vehicleDetails')
    },
    notesTabChange () {
      this.currentTab = 'notes'
      this.changeEstimentChapter = 'All'
      this.classTabContent = 'tab-content-table'
      this.isHiddenOptions = false
      this.isHiddenNewNote = false
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'notes')
    },
    imagesTabChange () {
      this.currentTab = 'images'
      this.changeEstimentChapter = 'Images'
      this.classTabContent = 'tab-content'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'images')
    },
    filesTabChange () {
      this.currentTab = 'files'
      this.changeEstimentChapter = 'Files'
      this.classTabContent = 'tab-content-table'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'files')
    },
    supplementsTabChange () {
      this.currentTab = 'supplements'
      this.changeEstimentChapter = 'All'
      this.classTabContent = 'tab-content-table'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'supplements')
    },
    activityTabChange () {
      this.currentTab = 'activity'
      this.changeEstimentChapter = 'All'
      this.classTabContent = 'tab-content'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'activity')
    },
    autoUpdateCardCustomerEmail: function (value) {
      this.card.customer.email = value
      this.$v.card.customer.email.$touch()
      this.autoUpdateCardCustomer()
    },
    autoUpdateCardCustomer: function () {
      if (this.$v.card.customer.$anyError) {
        this.showUnsavedChanges()
        return
      }
      let update = {}
      update.customer = this.card.customer
      update.customer_id = this.card.customer.customer_id
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateContacts: function () {
      let update = {}
      update.vehicleDriverName = this.card.vehicleDriverName
      update.contactNumber1 = this.card.contactNumber1
      update.contactNumber2 = this.card.contactNumber2
      update.contactEmail = this.card.contactEmail
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateBusinessABN: function (event) {
      let update = {}
      update.abn = this.card.customer.abn
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateCardStatus: function (event) {
      this.beforeDebouncedUnsavedChanges()
      this.updateCardProgressBar()
      let update = {}
      update.card_status = this.card.card_status
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    changedCardCustomerAddress: function (addr) {
      this.card.customer.address = addr['address']
      this.card.customer.level_unit_lot = addr['levelUnitLot']
      this.card.customer.street_name = addr['street_name']
      this.card.customer.suburb = addr['suburb']
      this.card.customer.state = addr['state']
      this.card.customer.postcode = addr['postcode']
      this.card.customer.country = addr['country']
      this.autoUpdateCardCustomer()
    },
    showActivityTab () {
      this.changeEstimentChapter = 'All'
      //this.$refs.cardProgress.changeTab(0, this.cardProgress.startIndex);
      //this.$refs.cardProgress.tabs.forEach((tab, i) => {
      //    if (i <= this.cardProgress.startIndex) {
      //        tab.active = true;
      //        tab.checked = true;
      //    } else {
      //        tab.active = false;
      //        tab.checked = false;
      //    }
      //});

      setTimeout(function () {
        let circlesNum = document.querySelectorAll('.wizard-nav-pills li').length
        document.getElementsByClassName('wizard-navigation')[0].style.width = 89.3 * circlesNum + 'px'
      }, 10)
    },
    updateCardProgressBar () {
      //this.showUnsavedChanges();
      if (this.card.statuses) {
        this.card.statuses.splice(0)
      } else {
        this.$set(this.card, 'statuses', [])
      }

      let currentStatusIndex = 0
      this.ceStatuses.forEach((ce_status, i) => {
        if (ce_status.ce_status_id.toString() === this.card.card_status) {
          currentStatusIndex = i
        }
      })
      let count = this.ceStatuses.length
      if (count > 0) {
        this.cardProgress.width = 'width: ' + (count * 89.3) + 'px'
        this.cardProgress.widthActivePercent = 'width: ' + (89.3 * (currentStatusIndex + 1) - 25) + 'px'
      } else {
        this.cardProgress.width = 'width: 0px'
        this.cardProgress.widthActivePercent = 'width: 0px'
      }

      this.cardProgress.startIndex = currentStatusIndex
      this.ceStatuses.forEach((ce_status, i) => {
        let status = {
          id: ce_status.ce_status_id,
          title: ce_status.name,
          active: false,
        }
        if (currentStatusIndex >= i) {
          status.active = true
          status.icon = 'ti-check'
        } else {
          status.active = false
          status.icon = ' '
        }
        this.card.statuses.push(status)
      })
      this.updateCardProgressBarSmall()
      //this.autoSaveMessage = '';
      //this.showUnsavedChanges();
    },
    updateCardProgressBarSmall () {
      if (!this.filteredStatusList) {
        return
      }
      let currentStatusIndexSmall = 0
      this.filteredStatusList.forEach((ce_status, i) => {
        if (ce_status.id.toString() === this.card.card_status) {
          currentStatusIndexSmall = i
        }
      })
      let countSmall = this.filteredStatusList.length

      let el = document.querySelector('#estimate-details > div:nth-child(1) > div.col-md-4.pr-0 > div.card.ex-card.wizard-bottom > div > div.wizard-navigation > ul')

      let width = 134
      if (el && el.clientWidth) {
        width = el.clientWidth / 4
        if (el.clientWidth > 365 && el.clientWidth <= 460) {
          width += 5
        }
        if (el.clientWidth > 460) {
          width += 15
        }
      }
      if (countSmall > 0) {
        this.cardProgressSmall.width = 'width: ' + (countSmall * 89.3) + 'px'
        if (currentStatusIndexSmall == 0) {
          this.$set(this.cardProgressSmall, 'widthActivePercent', 'width: 25px')
        } else {
          this.$set(this.cardProgressSmall, 'widthActivePercent', 'width: ' + (width * (currentStatusIndexSmall)) + 'px')
        }
      } else {
        this.cardProgressSmall.width = 'width: 0px'
        this.$set(this.cardProgressSmall, 'widthActivePercent', 'width: 0px')
      }
    },
    markAs: function (state) {
      let update = {}
      if (state == 0) {
        this.draft = 'Y'
        update.draft = 'Y'
      } else {
        this.draft = 'N'
        update.draft = 'N'
      }
      this.state = state
      update.state = state
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    markAsRead: function () {
      this.$store.dispatch('updateActivityViewedStatus', {
        card_id: this.card.card_id,
        viewed: 1
      })
      _.forEach(_.filter(this.activity, { 'viewed': '0' }), function (item) {
        item.viewed = '1'
      })
    },
    removeDraft: function () {

    },
    updateRRRepairPaint (type, data, estimate) {
      var vm = this
      estimate.parts[type].splice(0)
      setTimeout(() => {
        data.forEach(function (elem) {
          estimate.parts[type].push(elem)
        })
      }, 100)

    },
    updateRR: function (data, estimateId = false) {

      if (data) {
        if (!estimateId) {
          estimateId = this.estimate.id
        }
        let estimate = this.getItemList(estimateId)
        this.updateRRRepairPaint('RR', data, estimate)
      }
    },
    updateRepair: function (data, estimateId = false) {
      var vm = this
      if (data) {
        if (!estimateId) {
          estimateId = this.estimate.id
        }
        let estimate = this.getItemList(estimateId)
        this.updateRRRepairPaint('Repair', data, estimate)
      }
    },
    updatePaint: function (data, estimateId = false) {
      var vm = this
      if (data) {
        if (!estimateId) {
          estimateId = this.estimate.id
        }
        let estimate = this.getItemList(estimateId)
        this.updateRRRepairPaint('Paint', data, estimate)
      }
    },
    updatePart: function (data, estimateId = false) {
      var vm = this
      if (data) {
        if (!estimateId) {
          estimateId = this.estimate.id
        }
        let estimate = this.getItemList(estimateId)
        this.updateRRRepairPaint('Part', data, estimate)
      }
    },
    getItemList (estimateId) {
      return _.find(this.itemsList, function (i) {
        return Number(i.id) == Number(estimateId)
      })
    },
    updateCalculation: function (data, estimateId = false) {
      //  console.log('data',data)
      var vm = this
      if (!estimateId) {
        estimateId = this.estimate.id
      }
      let estimate = this.getItemList(estimateId)
      estimate.parts['Materials'] = []
      if (data && data.Materials) {
        this.$nextTick(() => {
          data.Materials.forEach(function (elem) {
            if (elem && elem.type && elem.type === 'calculation') {
              if (elem.id > 0) {
                elem.isOverrided = true
              }
            }
            estimate.parts['Materials'].push(elem)
          })
        })
      }

      estimate.parts['MaterialsCalc'] = []
      if (data && data.MaterialsCalc) {
        // this.estimateParts['MaterialsCalc'].splice(0);
        this.$nextTick(() => {
          data.MaterialsCalc.forEach(function (elem) {
            estimate.parts['MaterialsCalc'].push(elem)
          })
        })
      }
    },
    showUnsavedChanges: function () {
      this.autoSaveMessage = 'Unsaved Changes'
    },
    autoSave () {
      let vm = this
      _.forEach(this.updateData, function (data, key) {
        //console.log('!!!!', key, data);
        if (key && Number(key) > 0 && !_.isEmpty(data)) {
          let response = vm.saveData(key, data)
        }
      })
    },
    manualSave () {
      if (this.isAutoSaveEnable) {
        return
      }
      NProgress.start()
      let vm = this
      _.forEach(this.updateData2, function (data, key) {
        //console.log('!!!!', key, data);
        if (key && Number(key) > 0 && !_.isEmpty(data)) {
          let response = vm.saveData(key, data)
        }
      })
      NProgress.done()
    },
    saveData: function (estimateId, data) {
      if (_.isEmpty(data)) {
        return
      }
      // console.log('saveData', data)
      this.showPaintMaterialNotification()
      this.autoSaveMessage = 'Saving...'
      let vm = this
      return Axios({
        method: 'post',
        responseType: 'json',
        headers: { 'Autosave': true },
        url: `/fe/estimate/${estimateId}`,
        validateStatus: function (status) {
          return status < 500
        },
        data: data
      })
          .then(response => {
            if (response.status === 200) {
              this.autoSaveMessage = 'Saved'
              this.changedNameOfAssignedTo()
              // this.originalData = saveData;
              if (response?.data?.response?.update?.calculation) {
                this.updateCalculation(response.data.response.update.calculation, estimateId)
              }
              if (response?.data?.response?.update?.calculationOnlyNames) {
                // this.updateCalculation(response.data.response.update.calculationOnlyNames, true);
              }
              if (response?.data?.response?.update?.images) {
                this.images = this.getImages(response.data.response.update.images)
              }
              if (response?.data?.response?.update?.files) {
                this.files = this.getFiles(response.data.response.update.files)
              }
              if (response?.data?.response?.update?.rr) {
                this.updateRR(response.data.response.update.rr, estimateId)
              }
              if (response?.data?.response?.update?.repair) {
                this.updateRepair(response.data.response.update.repair, estimateId)
              }
              if (response?.data?.response?.update?.paint) {
                this.updatePaint(response.data.response.update.paint, estimateId)
              }
              if (response?.data?.response?.update?.template_removed) {
                this.loadEstimate(this.estimate.id)
              }
              if (response?.data?.response?.update?.logActivity) {
                this.loadActivity()
              }
              if (response?.data?.response?.update?.isLoadItems) {
                this.loadTimesForItemPart()
                this.loadItemsList(this.estimate.id, function (items) {

                  _.forEach(items, function (item) {
                    if (item?.AI) {
                      const i = vm.itemsList.find((i) => i.id == item.id)
                      vm.$set(i, 'AI', item?.AI)
                    }
                    vm.updateRR(item.parts.RR, item.id)
                    vm.updateRepair(item.parts.Repair, item.id)
                    vm.updatePaint(item.parts.Paint, item.id)
                    vm.updateCalculation({
                      Materials: item.parts.Materials,
                      MaterialsCalc: item.parts.MaterialsCalc
                    }, item.id)
                  })
                })
              }
              if (!this.isAutoSaveEnable && (this.currentTab === 'vehicleDetails' || this.currentTab.includes('itemList'))) {
                toastr.success('Estimate updated')
                if (_.isEmpty(this.updateData2[estimateId])) {
                  delete this.updateData2[estimateId]
                }
              }

              if (response?.data?.response && response?.data?.response?.result) {
                _.forEach(response.data.response.result, function (val, k) {
                  if (vm.updateData && vm.updateData[estimateId] && vm.updateData[estimateId][k]) {
                    let s = delete vm.updateData[estimateId][k]
                  }
                  if (vm.updateData2 && vm.updateData2[estimateId] && vm.updateData2[estimateId][k]) {
                    let s = delete vm.updateData2[estimateId][k]
                  }
                })
              }

              if (_.isEmpty(this.updateData2[estimateId])) {
                delete this.updateData2[estimateId]
              }

              return response
            } else {
              this.autoSaveMessage = 'Unsaved Changes'
              return false
            }
          })
          .catch(error => {
            console.log(error)
            this.autoSaveMessage = 'Unsaved Changes'
            return false
          })
          .finally(() => {

          })
    },
    saveCardData (data) {
      if (!this.isAutoSave) {
        return
      }

      this.autoSaveMessage = 'Saving...'
      const card_id = this.card_id

      return Axios({
        method: 'post',
        responseType: 'json',
        headers: { 'Autosave': true },
        url: `/fe/card/${card_id}`,
        validateStatus: function (status) {
          return status < 500
        },
        data: data
      })
          .then(response => {
            if (response.status === 200) {
              this.autoSaveMessage = 'Saved'

            } else {
              this.autoSaveMessage = 'Unsaved Changes'
            }
            // this.loadEstimate(this.$route.params.estimate_id, false, false, false)
          })
          .catch(() => {
            this.autoSaveMessage = 'Unsaved Changes'
          })
    },
    autoUpdateImage: function (event) {
      let update = {}
      update.image_ids = this.image_ids
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateFile: function (event) {
      let update = {}
      update.file_ids = this.file_ids
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateCardVehicle: function (event) {
      let update = {}
      update.vehicle = this.card.vehicle
      update.customer_id = this.card.customer.customer_id
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateVehicleTotalLoss: function (event) {
      if (this.card.isTotalLoss == 'true') {
        this.card.isTotalLoss = true
      }
      if (this.card.isTotalLoss == 'false') {
        this.card.isTotalLoss = false
      }
      let update = {}
      update.isTotalLoss = this.card.isTotalLoss
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateInsuranceAssessorEmail: function (value) {
      this.card.insurance.assessor_email = value
      this.$v.card.insurance.assessor_email.$touch()
      this.autoUpdateInsurance()
    },
    autoUpdateInsurance: function (event) {
      this.loadPaintCodes()
      if (this.$v.card.insurance.$anyError) {
        this.showUnsavedChanges()
        return
      }
      let update = {}
      update.insurance = this.card.insurance
      update.insurance_repair = this.card.insurance_repair
      this.setUpdateData(update)
      this.callRatesUpdate++
      this.beforeDebouncedAutoSave()
    },
    autoUpdatePaintMaterial: function () {
      if (this.isAutoSave) {
        let update = {}
        update.change_paint_material = this.estimateRates.paint_material
        this.setUpdateData(update)
        this.autoUpdateRates({ estimateRates: { paint_material: this.estimateRates.paint_material } })
        this.beforeDebouncedAutoSave()
      }
      if (this.isShowNewPaintColourNotification) {
        this.changeNewPaintColourAfterSetPaintMaterial()
      }
    },
    autoUpdateEstimateDateCreated: function () {
      let update = {}
      update.estimate = { dateCreated: this.estimate.dateCreated }
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateRates: function (data = false) {
      this.callRatesUpdate++
      let update = {}
      if (!data) {
        update.estimateRates = this.estimateRates
      } else {
        update = data
      }

      this.estimateRatesUpdater++
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    updateRates (v) {
      let estimateRatesCopy = _.cloneDeep(this.estimateRates)
      if (Number(v.rr)) {
        this.estimateRates.rr = v.rr
      }
      if (Number(v.repair)) {
        this.estimateRates.repair = v.repair
      }
      if (Number(v.paint)) {
        this.estimateRates.paint = v.paint
      }
      let data = {
        estimateRates: {
          estimate_methodology: type
        }
      }
      if (Number(estimateRatesCopy.rr) !== Number(this.estimateRates.rr)) {
        data.estimateRates.rr = this.estimateRates.rr
      }

      if (Number(estimateRatesCopy.repair) !== Number(this.estimateRates.repair)) {
        data.estimateRates.repair = this.estimateRates.repair
      }

      if (Number(estimateRatesCopy.paint) !== Number(this.estimateRates.paint)) {
        data.estimateRates.paint = this.estimateRates.paint
      }

      this.autoUpdateRates(data)
    },

    sctollToTop: function () {
      setTimeout(() => {
        document.getElementsByClassName('modal-dialog')[0].scrollIntoView()
        return true
      }, 100)
    },
    beforeImageSwitch: function () {
      // console.log('inside beforeImageSwitch')
      NProgress.start()
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.count < 1) {
            this.count++
            reject('Please note that this is a Test environment and <strong>no actual emails will be sent</strong> to the customers yet. Click "Send" again to complete this wizard')
          } else {
            this.count = 0
            resolve(true)
          }
          NProgress.done()
        }, 1000)
      })
    },
    customerModalFormCompleted: function () {
      return
    },
    sendToCustomer: function () {
      this.$v.card.vehicle.$touch()
      var vm = this
      if (!this.isInsuranceRepairOther && this.$v.card.vehicle.$anyError) {
        toastr.error('An error occurred while sending the estimate. Customer information was found to be missing.')
        let missingErrorText = ''
        if (this.$v.card.vehicle.rego_number.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleRegoNumber.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Rego</li>'
        }
        if (this.$v.card.vehicle.make.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleMake.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Make</li>'
        }
        if (this.$v.card.vehicle.model.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleModel.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Model</li>'
        }
        if (missingErrorText != '') {
          toastr.error(missingErrorText)
        }
        return
      }

      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      NProgress.start()
      let self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            NProgress.done()
            self.$router.push({
              name: 'sendToCustomer',
              params: { estimate_id: self.computedEstimateId, tab: self.currentTab }
            })
            //Axios.get(`/fe/estimate/to/customer/${estimate_id}`)
            //    .then(response => {
            //        self.estimateToCustomer = response.data;
            //
            //        self.customerContacts = Array({
            //            customer_name: response.data.customer.customer_name,
            //            email: response.data.customer.email
            //        });
            //
            //
            //        self.$refs.customerModal.show();
            //    })
            //    .catch(error => {
            //        toastr.error("Error occurred while loading estimate to customer info");
            //        // console.log(error)
            //        NProgress.done();
            //    });
          })
    },
    showPreADJEstimateModal: function () {

      if (!_.isEmpty(this.updateData2)) {
        toastr.error('Estimate has unsaved data')
        return

      }

      var self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 1000)
      })

      promise.then(
          resolve => {
            NProgress.start()
            Axios.get(`/fe/estimate/to/customer/${this.computedEstimateId}/pre-adjusted`)
                .then(response => {
                  self.estimateToCustomer = response.data
                  if (self.estimateToCustomer && self.estimateToCustomer.line_items && self.estimateToCustomer.line_items.lines) {
                    let countSubtotal = 0
                    _.forEach(self.estimateToCustomer.line_items.lines, function (i) {
                      if (i.length > 0) {
                        countSubtotal++
                      }
                    })
                    self.estimateToCustomer.line_items.countSubtotal = countSubtotal
                  }

                  self.customerContacts = Array({
                    customer_name: response.data.customer.customer_name,
                    email: response.data.customer.email
                  })

                  NProgress.done()
                  self.$refs.previewADJPreEstimateModal.show()
                })
                .catch(error => {
                  toastr.error('Error occurred while loading estimate to customer info')
                  //  console.log(error)
                  NProgress.done()
                })
          }
      )
    },
    showPreviewEstimateModal: function () {

      if (!_.isEmpty(this.updateData2)) {
        toastr.error('Estimate has unsaved data')
        return

      }

      var self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 1000)
      })

      promise.then(
          resolve => {
            NProgress.start()
            Axios.get(`/fe/estimate/to/customer/${this.computedEstimateId}`)
                .then(response => {
                  self.estimateToCustomer = response.data
                  if (self.estimateToCustomer && self.estimateToCustomer.line_items && self.estimateToCustomer.line_items.lines) {
                    let countSubtotal = 0
                    _.forEach(self.estimateToCustomer.line_items.lines, function (i) {
                      if (i.length > 0) {
                        countSubtotal++
                      }
                    })
                    self.estimateToCustomer.line_items.countSubtotal = countSubtotal
                  }
                  /**
                   * TODO: Remove This after backend supported for PDR
                   * manual added for FE work
                   */

                  //// add PDR data manually
                  //let PDRSubtotal = 0;
                  //// mapping current data
                  //const PDRParts = this.estimateParts['PDR'].map(part => {
                  //    PDRSubtotal += part.total * 1.1;
                  //    return {
                  //        gst: 10,
                  //        gst_amount: part.total * 0.1, // 20
                  //        gst_amount_str: `$${(Number(part.total) * 0.1).toFixed(2)}`, // "$20.00"
                  //        gst_str: "10.00%",
                  //        material: part.material.label,
                  //        action: part.action.label,
                  //        qty: 1,
                  //        qty_str: "",
                  //        name: part.name,
                  //        comment: part.comment,
                  //        price: part.price,
                  //        price_str: `$${part.price}.00`,
                  //        sub_total: part.total,
                  //        sub_total_str: `$${Math.floor(part.total * 1.1).toFixed(2)}`,
                  //        total: (Number(part.total) * 1.1).toFixed(2),
                  //        total_str: `$${Number(part.total * 1.1).toFixed(2)}`,
                  //        show_pdr_price: this.isVisibleToPDRTech,
                  //        type: part.type,
                  //    }
                  //});
                  //const PDRsubtotalStr = `$${Math.floor(PDRSubtotal).toFixed(2)}`;
                  //this.$set(self.estimateToCustomer.line_items.lines, 'PDR', PDRParts)
                  //this.$set(self.estimateToCustomer.line_items.summary, 'PDR-Total-SubTotal-Str', PDRsubtotalStr)
                  /** END manual added */

                  self.customerContacts = Array({
                    customer_name: response.data.customer.customer_name,
                    email: response.data.customer.email
                  })

                  NProgress.done()
                  self.$refs.previewEstimateModal.show()
                })
                .catch(error => {
                  toastr.error('Error occurred while loading estimate to customer info')
                  //  console.log(error)
                  NProgress.done()
                })
          }
      )
    },
    insurerModalFormCompleted: function () {
      //if (this.new_insurer_email) {
      //    this.addNewInsurerContact();
      //}
      //
      //let estimate_id = this.$route.params.estimate_id;
      //
      //NProgress.start();
      //Axios({
      //    method: 'post',
      //    responseType: 'json',
      //    url: `/fe/email/insurer/${estimate_id}`,
      //    validateStatus: function (status) {
      //        return status < 500;
      //    },
      //    data: JSON.stringify({
      //        insurers: this.insurerContacts,
      //        images: this.selectedImages,
      //    })
      //})
      //    .then(response => {
      //        if (response.status == 200) {
      //            toastr.success(response.data.msg);
      //            if (this.state == 0) {
      //                this.markAs(1);
      //            }
      //           // this.isSentToInsurer = true;
      //            this.$refs.insurerModal.hide();
      //        } else {
      //            toastr.error(response.data.msg);
      //        }
      //        NProgress.done();
      //    })
      //    .catch(error => {
      //        NProgress.done();
      //        toastr.error(error);
      //    });
    },
    sendToInsurerMain () {
      if (this.properties.isFromIag && this.vendorInfo?.features?.integrations?.orm) {
        this.goToSendToOrm()
      } else if (this.properties?.isFromEio) {
        this.goToSendToEio()
      } else if (this.properties?.isFromAudaBridge || this.properties?.isFromAudaNet) {
        this.goToSendToAuda()
      } else {
        this.sendToInsurer()
      }
    },
    sendToInsurer: function () {
      this.$v.card.vehicle.$touch()
      let vm = this
      if (!this.isInsuranceRepairOther && this.$v.card.vehicle.$anyError) {
        toastr.error('An error occurred while sending the estimate. Insurer information was found to be missing.')
        let missingErrorText = ''
        if (this.$v.card.vehicle.rego_number.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleRegoNumber.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Rego</li>'
        }
        if (this.$v.card.vehicle.make.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleMake.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Make</li>'
        }
        if (this.$v.card.vehicle.model.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleModel.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Model</li>'
        }
        if (missingErrorText != '') {
          toastr.error(missingErrorText)
        }
        return
      }

      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      NProgress.start()
      let self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            NProgress.done()
            self.$router.push({
              name: 'sendToInsurer',
              params: { estimate_id: self.computedEstimateIdForInsurance, tab: self.currentTab }
            })

          })
    },
    addNewInsurerContact: function () {
      if (!this.$v.new_insurer_email.email) {
        toastr.error('Your changes could not be saved, please check the form fields again')
        return
      }
      this.insurerContacts.push({
        insurer_name: this.new_insurer_name,
        // assessor_name: this.new_assessor_name,
        // assessor_email: this.new_assessor_email
        insurer_email: this.new_insurer_email
      })
      this.new_insurer_name = ''
      this.new_insurer_email = ''
      // this.new_assessor_name = ''
      // this.new_assessor_email = ''
    },
    goToSendToOrm: function () {
      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }
      let vm = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(vm.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            vm.$router.push('/estimates/view/' + vm.computedEstimateIdForInsurance + '/options/send-to-orm')
          })
      return
    },
    goToSendToEio: function () {
      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }
      let vm = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(vm.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            // this.$router.push({ name: 'Cards', params: {filters: this.$route.params.filters, trackerFilter: this.$route.params.trackerFilter} })
            vm.$router.push({
              name: 'estimateSendToEstimageOnline',
              params: { estimate_id: vm.computedEstimateIdForInsurance }
            })
          })
      return
    },
    goToSendToAuda: function () {
      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }
      let vm = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(vm.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            vm.$router.push({
              name: 'estimateSendToAudanet',
              params: { estimate_id: vm.computedEstimateIdForInsurance }
            })
          })
      return
    },
    goToSendToSuppliers: function () {

      if ((this.isShopManagerUser || this.isProductionManagerUser || this.isEstimatorUser) && this.properties?.isCanSendToPartssearch && this.isStatusActive && this.vendorInfo?.features?.integrations?.partsSearch) {
        this.goToSendToPartssearch()
        return
      }

      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      let vm = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(vm.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            vm.$router.push({
              name: 'sendToSupplier',
              params: { estimate_id: vm.computedEstimateId, tab: vm.currentTab }
            })
          })
      return
    },
    goToSendToPartssearch: function () {
      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      let vm = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(vm.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            vm.$router.push({
              name: 'sendToPartssearch',
              params: {
                estimate_id: vm.computedEstimateId,
                tab: vm.currentTab,
                subTab: vm.selectedCard[vm.computedEstimateId]
              }
            })
          })
      return
    },
    sendToClaimLinq: function () {
      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      let vm = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(vm.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            vm.$router.push({
              name: 'sendToClaimlinq',
              params: { estimate_id: vm.computedEstimateId, tab: vm.currentTab }
            })
          })
      return
    },
    onImageSelect: function (imgs) {
      // console.log(imgs)
      this.selectedImages = imgs
    },
    downloadEstimate: function (is_pre_adjusted = false) {
      let estimateId = this.estimate.id
      if (this.isSupplementItemListTab) {
        estimateId = this.currentItemListId
      }
      let token = localStorage.getItem('token')
      let url = appConfig.baseAPIURL + `/fe/pdf/estimate/${estimateId}`
      if (is_pre_adjusted) {
        url += '/pre-adjusted'
      }
      url += `?at=${token}`;
      //need empty space here
      (async (url) => {
        const popup = window.open('')
        if (popup) {
          popup.location.href = url
        }
      })(url)
      return
    },
    downloadPreAdjEstimate: function () {
      this.downloadEstimate(true)
      return
    },
    createSupplement: function (props = null) {
      Axios.post(`/fe/estimate/supplement/${this.$route.params.estimate_id}`)
          .then(response => {
            let suppEstimateId = response.data.estimate_id
            this.loadItemsList(this.$route.params.estimate_id, data => {
              let vm = this
              _.forEach(data, function (item) {
                if (Number(item.id) == Number(suppEstimateId)) {
                  vm.itemsList.push(item)
                  if (props && props.type) {
                    vm.addNewPartToSupplement(props.type, props.elem, item.id)
                  } else {
                    vm.currentTab = 'itemList' + suppEstimateId
                    vm.currentItemListId = suppEstimateId
                  }
                }
              })
            })
            toastr.success('Supplement estimate created')
          })
          .catch(error => {
            NProgress.done()
            toastr.error(error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    createInvoice: function () {
      let card_id = this.card_id

      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      var self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 1000)
      })
      promise.then(
          result => {
            self.$router.push(`/invoice/new/${card_id}`)
          })
    },
    createExcessInvoice: function () {
      let card_id = this.card_id

      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      var self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 1000)
      })
      promise.then(
          result => {
            self.$router.push(`/invoice/new/${card_id}/excess`)
          })
    },
    clickBrowse: function (id) {
      $(id).trigger('click')
    },
    clickBrowseDropzoneImages: function (event) {
      if (this.$refs?.imgUpDrop?.dropzone?.hiddenFileInput) {
        this.$refs.imgUpDrop.dropzone.hiddenFileInput.removeAttribute('capture')
      }
    },
    openCapture () {
      if (this.userInfo?.camera == 'web') {
        this.isShowCamera = true
      } else if (this.$refs?.imgUpDrop?.dropzone?.hiddenFileInput) {
        this.$refs.imgUpDrop.dropzone.hiddenFileInput.setAttribute('capture', 'camera')
      }
    },
    clickCancelDropzoneImages: function (event) {
      event.preventDefault()
      this.$refs.imgUpDrop.removeAllFiles(true)
      this.image_ids = []
      this.image_categories = []
    },
    clickCancelDropzoneFiles: function () {
      this.$refs.fileUpDrop.removeAllFiles(true)
      this.file_ids = []
    },
    removeFileDropzone ($event) {
      // let filesReplace = []
      //
      // this.files.forEach((file) => {
      //   if (!file.uuid) {
      //     filesReplace.push(file)
      //   } else if (file.uuid && file.uuid !== $event.upload.uuid) {
      //     filesReplace.push(file)
      //   }
      // })
      // console.log(filesReplace, 'remove file drop')
      // this.files = filesReplace
    },
    sendImgUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
    },
    sendFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
      let reader = new FileReader()
      reader.onload = (e) => {
        let fileBase60Code = e.target.result
        this.addFile({
          name: $event.name,
          src: fileBase60Code,
          user: this.$store.state.userInfo.first_name + ' ' + this.$store.state.userInfo.last_name,
          date: '',
          uuid: $event.upload.uuid
        })
      }
      reader.readAsDataURL($event)
    },
    sendFileRemove: function (file) {
      NProgress.start()
      let url = '/fe/card/sendFileRemove'
      Axios({
        method: 'post',
        responseType: 'json',
        url: url,
        validateStatus: function (status) {
          return status < 500
        },
        data: { key: file.key, id: file.id, card_id: this.card_id }
      })
          .then(response => {
            if (response.status == 200) {
              // toastr.success(response.data.msg);

            } else {
              // toastr.error(response.data.msg);
            }
            NProgress.done()

          })
          .catch(error => {
            NProgress.done()
            toastr.error(error)
          })
    },
    remTableFile: function (id) {
      if (!this.isStatusActive) {
        return
      }
      const index = this.files.findIndex(file => file.id === id)
      const filename = this.files[index].name

      if (this.files[index].id) {
        this.$refs.fileUpDrop.dropzone.files.forEach((file, i) => {
          if (file.upload.uuid === this.files[index].uuid) {
            this.$refs.fileUpDrop.removeFile(file)
          }
        })

        if (this.files[index].id != null) {
          this.sendFileRemove(this.files[index])
        }
        this.files.splice(index, 1)
      }
      toastr.success(filename + 'has been deleted')
    },
    completeImgUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].removeAttribute('style')
    },
    completeFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].removeAttribute('style')
    },
    successAllImgUpload (files, response) {
      // console.log(files);
      //   console.log(response);
    },
    successImgUpload (file, response) {
      //console.log(response, 111);
      if (response.status) {
        this.image_ids.push(response.file_id)
        this.imagesAfterUpload.push({ id: response.file_id, file: file })
        this.autoUpdateImage()
        this.saveImgInTop(response.file_id)
        var vm = this
        setTimeout(function () {
          vm.$refs.imgUpDrop.removeFile(file)
        }, 1000)
      }
    },
    saveImgInTop (id) {
      let update = {}
      update.imagesSort = [{
        id: id,
        index: 1,
      }]
      _.forEach(this.images, (img, index) => {
        let ind = index + 2
        if (img.hasOwnProperty('sort')) {
          ind = Number(img.sort) + 1
        }
        update.imagesSort.push({
          id: img.id,
          index: ind
        })
      })
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    successFileUpload (file, response) {
      if (response.status) {
        this.file_ids.push(response.file_id)
        this.filesAfterUpload.push({ id: response.file_id, file: file })
        this.debouncedAutoUpdateFile()
        var vm = this
        setTimeout(function () {
          vm.$refs.fileUpDrop.removeFile(file)
        }, 1000)
      }
    },
    addImgUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
    },
    addFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
    },
    deleteImage: function (data) {
      let correctItem = this.resultSortingImages[data.key].filter(_ => {
        return _.id === data.id
      })
      var filename = correctItem[0].name
      if (correctItem[0].id != null) {
        this.sendFileRemove(correctItem[0])
      }
      let findIndex = this.images.indexOf(correctItem[0])
      this.images.splice(findIndex, 1)
      toastr.success(filename + ' has been deleted')
    },
    //saveData: function (isDraft) {
    //    if (this.changeEstimentChapter === 'Images' && this.$refs.imgUpDrop.dropzone.files.length) {
    //        let vm = this.$refs.imgUpDrop;
    //        let files = this.$refs.imgUpDrop.dropzone.files;
    //
    //        if (!files.length) {
    //            vm.$emit('input', '');
    //            return;
    //        }
    //
    //        files.forEach((item, i) => {
    //            if (item.accepted) {
    //                this.addImage({
    //                    name: item.name,
    //                    src: item.dataURL,
    //                    user: this.$store.state.userInfo.first_name + ' ' + this.$store.state.userInfo.last_name,
    //                    date: ''
    //                });
    //            }
    //        });
    //    }
    //    let estimate_id = this.$route.params.estimate_id;
    //    // let obj = this
    //    if (this.validateForm()) {
    //        return;
    //    }
    //    this.files.forEach((file, i) => {
    //        if (file.uuid) {
    //            delete file.uuid;
    //        }
    //    });
    //    NProgress.start();
    //    Axios({
    //        method: 'post',
    //        responseType: 'json',
    //        url: `/fe/estimate/${estimate_id}`,
    //        validateStatus: function (status) {
    //            return status < 500;
    //        },
    //        data: JSON.stringify({
    //            estimate: this.estimate,
    //            card: this.card,
    //            parts: this.estimateParts,
    //            removeParts: this.removeEstimateParts,
    //            file_ids: this.file_ids,
    //            image_ids: this.image_ids,
    //            draft: isDraft,
    //            status: this.status,
    //            insurance: this.card.insurance,
    //            insurance_repair: this.card.insurance_repair
    //        })
    //    })
    //        .then(response => {
    //            if (response.status == 200) {
    //                if (isDraft == 'N') {
    //                    toastr.success('Estimate updated');
    //                    // this.$router.push('/estimates')
    //                } else {
    //                    toastr.success('Draft saved!');
    //                    // this.$router.push('/estimates/drafts')
    //                }
    //                this.removeEstimateParts = {
    //                    'RR': [],
    //                    'Repair': [],
    //                    'Paint': [],
    //                    'Part': [],
    //                    'Materials': [],
    //                    'Sublet': [],
    //                    'Other': [],
    //                    'PDR': []
    //                };
    //                this.loadEstimate(estimate_id);
    //                this.$refs.imgUpDrop.removeAllFiles(true);
    //                this.$refs.fileUpDrop.removeAllFiles(true);
    //                this.file_ids = [];
    //                this.image_ids = [];
    //
    //                // this.$router.push('/files')
    //            } else {
    //                toastr.error(response.data.msg);
    //            }
    //            NProgress.done();
    //        })
    //        .catch(error => {
    //            NProgress.done();
    //            toastr.error(error);
    //        });
    //},
    loadCustomDirectory (type) {

    },
    loadTimesForItemPart: async function () {

      if (this.isEstimateMethodologyCustom) {
        return
      }
      if (this.isLoadTimesForItemPart) {
        return
      }
      this.isLoadTimesForItemPart = true
      // if (!this.currentSeriesSheduleNumber) {
      //     return;
      // }
      NProgress.start()
      if (this.isZurichEstimateMethodology) {
        var url = `/fe/parts/zi`
      } else if (this.card.vehicle.body != '' && this.card.vehicle.series_shedule_number != '' && this.card.vehicle.series_shedule_number != 0) {
        var url = `/fe/parts/directory/${this.card.vehicle.series_shedule_number}/${this.card.vehicle.body}`
      } else {
        var url = `/fe/parts/directory/0`
      }
      Axios.get(url)
          .then(response => {
            this.timesForItemPart = response.data
            NProgress.done()
            this.isLoadTimesForItemPart = false
          })
          .catch(error => {
            console.log(error)
            NProgress.done()
            this.isLoadTimesForItemPart = false
          })
    },
    loadItemsList (estimateId, callBack = false, isShowNProgress = true) {
      if (isShowNProgress) {
        NProgress.start()
      }
      let vm = this
      Axios.get(`/fe/estimate/${estimateId}/items-list`)
          .then(response => {
            if (response.data && response.data._status) {
              if (callBack) {
                callBack(response.data.itemsList)
                return
              }
              vm.itemsList.splice(0)
              _.forEach(response.data.itemsList, function (item) {
                vm.itemsList.push(item)
                //console.log('push!!!');
              })
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(() => {
        if (isShowNProgress) {
          NProgress.done()
        }
        this.isItemListLoaded = true
      })
    },
    autoSaveItemsList () {
      let estimateId = this.$route.params.estimate_id
      let data = []

      NProgress.start()
      Axios.post(`/fe/estimate/${estimateId}/items-list`)
          .then(response => {
            if (response.data && response.data._status) {
              this.itemsList = response.data.itemsList
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(() => {
        NProgress.done()
      })

    },
    loadEstimate: function (estimateId, callbackToReturn = false, isShowNProgress = true, isFirstRequest = false) {
      this.loadingEstimate = true
      if (isShowNProgress) {
        NProgress.start()
      }
      Axios.get(`/fe/estimate/${estimateId}`)
          .then(response => {
            if (response.data.estimate && response.data.estimate.parent_estimate_id && Number(response.data.estimate.parent_estimate_id) > 0) {
              this.$router.push('/estimates/view/' + Number(response.data.estimate.parent_estimate_id))
              return
            }
            if (callbackToReturn) {
              callbackToReturn(response.data)
              return
            }

            this.estimateAmount = response.data.estimate
            this.card = response.data.card
            this.plannerBoard = response.data.plannerBoard

            if (this.plannerBoard.onSite) {
              this.onSiteReason = this.plannerBoard.onSite.reason
              this.onSiteAttempt = this.plannerBoard.onSite.attempt
              this.onSiteFollowUpAction = this.plannerBoard.onSite.followUpAction
              if (this.plannerBoard.onSite.isAttendedBooking) {
                this.checkIsAttendYes(true)
              } else if (this.plannerBoard.onSite.isAttendedBooking === false) {
                this.checkIsAttendNo(true)
              }
            }

            this.invoice = response.data.invoice
            this.excess_invoice = response.data.excess_invoice

            this.assignedToUser = response.data.card?.assignedTo?.name
            this.assignedToArr = response.data.users
            this.assignedToUsers = response.data.users

            this.files = response.data.files
            this.images = this.getImages(response.data.images)
            //this.estimateParts = response.data.parts;
            this.estimate = response.data.estimate
            if (response.data.productionTime) {
              let r = _.find(response?.data?.properties?.production?.definitions?.categories, (c) => {
                return _.toLower(c.name) == _.toLower(response.data.productionTime?.category)
              })
              if (r && r.id) {
                response.data.productionTime.category = r.id
                setTimeout(() => {
                  this.isAutoSave = true
                  this.onRepairCategoryChange(r.id)
                }, 200)
              }
              this.productionTime = response.data.productionTime
              this.repairCategory = this.productionTime.category
            }

            this.plannerBoard = response.data.plannerBoard
            if (this.plannerBoard.onSite) {
              this.onSiteReason = this.plannerBoard.onSite.reason
              this.onSiteAttempt = this.plannerBoard.onSite.attempt
              if (this.plannerBoard.onSite.isAttendedBooking) {
                this.checkIsAttendYes(true)
              } else if (this.plannerBoard.onSite.isAttendedBooking === false) {
                this.checkIsAttendNo(true)
              }
            }

            this.estimateRates = response.data.rates
            this.isVisibleToPDRTech = response.data.estimate.isVisibleToPDRTech
            this.defaultValues.rates = response.data.default_rates
            this.estimate_number = response.data.estimate_number
            this.supplement_number = response.data.supplement_number
            this.parent_estimate_id = response.data.parent_estimate_id
            this.card_id = response.data.card_id
            this.card.card_number = response.data.card_number
            this.draft = response.data.draft
            this.booking_date = response.data.booking_date
            this.completion_date = response.data.completion_date
            this.arrivedDate = response.data.arrivedDate
            this.pickUpDate = response.data.pickUpDate
            if (response.data.pickUpTime) {
              this.pickUpTime = response.data.pickUpTime
            }
            this.status = response.data.status
            this.insurers = response.data.insurers
            this.assessors = response.data.assessors
            this.properties = response.data.properties
            this.boardDeparture = response.data.boardDeparture
            this.boardIn = response.data.boardIn
            this.iagOrmItems = response.data.iagOrmItems
            // init boards selection
            this.syncBoardsSelection()
            //ToDo turn off
            //this.$refs.rr.setValue(this.estimateRates.rr);
            //this.$refs.repair.setValue(this.estimateRates.repair);
            //this.$refs.paint.setValue(this.estimateRates.paint);
            //this.$refs.partmarkup.setValue(this.estimateRates.partmarkup);

            this.selectedVehicleMake = this.card.vehicle.make
            this.selectedVehicleModel = this.card.vehicle.model

            //  this.updateCalculation(Object.assign({}, response.data.parts));
            this.checkEmail2()
            this.updateCardProgressBar()
            this.loadPaintCodes()
            this.loadNotes()
            this.loadItemsList(estimateId)
            //NProgress.done();

            //if (this.supplement_number === 0) {
            //    this.loadSupplements();
            //}

            this.loadTimesForItemPart()
            var vm = this
            setTimeout(function () {
              vm.showPaintMaterialNotification()
              vm.isAutoSave = true
            }, 500)

            this.setTitle()

            if (isFirstRequest) {
              this.isLoadedEstimate = true
            }

            // REMOVE THIS - FOR TESTING ONLY
            //this.$set(this.estimateParts, 'PDR', []);
            //this.$set(this.removeEstimateParts, 'PDR', []);

          })
          .catch(error => {
            toastr.error('Estimate error')
            console.log(error)
            this.$router.push('/estimates')
          }).finally(() => {
        this.loadingEstimate = false
        if (isShowNProgress) {
          NProgress.done()
        }
      })
    },
    //loadSupplements: function () {
    //    let estimate_id = this.$route.params.estimate_id;
    //    Axios.get(`/fe/estimate/supplement/${estimate_id}`)
    //        .then(response => {
    //            this.supplements = response.data;
    //            if (!_.isEmpty((this.currentItemList))) {
    //                //update supp
    //                let self = this;
    //                let supp = _.find(response.data, function (s) {
    //                    return s.estimate_id == self.currentItemList.estimate_id;
    //                });
    //                this.currentItemList = supp;
    //                console.log(this.currentItemList, 'currentSupp');
    //            } else if (_.isEmpty(this.currentItemList) && this.isItemListTab) {
    //                let suppNum = this.currentTab.split('supplementItemsList')[1];
    //                let self = this;
    //                let supp = _.find(this.supplements, function (supp) {
    //                    let index = self.supplements.indexOf(supp) + 1;
    //                    return index == suppNum;
    //                });
    //                this.currentItemList = supp;
    //            }
    //        })
    //        .catch(error => {
    //            toastr.error("Error occurred while loading supplements");
    //            console.log(error, 'supp error');
    //            NProgress.done();
    //        });
    //},
    loadActivity (sort_type) {
      const estimate_id = this.$route.params.estimate_id
      let payload = { estimate_id: estimate_id }
      if (sort_type) {
        payload.sort_type = sort_type
      }
      this.$store.dispatch('loadEstimateActivity', payload).then(response => {
        if (response.status === 200) {
          this.activity = response.data
        } else if (response.status === 400) {
          toastr.error(response.data.msg)
        } else {
          toastr.warning(response.data.msg)
        }
      }).catch(error => {
        toastr.error('Error occurred while loading estimate activity')
        console.log(error)
        NProgress.done()
      })
    },
    addImage: function (img) {
      // console.log(img)
      if (img.src == '' || img.src === undefined || img.src === null) {
        return
      } else {
        this.images.unshift(img)
        this.newImageAdded = true
      }
    },
    addFile: function (file) {
      if (file.src == '' || file.src === undefined || file.src === null) {
        return
      } else {
        this.files.unshift(file)
        this.newFileAdded = true
      }
    },
    validateForm: function () {
      this.error.messages = []
      let status = false

      if (this.error.messages.length > 0) {
        status = false
      } else {
        status = true
      }
      this.error.exists = !status

      return status
    },
    onCustomerSelect: function (c) {
      // console.log(c)
      this.card.customer.customer_id = c.customer_id
      this.card.customer.name = c.customer_name
      this.card.customer.address = c.address
      this.card.customer.level_unit_lot = c.level_unit_lot
      this.card.customer.street_name = c.street_name
      this.card.customer.suburb = c.suburb
      this.card.customer.state = c.state
      this.card.customer.postcode = c.postcode
      this.card.customer.country = c.country
      this.card.customer.mobile = c.mobile
      this.card.customer.phone = c.phone
      this.card.customer.fax = c.fax
      this.card.customer.email = c.email

      this.card.vehicle.customer_vehicle_id = c.customer_vehicle_id
      this.card.vehicle.rego_number = c.rego_number
      this.card.vehicle.make = c.make
      this.card.vehicle.model = c.model
      this.card.vehicle.series = c.series
      this.card.vehicle.colour = c.colour
      this.card.vehicle.colour_variant = c.colour_variant
      this.card.vehicle.vin = c.vin

      // this.showCustomerSearchBox = false
    },
    onAssessorSelect: function (a) {
      if (a === null) {
        this.card.insurance.insurer_assessor_id = null
        this.card.insurance.assessor_email = ''
        this.card.insurance.assessor_phone = ''
      } else {
        this.card.insurance.insurer_assessor_id = a.insurer_assessor_id
        this.card.insurance.assessor_name = a.assessor_name
        this.card.insurance.assessor_email = a.assessor_email
        this.card.insurance.assessor_phone = a.assessor_phone
      }
    },
    getFocus: function (el) {
      if (el) {
        document.getElementById(el).focus()
      }
    },
    dismissError: function () {
      this.error.exists = false
    },
    refreshItemsList: function () {
      //   console.log(this.cardSubParts);
    },
    replyActivity (index) {
      const refIndex = 'activityReplyMessageRef' + index
      if (this.$refs[refIndex]) {
        this.$refs[refIndex][0].showReplyMessage(false)
      }
    },
    replyToAllActivity (index) {
      const refIndex = 'activityReplyMessageRef' + index
      if (this.$refs[refIndex]) {
        this.$refs[refIndex][0].showReplyMessage(true)
      }
    },
    changeActivitySortBy (sort_by) {
      this.activitySortTypeText = sort_by
      this.card.sort_type = sort_by
      this.loadActivity(sort_by)
    },

    beforeDebouncedAutoSave: function () {
      if (!this.isAutoSave || (!this.isAutoSaveEnable && (this.currentTab === 'vehicleDetails' || this.currentTab.includes('itemList')))) {
        console.log('return from debounce')
        return
      }
      this.debouncedAutoSave()
    },
    beforeDebouncedUnsavedChanges: function () {
      if (!this.isAutoSave || (!this.isAutoSaveEnable && (this.currentTab === 'vehicleDetails' || this.currentTab.includes('itemList')))) {
        return
      }
      this.debouncedUnsavedChanges()
    },
    closeAssignToModal () {
      document.body.classList.remove('modal-open')
      this.assignToActive = false
    },
    assignedToOpen () {
      if (!this.isStatusActive) {
        return
      }
      if (this.isMobile) {
        document.body.classList.add('modal-open')
        this.assignToActive = true
        return
      }
      setTimeout(() => {
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.filterAssigned') && !e.target.closest('.openfilterTarget') && this.$refs.AssignedfilterRef) {
            this.$refs.AssignedfilterRef.classList.remove('openFilterAssigned')
          }
        })
      }, 0)
      this.$refs.AssignedfilterRef.classList.add('openFilterAssigned')
    },
    changeAssignedName (elem) {
      let update = {}
      this.loaderAssignTo = true
      update.assignedTo = { id: elem.id }
      this.assignedToText = elem.name
      this.$refs.AssignedfilterRef.classList.remove('openFilterAssigned')
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    changedNameOfAssignedTo () {
      this.loaderAssignTo = false
      this.assignedToUser = this.assignedToText
    },
    handleItemRead: function (el) {
      const activityTabLink = this.$refs['activity-tab-link']
      if (activityTabLink && activityTabLink.classList.contains('active')) {
        const isChecked = el.target.checked ? 1 : 0
        this.$store.dispatch('updateActivityViewedStatus', {
          activity_id: el.target.id,
          card_id: this.card.card_id,
          viewed: isChecked
        })
      }
    },
    replaceCharAtCategories: function (elem) {
      return (elem.split(' ').length > 1) ?
          elem.split(' ').map(_ => _.replace(_.charAt(0), _.charAt(0))).join(' ').replace(/ /g, '_') : elem
      //elem.split(' ').map(_ => _.replace(_.charAt(0), _.charAt(0).toLowerCase())).join(' ').replace(/ /g, '_') : elem.toLowerCase()
    },
    updateImageCategory: function (info) {
      if (!info) {
        return
      }
      this.beforeDebouncedUnsavedChanges()
      let update = {}
      if (info.imgInfo) {
        let key = _.findIndex(this.image_categories, { file_id: info.imgInfo.id })
        let img = _.find(this.images, (i) => {
          return Number(i.id) == Number(info.imgInfo.id)
        })
        if (img) {
          img.category = info.categoryName
        }
        if (key >= 0) {
          this.image_categories[key] = {
            file_id: info.imgInfo.id,
            category: info.categoryName,
          }
        } else {
          this.image_categories.push({
            file_id: info.imgInfo.id,
            category: info.categoryName,
          })
        }
        update.imageCategories = this.image_categories
      }
      if (info.imagesSort) {
        update.imagesSort = info.imagesSort
        _.forEach(this.images, (img) => {
          let itm = _.find(info.imagesSort, (i) => {
            return Number(i.id) == Number(img.id)
          })
          if (itm) {
            img.sort = itm.index
          }
        })
      }
      this.setUpdateData(update)
      //console.log('updateImageCategory', update)
      this.beforeDebouncedAutoSave()
    },
    removeSupplement: function () {
      let sid = this.computedEstimateId
      Axios.post(`/fe/estimate/supplement/${sid}/remove`)
          .then((response) => {
            if (response.data && response.data._status) {
              this.tabEstimateChange('itemList' + (this.estimate.id), this.estimate.id)
              let index = _.findIndex(this.itemsList, function (i) {
                return i.id == sid
              })
              console.log('index.remove.supplement', index)
              if (index != -1) {
                this.itemsList.splice(index, 1)
              }
              this.$refs.deleteSuppModal.hide()
              toastr.success('Supplement was removed successfully')
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(() => {
        NProgress.done()
      })
    },

    saveAsTemplate () {
      let name = this.searchTemplateInput
      Axios.post(`/fe/estimate/${this.$route.params.estimate_id}/save-as-template`, { name })
          .then(response => {
            if (response.data && response.data._status) {
              toastr.success(`Template "${name}" has been created`)
              this.searchTemplateInput = ''
              sessionStorage.selectedTemplateId = response.data.templateId
            } else {
              toastr.error('Woops! Something went wrong')
              console.log('SaveAsTemplate Response: ', response.data)
            }
          }).catch(e => {
        toastr.error('Error: ' + e)
        console.error(e)
      }).finally(() => {
        this.loadEstimateTemplates()
      })
    },
    calculateTopSticky () {
      this.getPdfViewerParameters()
      this.updateCardProgressBarSmall()
      const tabsComponent = this.$refs.tabsComponent
      const pageHeader = document.querySelector('.page-header')
      const pageHeaderHeight = pageHeader ? pageHeader.offsetHeight : 75
      if (tabsComponent) {
        // site-header + page-header + tabs-component
        this.topSticky = 60 + pageHeaderHeight + this.$refs.tabsComponent.offsetHeight
      } else {
        // default
        this.topSticky = 0
      }
    },
    updateHeightOptionsMenu (event) {
      if (document.body.offsetHeight <= 750) {
        this.heightOptions = document.body.offsetHeight - event.clientY - 30
      }
      if (!isMobile) {
        setTimeout(() => {
          this.setHeightForSaveTemplateMenu()
          this.setHeightForAddTemplateMenu()
        }, 100)
      }
    },
    changeOrientation () {
      if (window.screen.orientation.type == 'portrait-primary' || window.screen.orientation.type == 'portrait') {
        window.scrollTo(0, 0)
      }
      if (window.screen.orientation.type == 'landscape-primary' || window.screen.orientation.type == 'landscape') {
        window.scrollTo(0, 0)

      }
    },
    copyEstimateModal: function () {
      this.copyEstimate.copyToCardId = 0
      this.copyEstimate.copyToCard = {}
      this.copyEstimate.isCopyImages = false
      this.copyEstimate.isCopyFiles = false

      this.$refs.copyEstimateModal.show()
    },
    completeCopyEstimate: function () {
      this.$refs.copyEstimateModal.hide()
      NProgress.start()

      if (this.copyEstimate.copyToCard && this.copyEstimate.copyToCard.cardId && this.copyEstimate.copyToCard.cardId > 0) {
        this.copyEstimate.copyToCardId = this.copyEstimate.copyToCard.cardId
      }
      this.copyEstimate.isNew = false
      this.copyEstimate.isCopyEstimateValuesOnly = true
      delete this.copyEstimate.copyToCard
      Axios({
        method: 'post',
        responseType: 'json',
        url: `/fe/card/${this.card.card_id}/copy-card`,
        validateStatus: function (status) {
          return status < 500
        },
        data: this.copyEstimate,
      }).then(response => {
        if (response.status === 200 && response.data._status) {
          toastr.success('Duplicate Estimate ' + this.estimate.estimate_number + ' has been copied successfully')
          this.$router.push({ name: 'EstimatesEdit', params: { estimate_id: response.data.estimateId } })
          return
        } else {
          toastr.error(response.data.msg)
        }
        this.loadActivity()
      })
          .catch(error => {
            toastr.error(error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
  },
  computed: {
    ...mapGetters({
      partCategories: 'partCategories',
      addressStates: 'addressStates',
      addressCountries: 'addressCountries',
      isTechnicalUser: 'isTechnicalUser',
      isCustomerUser: 'isCustomerUser',
      isEstimatorUser: 'isEstimatorUser',
      isPDRTechnicianUser: 'isPDRTechnicianUser',
      isDisplayBoardUser: 'isDisplayBoardUser',
      isDetailerUser: 'isDetailerUser',
      isStripperFitterUser: 'isStripperFitterUser',
      isPanelTechnicianUser: 'isPanelTechnicianUser',
      isPaintTechnicianUser: 'isPaintTechnicianUser',
      isShopManagerUser: 'isShopManagerUser',
      isProductionManagerUser: 'isProductionManagerUser',
      butterflyCategories: 'butterflyCategories',
      butterflyMatrix: 'butterflyMatrix',
      butterflyCustomMatrix: 'butterflyCustomMatrix',
      butterflySubcategories: 'butterflySubcategories',
      butterflyBodies: 'butterflyBodies',
      butterflyMatrixOrder: 'butterflyMatrixOrder',
      getterActiveUsers: 'activeUsers',
      getterVisibleUsers: 'visibleUsers',
      isStatusActive: 'isStatusActive',
      getterBusinessName: 'getBusinessName',
      customerVehicles: 'getAllCustomers',
      getterAllEstimates: 'estimate/getAllEstimates',
      pcs: 'pcs',
      getterCameraCount: 'getCameraCount',
      vendorInfo: 'vendorInfo',
      userInfo: 'userInfo',
      isFreePlan: 'isFreePlan',
      ceStatuses: 'ceStatuses',
      isBusinessTypeBikeRepairer: 'isBusinessTypeBikeRepairer',
    }),
    isLoadingAiInState () {
      const id = Number(this.card_id)
      return this.$store.getters['aiVehicle/getRequestStatus'](id)
    },
    resAiInstate () { return this.$store.getters['aiVehicle/response'] },
    wasAiRequestSent () {
      const id = this.$route.params.estimate_id
      const estimate = this.itemsList.find(item => item.id == id)
      const aiRes = !!estimate?.AI || false
      return aiRes
    },
    isAudaContractedCompany () {
      return (this.properties?.isAudaContractedCompany === true)
    },
    isBlockByAuda () {
      return (this.properties?.isBlockByAuda === true)
    },
    isViewRunDamageAssmnt () {
      return this.properties?.copilot?.damage || false
    },
    computedEstimateForcopyEstimate () {
      let d = _.map(this.getterAllEstimates, (e) => {
        return {
          cardId: e.card_id,
          label: e.estimate_number + (e.rego_number ? ' - ' + e.rego_number : '') + (e.insurer_name ? ' - ' + e.insurer_name : '')
        }
      })
      let estimateIndex = _.findIndex(d, (e) => {
        return Number(e.id) == Number(this.estimate.id)
      })
      if (estimateIndex !== -1) {
        d.splice(estimateIndex, 1)
      }
      return d
    },
    isDisabledOnSiteSelects () {
      this.computedOnSiteSelect
      return !!(!this.isStatusActive || this.isDisabledFieldsByUserRole || this.plannerBoard.onSite.isAttendedBooking)
    },
    isDisabledFieldsByUserRole () {
      return this.isPanelTechnicianUser || this.isPaintTechnicianUser || this.isStripperFitterUser || this.isDetailerUser || this.isTechnicalUser || this.isPDRTechnicianUser
    },
    categoryOptions () {
      let groups = this.categories.slice()
      let emptyCategoryIndex = _.findIndex(this.categories, (gr) => {
        return gr.id === null
      })
      if (emptyCategoryIndex === -1) {
        groups.unshift({ name: 'No Category', id: null, color: '#5f9fa0', isSetColor: false, isOpenColorPicker: false })
      }
      return groups
    },
    computedBookingBoardCategory: {
      get: function () {
        if (this.plannerBoardGroupId) {
          return this.plannerBoardGroupId
        }
        try {
          let groupId = this.plannerBoard?.vehicle?.groupId
          let item = _.find(this.categoryOptions, (opt) => {
            return opt.id === groupId
          })
          return item
        } catch (e) {
          console.log('E.computedBookingBoardCategory', e)
          return {}
        }
      },
      set: function (item) {
        if (item && Object.prototype.hasOwnProperty.call(item, 'id')) {
          this.plannerBoardGroupId = item
          if (this.plannerBoard?.vehicle) {
            this.plannerBoard.vehicle.groupId = item.id
          }
        } else {
          this.plannerBoardGroupId = null
          if (this.plannerBoard?.vehicle) {
            this.plannerBoard.vehicle.groupId = null
          }
        }
        console.log('computedBookingBoardCategory', item)
      }
    },
    isShowAuthOption () {
      let b = !this.isAuthorisePage[this.currentItemListId] && this.isStatusActive
      if (!b) {
        return false
      }
      if (this.isItemListTab && this.isEstimateItemList) {
        return true
      }
      if (!_.isEmpty(this.itemsList)) {
        return true
      }
      return false
    },
    computedSelectedSchemeParts () {
      if (!_.isEmpty(this.selectedSchemeParts)) {
        let notPickedArray = []
        let methodology = this.estimate?.rates?.estimate_methodology
        if (methodology == 'ltar' || methodology == 'ntar') {
          notPickedArray = [
            'L/H FRONT STRUCTURE',
            'R/H FRONT STRUCTURE',
            'L/H REAR STRUCTURE',
            'R/H REAR STRUCTURE',
            'REAR BODY PANEL',
            'UNITARY TIMES',
          ]
        } else if (methodology == 'zi') {
          notPickedArray = [
            'MISCELLANEOUS',
            'CHASSIS FRONT',
            'BEAVER PANEL',
            'MECHANICAL',
            'BOOT FLOOR',
            'VAN',
            'UTE',
          ]
        } else if (methodology == 'custom') {
          notPickedArray = [
            'CHASSIS FRONT',
            'TAILGATE',
            'BEAVER PANEL',
            'BOOT FLOOR',
            'MISCELLANEOUS',
            'TRUCK',
          ]
        } else if (methodology == 'dollars') {
          notPickedArray = [
            'R/H SILL PANEL',
            'L/H FRONT STRUCTURE',
            'R/H FRONT STRUCTURE',
            'UNITARY TIMES',
            'L/H REAR STRUCTURE',
            'R/H REAR STRUCTURE',
            'REAR BODY PANEL',
          ]
        }
        return _.concat(notPickedArray, this.selectedSchemeParts,)
      }
      return this.selectedSchemeParts
    },
    isCanShowSchemeParts () {
      if (!this.card?.vehicle?.body) {
        return false
      }
      let body = _.toLower(this.card.vehicle.body)
      return body == 'suv' || body == 'sedan' || body == 'hatch' || body == 'wagon' || body == '5 door' || body == '3 door'
    },
    disabledDates() {
      let arr = []

      _.forEach([true, true, true, true, true, true, true], (d, ind) => {
        if (!d) {
          arr.push(ind + 1)
        }
      })

      if (_.isEmpty(arr)) {
        return  {}
      }
      return { weekdays: arr }
    },
    isDisabledOnSiteSelects () {
      this.computedOnSiteSelect++
      return !!(!this.isStatusActive || this.plannerBoard.onSite.isAttendedBooking)
    },
    additionalMenu () {
      if (_.isEmpty(this.searchFilter)) {
        return []
      }
      let data = _.filter(this.getterAllEstimates, (r) => {
        return _.startsWith(_.trim(_.toLower(r.estimate_number)), _.trim(_.toLower(this.searchFilter))) ||
            _.startsWith(_.trim(_.toLower(r.rego_number)), _.trim(_.toLower(this.searchFilter))) ||
            _.includes(_.trim(_.toLower(r.customer_name)), _.trim(_.toLower(this.searchFilter)))
      })
      let result = []
      _.forEach(data, (itm) => {
        let label = itm.estimate_number
        if (itm.rego_number) {
          label += ' - '
        }

        if (itm.rego_number) {
          label += itm.rego_number + ' '
        }

        if (itm.dom) {
          if (itm.dom.length == 6) {
            let stg = ''
            stg = itm.dom.at(-2) + itm.dom[itm.dom.length - 1] + '/' + itm.dom.slice(2, 4)
            itm.dom = stg
          }
          if (itm.dom.length == 7 && itm.dom[2] == '/') {
            let stg = ''
            stg = itm.dom.slice(0, 3) + itm.dom.slice(5, 7)
            itm.dom = stg
          }
        }

        result.push({
          value: itm.estimate_id,
          label: label,
          estimateNumber: itm.estimate_number,
          regoNumber: itm.rego_number,
          customerName: itm.customer_name,
          insurerName: itm.insurer_name,
          make: itm.make,
          model: itm.model,
          buildDate: itm.dom,
        })
      })
      result = _.orderBy(result, ['label'], ['asc']).slice(0, 10)
      return result
    },
    isEstimateMethodologyDollars () {
      this.callRatesUpdate++
      return this.estimateRates.estimate_methodology == 'dollars'
    },
    computedApproximateDays () {
      this.callApproximateDaysComputed++
      let r = 0
      if (this.productionTime.category) {
        let cat = _.find(this.properties?.production?.definitions?.categories, (c) => {
          return c.id == this.productionTime.category
        })
        if (cat) {
          r += Number(cat.count)
        }
      }
      if (this.productionTime.isCheckWeld) {
        r += Number(this.properties.production.definitions.numberOfDays.weld) * this.productionTime.weldQty
      }
      if (this.productionTime.isCheckMechanical) {
        r += Number(this.properties.production.definitions.numberOfDays.mechanical)
      }
      if (this.productionTime.isCheckHail) {
        r += Number(this.properties.production.definitions.numberOfDays.hail)
      }
      if (this.productionTime.isCheckElectrical) {
        r += Number(this.properties.production.definitions.numberOfDays.electrical)
      }
      if (this.productionTime.isCheckPpf) {
        r += Number(this.properties.production.definitions.numberOfDays.ppf)
      }
      if (this.productionTime.isCheckAccessories) {
        r += Number(this.properties.production.definitions.numberOfDays.accessories)
      }

      return r
    },
    computedCategories () {
      return _.map(this.properties?.production?.definitions?.categories, (c) => {
        return c.id
      })
    },
    isShowBigImage () {
      return this.$route.name == 'EstimatesEditImage'
    },
    isShowSendToInsurer () {
      let supp = _.find(this.itemsList, (s) => {return Number(s.id) == Number(this.computedEstimateIdForInsurance)})
      return (((this.isShopManagerUser || this.isProductionManagerUser || this.isEstimatorUser) && this.isInsuranceRepairYes && this.isStatusActive) ||
          (this.properties.isFromIag && this.vendorInfo?.features?.integrations?.orm) ||
          (this.properties.isFromEio) || (this.properties.isFromAudaBridge || this.properties.isFromAudaNet)) && supp && !supp.isAuthorised
    },
    isDisabledRates () {
      return (this.properties.isFromIag || this.properties.isFromEio || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && this.properties.isRatesEditable === false
    },
    isDisabledRatesRR () {
      return ((this.properties.isFromIag || this.properties.isFromEio || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && this.properties.isRatesRREditable === false)
    },
    isDisabledRatesRepair () {
      return (this.properties.isFromIag || this.properties.isFromEio || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && this.properties.isRatesRepairEditable === false
    },
    isDisabledRatesPaint () {
      return (this.properties.isFromIag || this.properties.isFromEio || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && this.properties.isRatesPaintEditable === false
    },
    isSmsAvailable () {
      return this.properties.isSmsFeatureEnabled
    },
    filteredStatusList () {
      let currentIndex = this.card?.statuses?.findIndex(
          (status) => Number(status.id) === Number(this.card.card_status)
      )
      if (this.card?.statuses?.length <= 4) return this.card?.statuses

      const statusCount = this.card?.statuses?.length
      const index = currentIndex

      if (index < 3) {
        // on minimal
        return this.card?.statuses?.slice(0, 4)
      } else if ((statusCount - index + 1) < 5) {
        // on maximum
        return this.card?.statuses?.slice(-4)

        // everything in between
      } else {
        return this.card?.statuses?.slice((index - 1) % 2 == 0 ? index - 1 : index - 2, (index + 2) % 2 == 0 ? index + 2 : index + 3)
      }
    },
    computedEstimateMethodologies () {

      let em = this.estimateMethodologies.slice()
      //   if(this.isBusinessTypeBikeRepairer){
      //   return em.filter((m) => m.key == 'custom')
      // }
      if (this.isRsEnabled) {
        em.push({ key: 'rs', value: 'RS' })
      }
      return em
    },
    boardInId () {
      if (this.boardIn && this.boardIn.id) {
        return this.boardIn.id
      }
      return ''
    },
    boardDepartureId () {
      if (this.boardDeparture && this.boardDeparture.id) {
        return this.boardDeparture.id
      }
      return ''
    },
    isShowImportPdfForParts () {
      return Boolean((this.isShopManagerUser || this.isProductionManagerUser || this.isEstimatorUser || this.isCustomerUser)
          && this.isItemListTab
          && this.allowShowImportPdfParts[this.computedEstimateId] === true)
    },
    orderedItemsList () {
      return _.orderBy(this.itemsList, ['type', 'supplementNumber'], ['asc', 'asc'])
    },
    computedTimesForItemPart () {
      return this.timesForItemPart
    },
    isItemListTab () {
      return this.currentTab.includes('itemList')
    },
    isEstimateItemList () {
      let itemsList = this.getItemList(this.currentItemListId)
      return !!(this.isItemListTab && itemsList && itemsList.type == 'estimate')
    },
    isSupplementItemListTab () {
      return !!(this.isItemListTab && !this.isEstimateItemList)
    },
    computedTemplateId () {
      if (this.isItemListTab) {
        let itemsList = this.getItemList(this.currentItemListId)
        if (!_.isEmpty(itemsList)) {
          return itemsList.templateId
        }
      }
      return 0
    },
    isHasTemplates () {
      let itemsList = this.getItemList(this.currentItemListId)
      return !!(this.isItemListTab && itemsList && itemsList.templateId > 0)
    },
    computedSupplementNumber () {
      if (!this.isSupplementItemListTab) {
        return 0
      }
      let itemsList = this.getItemList(this.currentItemListId)
      return itemsList ? itemsList.supplementNumber : ''
    },
    computedEstimateId () {
      let estimateId = this.estimate.id

      if (this.isSupplementItemListTab) {
        estimateId = this.currentTab.split('itemList')[1]
        //estimateId = this.itemsList[Number(index) - 1].id;
      }
      return estimateId
    },
    computedEstimateIdForInsurance () {
      let estimateId = this.estimate.id
      let suppId = _.find(this.itemsList, (s) => {
        return s.type == 'supplement'
      })?.id

      if (this.isSupplementItemListTab) {
        return this.currentTab.split('itemList')[1]
      }
      if (suppId && !_.includes(this.currentTab, 'itemList')) {
        return suppId
      }
      return estimateId
    },
    computedEstimateAmount () {
      let result = 0
      let vm = this
      _.forEach(this.itemsList, function (supp) {
        if (supp.amount) {
          result += vm.pT(supp.amount)
          // console.log('computedEstimateAmount.forEach', result, parseFloat(supp.amount), vm.pT(supp.amount), supp.amount)
        }
      })
      //let gst = _.round((result * 0.1),2);
      //result = (gst+result);
      return result
    },
    isShowSaveButtonInCurrentTab () {
      return true
    },
    isAutoSaveEnable () {
      if (this.properties && this.properties.hasOwnProperty('isAutoSave')) {
        return this.properties.isAutoSave
      }
      return true
    },
    computedActiveUsers () {
      if (!this.filterAssignTo || this.filterAssignTo == '') {
        let users = this.getterVisibleUsers.slice()
        users.unshift({
          id: null,
          name: 'None',
          groupId: null,
          group_id: null,
          isActive: true,
          isVisible: true,
          lastName: null,
          firstName: null,
          role: null,
        })
        return users
      }
      let self = this
      let filterUsers = _.filter(this.getterVisibleUsers, function (user) {
        let search = []
        search.push(_.toLower(user.name))
        return !!(search.join(',').indexOf(_.toLower(self.filterAssignTo)) > -1)
      })
      return filterUsers
    },
    isRSEstimateMethodology () {
      this.backdoor
      return !!(this.isRsEnabled && this.estimate?.rates?.estimate_methodology == 'rs')
    },
    isEstimateMethodologyLTARNTAR () {
      this.backdoor
      return this.estimate?.rates?.estimate_methodology == 'ltar' || this.estimate?.rates?.estimate_methodology == 'ntar'
    },
    computedRepairCategory: {
      get: function () {
        let vm = this
        try {
          let item = _.find(this.properties?.production?.categories, function (itm) {
            return Number(itm.id) === Number(vm.estimate.production.category)
          })
          return item
        } catch (e) {
          return {}
        }
      },
      set: function (item) {
        this.estimate.production.category = item.id
      },
    },
    isZurichEstimateMethodology () {
      this.backdoor
      return (this.estimate?.rates?.estimate_methodology == 'zi')
    },
    computedEstimateMethodology: {
      get: function () {
        this.backdoor
        let vm = this
        try {
          let item = _.find(this.computedEstimateMethodologies, function (itm) {
            return itm.key.toLowerCase() === vm.estimateRates.estimate_methodology.toLowerCase()
          })
          return item
        } catch (e) {
          return { key: 'custom', value: 'Custom' }
        }
      },
      set: function (item) {
        this.estimateRates.estimate_methodology = item.key
        this.backdoor++
      },
    },
    computedCustomerState: {
      get: function () {
        let vm = this
        try {
          let item = _.find(this.addressStates, function (itm) {
            return itm.key === vm.card.customer.state
          })
          return item
        } catch (e) {
          return {}
        }
      },
      set: function (item) {
        this.card.customer.state = item.key
      },
    },
    computedCustomerCountry: {
      get: function () {
        let vm = this
        try {
          let item = _.find(this.addressCountries, function (itm) {
            return itm.key === vm.card.customer.country
          })
          return item
        } catch (e) {
          return []
        }
      },
      set: function (item) {
        this.card.customer.country = item.key
      },
    },
    isInsuranceRepairYes: function () {
      if (this.card.insurance_repair == 'true') {
        return true
      }
      return false
    },
    isShowPaintRateForCustomMethodology: function () {
      return !!(this.isEstimateMethodologyCustom && this.isInsuranceRepairYes)
    },
    isInsuranceRepairNo: function () {
      if (this.card.insurance_repair == 'false') {
        return true
      }
      return false
    },
    isInsuranceRepairOther: function () {
      if (this.card.insurance_repair == 'other' || this.card.insurance_repair == '2') {
        return true
      }
      return false
    },
    isNoNeedVehicleRego: function () {
      if (this.isInsuranceRepairOther) {
        return true
      }
      return false
    },
    showUpperRegoNumber: {
      get: function () {
        return _.toUpper(this.card.vehicle.rego_number)
      },
      set: function (rego) {
        this.card.vehicle.rego_number = _.toUpper(rego)
      }
    },
    totalNotes: function () {
      return this.notes.length
    },
    showButtonInHeaderForInsurerModal: function () {

    },
    isEstimateMethodologyCustom: function () {
      this.backdoor
      if (this.estimateRates.estimate_methodology == 'custom') {
        return true
      }
      return false
    },
    isInsurance: function () {
      return (this.card?.insurance_repair === 'true')
    },
    isExcess: function () {
      return (this.isInsurance && this.card?.insurance?.excess > 0)
    },
    isExcessToNil () {
      return (this.isInsurance && this.card?.insurance?.excess === null)
    },
    isTotalLoss: function () {
    },
    isShowMarkAsRead () {
      if (_.find(this.activity, { 'viewed': '0' })) {
        return true
      }
      return false
    },
    isShowRedMessageForBody: function () {
      if (this.computedBodies && this.computedBodies.length > 0 && this.card.vehicle.body === '') {
        return true
      }
      return false
    },
    isShowRedBorderForPaintMaterial: function () {
      if (this.isShowPaintMaterialNotification && !this.isShowRedBorderIfNewPaintColour && !this.isEstimateMethodologyCustom && this.estimateRates.paint_material === 'not_set') {
        return true
      }
      return false
    },
    isShowRedBorderIfNewPaintColour: function () {
      if (this.isShowNewPaintColourNotification) {
        return true
      }
      return false
    },
    currentSeriesSheduleNumber: function () {
      if (this.card.vehicle.series_shedule_number) {
        return this.card.vehicle.series_shedule_number
      } else {
        return this.computedSheduleNumber
      }

      return null
    },
    imageSource: function () {
      let images = _.orderBy(this.images, ['id'], ['desc'])
      images = _.orderBy(images, [(itm) => Number(itm.sort)], ['asc'])
      let _uncategoriesArr = [],
          _dataObj = {}
      Array.from(this.uploadImageCategories).forEach(el => {
        _dataObj[this.replaceCharAtCategories(el)] = []
      });
      [].slice.call(Array.from(images)).forEach((el, ind) => {
        if (!el.hasOwnProperty('category') || !el.category || this.replaceCharAtCategories(el.category) === 'Uncategorised') {
          _uncategoriesArr.push(el)
          _dataObj.Uncategorised = _uncategoriesArr
        } else {
          let _categReplace = this.replaceCharAtCategories(el.category)
          _dataObj[_categReplace].push(el)
        }
      })
      console.log(
          'imageSource', _dataObj
      )
      this.resultSortingImages = _dataObj

      return this.resultSortingImages
    },
    totalImages: function () {
      return this.images.length
    },
    totalFiles: function () {
      return this.files.length
    },
    totalSupplements: function () {
      return this.supplements.length
    },
    customers: function () {
      return this.$store.state.customers
    },
    insurerAssessors: function () {
      try {
        if (this.card.insurance.insurer_id) {
          return this.assessors[this.card.insurance.insurer_id]
        }
        return []
      } catch (erro) {
        return []
      }
    },
    fromFiles: function () {
      if (!this.files) return 0
      else return (this.cardsCurrentPage - 1) * this.cardsPerPage + 1
    },

    toFiles: function () {
      const toFiles = (this.cardsCurrentPage - 1) * this.cardsPerPage + this.cardsPerPage
      if (toFiles > this.totalFiles) return this.totalFiles
      return toFiles
    },

    showClaimLinqButton: function () {
      let val = (
          this.card.insurance.insurer_id
          && (this.isShopManagerUser || this.isProductionManagerUser || this.isEstimatorUser)
      )

      // console.log("INSURER: " + this.card.insurance.insurer_id + ', VAL: ' + (val ? 'true' : 'false'));

      return val
    },
  },
  watch: {
    isLoadingAiInState: {
      handler (v) {
        if (v === 'pending') {
          this.loadResAi = true
        }
        if (v === 'done') {
          this.loadEstimate(this.estimate.id)
          this.loadNotes()
          this.loadResAi = false
        }
        if (v === 'error') {
          this.loadResAi = false
        }
        if (v === 'idle') {
          this.loadResAi = false
        }
      },
      immediate: true
    },
    boardIn: {
      deep: true,
      handler () {
        this.syncBoardsSelection()
      }
    },
    boardDeparture: {
      deep: true,
      handler () {
        this.syncBoardsSelection()
      }
    },
    'plannerBoard.vehicle.id': function () {
      this.syncBoardsSelection()
    },
    partCategories: {
      handler () {
        let localVParts = JSON.parse(localStorage.getItem('estimateSchemes'))?.[this.$route.params.estimate_id]?.cat
        let localVBody = JSON.parse(localStorage.getItem('estimateSchemes'))?.[this.$route.params.estimate_id]?.body
        if (!_.isEmpty(localVParts) && localVBody == _.toLower(this.card.vehicle.body)) {
          this.selectedSchemeParts = localVParts
        } else {
          this.selectedSchemeParts = []
        }
      },
      immediate: true
    },
    getterCameraCount: {
      handler (v) {
        console.log('vvvv', v)
        if (v) {
          this.isShowCamera = true
        }
      },
      deep: true
    },
    ceStatuses: {
      handler () {
        this.$nextTick(() => {
          this.updateCardProgressBar()
        })
      },
      immediate: true
    },
    file_ids: function () {
      this.beforeDebouncedUnsavedChanges()
    },
    image_ids: function () {
      this.beforeDebouncedUnsavedChanges()
    },
    image_categories: function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.name': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.mobile': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.email': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.customer_type': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.abn': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.address': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.level_unit_lot': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.street_name': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.suburb': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.state': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.postcode': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.country': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer_contact_2': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.dom': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.rego_number': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.make': function () {
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.model': function () {
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.badge': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.series': function () {
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.series_shedule_number': function () {
      console.log('test.series_shedule_number', this.card.vehicle.series_shedule_number)
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.colour': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.body': function () {
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.vin': function () {
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.odometer': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.complianceDate': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.transmission': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance_repair': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.id': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.insurance_claim_type': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.insurer_id': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.insurer_name': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.insurer_location': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.insurer_assessor_id': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.assessor_name': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.assessor_email': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.assessor_phone': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.policy_number': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.claim_number': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.assessment_date': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.excess': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.contribution': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.discount': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.market_value': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.agreed_value': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.statuses': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.card_status': function () {
      this.updateCardProgressBar()
    },
    // 'card.insurance.rates': {
    //   deep: true,
    //   handler (newVal, oldVal) {
    //     if (!this.isAutoSave) {
    //       return
    //     }
    //     console.log('card.insurance.rates', newVal, oldVal)
    //     this.estimateRates.estimate_methodology = _.toLower(this.card.insurance.rates.estimate_methodology)
    //     this.estimateRates.rr = this.card.insurance.rates.estimate_rates_rr || 0
    //     this.estimateRates.mechanical = this.card.insurance.rates.estimate_rates_mechanical || 0
    //     this.estimateRates.repair = this.card.insurance.rates.estimate_rates_repair || 0
    //     if (_.toLower(this.card.insurance.rates.estimate_methodology) === 'custom') {
    //       if (this.estimateRates.paint_material == 'not_set' || !(this.estimateRates.paint_material)) {
    //         this.estimateRates.paint = 0
    //       } else {
    //         this.estimateRates.paint = this.card.insurance.custom_paint_times[this.estimateRates.paint_material.toLowerCase()] || 0
    //       }
    //     } else {
    //       this.estimateRates.paint = this.card.insurance.rates.estimate_rates_paint || 0
    //     }
    //     this.estimateRates.rs_rr_percentage = this.card.insurance.rates.estimate_rates_rs_rr_percentage || this.defaultValues.rates.rs.default_rates_rs_rr_percentage
    //     this.estimateRates.rs_paint_percentage = this.card.insurance.rates.estimate_rates_rs_paint_percentage || this.defaultValues.rates.rs.default_rates_rs_paint_percentage
    //     this.backdoor++
    //     this.autoUpdateRates()
    //   }
    // },
    // 'estimateRates.estimate_methodology': function () {
    //   if (!this.isAutoSave) {
    //     return
    //   }
    //   console.log('wather.methodology', this.estimateRates.estimate_methodology)
    //   if (!this.isEstimateMethodologyCustom) {
    //     this.loadTimesForItemPart()
    //   }
    //   this.beforeDebouncedUnsavedChanges()
    // },
    // 'estimateRates.rr': function () {
    //   if (!this.isAutoSave) {
    //     return
    //   }
    //   this.beforeDebouncedUnsavedChanges()
    // },
    // 'estimateRates.mechanical': function () {
    //   if (!this.isAutoSave) {
    //     return
    //   }
    //   this.beforeDebouncedUnsavedChanges()
    // },
    // 'estimateRates.repair': function () {
    //   if (!this.isAutoSave) {
    //     return
    //   }
    //   this.beforeDebouncedUnsavedChanges()
    // },
    // 'estimateRates.paint': function () {
    //   if (!this.isAutoSave) {
    //     return
    //   }
    //   this.beforeDebouncedUnsavedChanges()
    // },
    // 'estimateRates.partmarkup': function () {
    //   if (!this.isAutoSave) {
    //     return
    //   }
    //   this.beforeDebouncedUnsavedChanges()
    // },
    // 'estimateRates.paint_material': function () {
    //   console.log('UPD!!estimateRates.paint_material')
    //   console.log(this.estimateRates.paint_material)
    //   if (_.toLower(this.card.insurance.rates.estimate_methodology) === 'custom') {
    //     if (this.estimateRates.paint_material == 'not_set' || !(this.estimateRates.paint_material)) {
    //       this.estimateRates.paint = 0
    //     } else {
    //       this.estimateRates.paint = this.card.insurance.custom_paint_times[this.estimateRates.paint_material.toLowerCase()] || 0
    //     }
    //   }
    //
    //   if (!this.isAutoSave) {
    //     return
    //   }
    //   this.autoUpdatePaintMaterial()
    // },
    // backdoor () {
    // console.log('backdoor UPD')
    //  if (!this.isAutoSave) {
    //    return
    //  }
    //this.autoUpdatePaintMaterial()
    // this.beforeDebouncedUnsavedChanges()
    // },
    //'estimate.dateCreated': function (newVal) {
    //    if (!this.isAutoSave) {
    //        return;
    //    }
    //    if (newVal) {
    //        this.autoUpdateEstimateDateCreated();
    //        this.beforeDebouncedUnsavedChanges();
    //    }
    //},
  },
  beforeDestroy () {
    if (this.intervalUpdateImages !== null) {
      clearInterval(this.intervalUpdateImages)
    }
    if (this.intervalUpdateScannerFiles !== null) {
      clearInterval(this.intervalUpdateScannerFiles)
    }
    if (this.checkConnectedPcsIntervalId !== null) {
      clearInterval(this.checkConnectedPcsIntervalId)
    }
    this.setTitle(true)
  },
  mounted: function () {
    this.loadCategories()
    this.checkConnectedPcsIntervalId = setInterval(() => {
      this.getConnectedPcs()
    }, this.checkConnectedPcsInterval)
    this.getConnectedPcs()
    this.loadItemsList(this.$route.params.estimate_id)
    if (this.$route.name == 'EstimatesEditImage') {
      this.currentTab = 'images'
      let body = document.querySelector('body')
      if (!_.includes(body.classList, 'compact-sidebar')) {
        body.classList.add('compact-sidebar')
      }
    } else if (this.$route.params.tab) {
      this.currentTab = this.$route.params.tab
    } else if (!_.isEmpty(this.$storage.get('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView'))) {
      this.currentTab = this.$storage.get('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView')
    }
    if (this.currentTab.includes('itemList')) {
      this.currentItemListId = this.currentTab.split('itemList')[1]
    }
    this.loadEstimate(this.$route.params.estimate_id, false, true, true)
    this.setTitle()
    this.loadActivity()

    let params = this.$route.params
    this.$nextTick(() => {
      if (params && params.action && params.action == 'goToTask') {
        this.activityTabChange()
      }
    })

    this.intervalUpdateImages = setInterval(() => {
      this.checkUpdate()
    }, 5000)

    this.calculateTopSticky()
    this.changeOrientation()
    window.addEventListener('resize', this.calculateTopSticky)
    window.addEventListener('orientationchange', this.changeOrientation)
    this.getPdfViewerParameters()
  },
  unmounted () {
    window.removeEventListener('resize', this.calculateTopSticky)
    window.removeEventListener('orientationchange', this.changeOrientation)
  },
  created () {
    this.debouncedAutoSave = _.debounce(this.autoSave, 500)
    this.debouncedAutoSaveScheduling = _.debounce(this.flushSchedulingUpdate, 500)
    this.debouncedUnsavedChanges = _.debounce(this.showUnsavedChanges, 100)
    this.debouncedAutoUpdateFile = _.debounce(this.autoUpdateFile, 500)
  },
  components: {
    CarScheme,
    QRCode,
    assignToModal,
    SearchFilter2,
    SearchFilter,
    ItemList,
    EstimateSupplements,
    FileUploader,
    ImageLightbox,
    SiteFooter,
    NumberFormatter,
    AdvancedSearch,
    ImageSelector,
    DatePicker,
    VueTimepicker,
    draggable,
    AmazonAds,
    ActivityReplyMessage,
    vueDropzone: vue2Dropzone,
    VueContext,
    GoogleLocation,
    FormWizard,
    TabContent,
    WizardStep,
    Multiselect,
    ActivityList,
    CardNotes,
    CardFiles,
    InsuranceBlock,
    WebCamera,
    PdfViewer,
    VehicleBlock,
    RsFormWizard,
    SmallFormWizard,
    RsRipple,
    BlockPagination,
    AdvertBanner,
    AssessmentAuth,
    ModalNote,
    EstimateRates,
  }
}
</script>

<template>
  <web-camera
      v-if="isShowCamera"
      @close="isShowCamera = false"
      :is-estimate="true"
      :estimateId="$route.params.estimate_id"
      :imageIds="getImagesForCamera()"
  ></web-camera>
  <div v-else class="estimates-edit-page" :class="{'is-mobile-only': isMobileOnly}">
    <div class="page-header" id="pageHeaderEst" :class="{ 'page-header-mobile': isMobileOnly }">
      <h4 style="height: auto"><span v-if="!isMobile">Estimate</span><span v-else>Est</span> - {{ estimate_number }}
        <span
            v-if="supplement_number">-{{ supplement_number }}</span> <span
            class="text-muted"> | </span> {{ card.customer.name }} <span
            class="text-muted"> | </span>
        {{ showUpperRegoNumber }}
        <span v-if="card.insurance.insurer_name !== ''"><span class="text-muted">|</span> {{
            card.insurance.insurer_name
          }}</span>
        <span v-if="card.insurance.claim_number !== '' && !isMobileOnly"
              class="claim-number-vertical-display"> - {{ card.insurance.claim_number }}</span>
        <!--                <span class="autosave" v-if="isAutoSaveEnable || !(currentTab === 'vehicleDetails' || currentTab.includes('itemList')">{{autoSaveMessage}}</span></h4>-->
        <span class="autosave"
              :class="{ 'autosave-saved': autoSaveMessage == 'Saved', 'autosave-not-mobile': !isMobile }"
              v-if="isAutoSaveEnable && !isMobileOnly">{{ autoSaveMessage }}</span></h4>
      <ol class="breadcrumbs">
        <li class="breadcrumb-item">
          <router-link to="/">Home</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link :to="'/estimates'">View Estimates</router-link>
        </li>
        <li v-if="parent_estimate_id" class="breadcrumb-item">
          <router-link :to="'/estimates/view/' + parent_estimate_id">{{ estimate_number }}</router-link>
        </li>
        <li class="breadcrumb-item active">Edit Estimate</li>
      </ol>
      <template slot="nav-item-right" v-if="!isMobile"
                style="display: block; float: right; position: absolute; right: 15px; top: 18px">
        <div class="tabs-nav-right-search tabs-nav-right-search-font-weight" style="min-width: 362px !important">
          <i v-if="!isMobile" @click="isShowQrCode = true" class="bx bx-qr"
             style="font-size: 41px; cursor: pointer"></i>
          <search-filter2
              type="estimates"
              class="search-filter"
              v-model="searchFilter"
              :limitLength="50"
              :filterValue="searchFilter"
              @selectAdditional="redirectToEstimateEdit"
              @onEnter="onEnter"
              :placeholder="'Search'"
              :additionalMenu="additionalMenu"
              style="width: 100%; padding-left: 10px !important;"
              :isIgnoreSiteAndPageHeader="true"
              :debug="false"
              height="41px"
              aria-expanded="false"
              data-toggle="dropdown">
          </search-filter2>
          <q-r-code v-if="isShowQrCode" :value="card.card_number" :size="190"
                    style="z-index: 999; position: absolute; left: -154px;" v-click-outside="hideQrCode"></q-r-code>
        </div>
      </template>
      <div class="desktop-b-promo-block estimare-header-b-promo">

      </div>
      <div v-if="!isMobileOnly" style="margin-right: 5px" class="page-header-nav-pin-images">
        <label class="form-check-inline checkbox"
               v-b-tooltip.hover="{customClass: 'ps-tooltip', title:'Click to view images', placement:'left'}">
          <input class="form-check-input" name="pinimage" v-model="pinImage" type="checkbox">
          <span class="icon"><i class='bx bx-check'></i></span><span class="text">Pin Images</span>
        </label>
      </div>
      <div v-if="!selectedFile && !isHiddenOptions" class="page-header-nav-options">
        <div class="navbar-nav nav dropdown dropdown-options  show inline">
          <button type="button"
                  class="btn waves-effect waves-light ex-options-button"
                  id="dropdownMenuLink1" data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                  @click="updateHeightOptionsMenu($event)">Options
            <span class="dropdown-arrow  pull-right" style="
                                                  box-sizing: border-box;
                                                  width: 32px;
                                                  border-left: 1px solid rgba(27,30,56,0.25);
                                                  "> <i class="fa fa-chevron-down pull-right"></i>
                                                </span>
          </button>
          <div class="dropdown-menu dropdown-menu-right animated fadeInUp" aria-labelledby="dropdownMenuLink1"
               :style="{'max-height': heightOptions + 'px'}" :class="{'options-menu-height': heightOptions != ''}">
            <a v-if="isMobile" @click="assignedToOpen"
               class="dropdown-item">Assign to</a>
            <a v-if="isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser"
               @click="showPreviewEstimateModal" class="dropdown-item">
              {{ isSupplementItemListTab ? 'Preview Supplement' : 'Preview Estimate' }}</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isInsuranceRepairYes"
               @click="showPreADJEstimateModal" class="dropdown-item">
              {{ isSupplementItemListTab ? 'Print Pre-ADJ Supplement' : 'Print Pre-ADJ Estimate' }}</a>
            <a v-if="isStatusActive && !isFreePlan" @click="printKeyTicket" class="dropdown-item">Print Key Label</a>
            <a v-if="isStatusActive && isAudaContractedCompany && (isEstimateItemList || isSupplementItemListTab)"
               class="dropdown-item">
              <span>AUDANET</span>
              <div class="dropdown-menu-child">
                <ul type="none">
                  <li @click="downloadAudaParts()">
                    <a class="cursor-ptr" href="#">Download Parts List</a>
                  </li>
                  <li @click="sendPartsToAudaQuote()">
                    <a class="cursor-ptr" href="#">Update Parts list Pricing</a>
                  </li>
                  <li v-if="isEstimateItemList"
                      @click="downloadAudaQuote()">
                    <a class="cursor-ptr" href="#">Download MAIN Quote</a>
                  </li>
                  <li v-else
                      @click="downloadAudaQuote()">
                    <a class="cursor-ptr" href="#">Download SUP{{ computedSupplementNumber }} Quote</a>
                  </li>
                  <li v-if="properties?.audaUrl != ''"
                      @click="viewInAudaNet()">
                    <a class="cursor-ptr" href="#">View In AUDANET</a>
                  </li>
                </ul>
              </div>
            </a>
            <a v-if="isStatusActive && isSupplementItemListTab" class="dropdown-item"></a>
            <a v-if="isStatusActive" @click="addNote" data-toggle="modal" data-target="#noteBoxModal"
               class="dropdown-item">Add Note</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && !isHasTemplates && isStatusActive && !isBlockByAuda"
               class="dropdown-item has-child" @click="addTemplate">
              <span>Add Template</span>
              <div class="dropdown-menu-child">
                <input type="text" placeholder="Search" autofocus v-model="searchTemplateInput">
                <ul v-if="templates.length" type="none">
                  <li v-for="(template, index) of filteredTemplates" :key="template.id">
                    <a href="#">{{ template.name }}</a>
                  </li>
                </ul>
                <ul type="none" v-else>
                  <li>Loading...</li>
                </ul>
              </div>
            </a>
            <a v-else-if="isStatusActive" class="dropdown-item" @click="removeTemplateFromEstimate(computedTemplateId)">
              Remove Template</a>
            <a v-if="properties.isFromIag && isStatusActive && vendorInfo && vendorInfo.features  && vendorInfo.features.integrations && vendorInfo.features.integrations.orm"
               @click.prevent="goToSendToOrm" class="dropdown-item">Send To ORM</a>
            <!--            <a v-if="properties.isFromEio" @click.prevent="goToSendToEio" class="dropdown-item">Send To EIO</a>-->
            <a v-if="isShowImportPdfForParts && isStatusActive && !isBlockByAuda" class="dropdown-item"
               @click="importPdfForParts">Import Pricing</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
               @click="goToSendToSuppliers" class="dropdown-item"> Send To Supplier</a>
            <a v-if="showClaimLinqButton && properties.isCanSendToClaimlinq && isStatusActive" @click="sendToClaimLinq"
               class="dropdown-item"> Send To ClaimLinq</a>
            <a v-if="isShowSendToInsurer"
               @click="sendToInsurerMain" class="dropdown-item"> Send to Insurer</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
               @click="sendToCustomer" class="dropdown-item"> Send To Customer</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
               @click="createSupplement(null)" class="dropdown-item"> Add Supplement</a>
            <a v-if="isStatusActive && vendorInfo && vendorInfo.webtrimAuth && vendorInfo.webtrimAuth.active"
               @click="addToWebtrim" class="dropdown-item">Add to WEBTRIM</a>
            <!--                        <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 0" @click="markAs(0)" class="dropdown-item"> Mark As Draft</a>-->
            <!--                        <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 1" @click="markAs(1)" class="dropdown-item"> Mark As Sent</a>-->
            <!--                        <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 2" @click="markAs(2)" class="dropdown-item"> Mark As On Hold</a>-->
            <!--                        <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 3" @click="markAs(3)" class="dropdown-item"> Mark As Closed</a>-->

            <a v-if='isShowAuthOption  && isStatusActive && !isSupplementItemListTab && !isBlockByAuda'
               @click="authoriseEstimate(true)" class="dropdown-item text-primary p-1 clickable">Authorise Estimate</a>
            <a v-if='!isAuthorisePage[currentItemListId] && isStatusActive && isItemListTab && isSupplementItemListTab && !isBlockByAuda'
               @click="authoriseEstimate(true)" class="dropdown-item text-primary p-1 clickable">Authorise
              Supplement</a>
            <a v-if="isStatusActive" @click="openNewTask" class="dropdown-item text-primary p-1 clickable">Add New
              Task</a>
            <a @click="copyEstimateModal" class="dropdown-item">Copy Estimate</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isShowMarkAsRead && isStatusActive"
               @click="markAsRead" class="dropdown-item"> Mark As Read</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && invoice.id > 0"
               @click="createInvoice" class="dropdown-item"> Go To Invoice</a>
            <a v-else-if="(isShopManagerUser|| isProductionManagerUser || isCustomerUser) && isStatusActive"
               @click="createInvoice" class="dropdown-item"> Create Invoice</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && isExcess && excess_invoice.id > 0"
               @click="createExcessInvoice" class="dropdown-item"> Go To Excess
              Invoice</a>
            <a v-else-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && isExcess && isStatusActive"
               @click="createExcessInvoice" class="dropdown-item"> Create Excess Invoice</a>
            <a v-if="isSupplementItemListTab && (isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
               @click="$refs.deleteSuppModal.show()"
               class="dropdown-item">Delete Supplement</a>
          </div>
        </div>
      </div>
    </div>
    <assign-to-modal v-if="assignToActive" @close="closeAssignToModal" @selected="assignToUser"></assign-to-modal>
    <div v-if="isMobile" class="nav-chevron-block" :style="navTabsTopStyle('chevron')">
      <div :class="{ 'active': tabsArrowLeftVisible }"><i class='bx bx-chevron-left'></i></div>
      <div :class="{ 'active': tabsArrowRigthVisible }"><i class='bx bx-chevron-right'></i></div>
    </div>
    <div :class="{'hide-estimate-block': !isLoadedEstimate && isShowBigImage}" class="box-block bg-white">
      <div class="row">
        <div>
          <div class="estimates-edit">
            <div ref="tabsComponent" class="tabs-component" :style="navTabsTopStyle('tabs')" @scroll="isArrowActive"
                 :class="{'is-mobile-only': isMobileOnly, 'tabs-component-mobile': isMobile}">
              <ul class="nav nav-tabs nav-tabs-2 float-sm-left rs-scroll rs-scroll--x hide-scrollbar"
                  :class="{'is-mobile-only': isMobileOnly}">
                <li class="tabs-component-tab nav-item" role="tablist">
                  <a :class="{'active': currentTab === 'vehicleDetails'}" class="tabs-component-tab-a nav-link"
                     @click="vehicleDetailsTabChange()" data-toggle="tab"
                     href="#estimate-details" ref="estimate-details" role="tab">
                    Vehicle Details
                  </a>
                </li>
                <li class="tabs-component-tab nav-item">
                  <a :class="{'active': currentTab === 'notes'}" class="tabs-component-tab-a nav-link "
                     @click="notesTabChange()"
                     data-toggle="tab" href="#card-notes" role="tab"
                     style="min-width: 95px;"
                  >
                    Notes
                    <span v-if="totalNotes" class="tag tag-info">{{ totalNotes }}</span>
                  </a>
                </li>
                <template v-if="!isItemListLoaded">
                  <li
                      class="tabs-component-tab nav-item">
                    <a @click="tabEstimateChange('itemList'+$route.params.estimate_id, $route.params.estimate_id)"
                       class="tabs-component-tab-a nav-link clickable"
                       data-toggle="tab" role="tab">
                      <span v-if="!isMobile">EST-Items List</span>
                      <span v-if="isMobile">EST</span>
                    </a>
                  </li>
                </template>
                <template v-else>
                  <li
                      v-for="(itemList, itemIndex) in orderedItemsList"
                      :key="'itemListKey'+itemList.id"
                      class="tabs-component-tab nav-item">
                    <template v-if="itemList.type == 'estimate'">
                      <a :class="{'active': currentTab === 'itemList'+(itemList.id)}"
                         @click="tabEstimateChange('itemList'+(itemList.id), itemList.id)"
                         class="tabs-component-tab-a nav-link clickable"
                         data-toggle="tab"
                         role="tab">
                        <span v-if="!isMobile">EST-Items List</span>
                        <span v-if="isMobile">EST</span>
                        <span v-if="totalParts(itemList.parts)"
                              class="tag tag-info">{{ totalParts(itemList.parts) }}</span>
                      </a>
                    </template>
                    <template v-else>
                      <a :class="{'active': currentTab === 'itemList'+(itemList.id)}"
                         @click="tabEstimateChange('itemList'+(itemList.id), itemList.id)"
                         class="tabs-component-tab-a nav-link clickable"
                         data-toggle="tab"
                         role="tab">
                        <span v-if="!isMobile">SUPP-Items List {{ itemList.supplementNumber }}</span>
                        <span v-if="isMobile">SUPP {{ itemList.supplementNumber }}</span>
                        <span v-if="totalParts(itemList.parts)"
                              class="tag tag-info">{{ totalParts(itemList.parts) }}</span>
                      </a>
                    </template>
                  </li>
                </template>
                <li class="tabs-component-tab nav-item">
                  <a :class="{'active': currentTab === 'images'}" class="tabs-component-tab-a nav-link"
                     @click="imagesTabChange()"
                     data-toggle="tab" href="#upload-images" role="tab"
                     style="min-width: 103px;">
                    Images
                    <span v-if="totalImages" class="tag tag-info">{{ totalImages }}</span>
                  </a>
                </li>
                <li class="tabs-component-tab nav-item">
                  <a :class="{'active': currentTab === 'files'}" class="tabs-component-tab-a nav-link"
                     @click="filesTabChange"
                     data-toggle="tab" href="#upload-files" role="tab"
                     style="min-width: 88px;">
                    Docs
                    <span v-if="totalFiles" class="tag tag-info">{{ totalFiles }}</span>
                  </a>
                </li>
                <!--                                <li v-if="supplement_number === 0" class="tabs-component-tab nav-item">-->
                <!--                                    <a :class="{'active': currentTab === 'supplements'}" class="tabs-component-tab-a nav-link" @click="supplementsTabChange" data-toggle="tab" href="#supplements"-->
                <!--                                       role="tab">-->
                <!--                                        Supplements-->
                <!--                                        <span v-if="totalSupplements" class="tag tag-info">{{totalSupplements}}</span></a>-->
                <!--                                </li>-->
                <li class="tabs-component-tab nav-item">
                  <a :class="{'active': currentTab === 'activity'}" id="activity-tab"
                     class="tabs-component-tab-a nav-link" @click="activityTabChange" data-toggle="tab"
                     href="#activity" role="tab" ref="activity-tab-link">
                    Activity
                  </a>
                </li>
                <li class="tabs-component-tab nav-item">
                  <a class="tabs-component-tab-a nav-link openfilterTarget pr-0"
                     style="cursor:pointer; margin-right: 30px"
                     @click="assignedToOpen()">Assigned To: {{
                      (!assignedToUser || assignedToUser === 'None') ? '' :
                          assignedToUser
                    }}
                    <img v-if="loaderAssignTo" class="loaderAssignTo" src="../../assets/img/wait.gif" alt="loading"></a>
                  <div class="filterAssigned" ref="AssignedfilterRef">
                    <input type="text" placeholder="Search" v-model="filterAssignTo">
                    <ul type="none">
                      <li @click="changeAssignedName(elem)" v-for="elem in computedActiveUsers">
                        {{ elem.name }}
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="mobile-pin-images" v-if="isStatusActive && !selectedFile">
                  <label class="form-check-inline checkbox">
                    <input class="form-check-input" name="pinimage" v-model="pinImage" type="checkbox">
                    <span class="icon"><i class='bx bx-check'></i></span><span class="text">Pin Images</span>
                  </label>
                </li>
              </ul>
              <div v-if="!isMobileOnly && !isMobile"
                   class="rs-btn-group tab-header float-sm-right mt-1-sm additional-padding-btn">

                <!--
                                                                <div :class="!isHiddenOptions ? 'tabs-absolute-right' : 'tabs-absolute-right-notes-btn'">
                                                                        <label class="pin-image">
                                                                            <input type="checkbox" name="pinimage" v-model="pinImage">
                                                                            <span class="pin-checkmark"></span>
                                                                        </label>
                                                                </div>
                                  -->
                <div
                    v-if="isCanShowSchemeParts && currentTab == 'itemList' + currentItemListId"
                    style="position: relative">
                  <div @click="activeCarScheme = !activeCarScheme" class="page-header-nav-car-icon"
                       style="position: relative">
                    <img src="../../../mjml/img/car/car-icon.png" height="14" width="30"/>
                  </div>
                </div>

                <div class="tabs-nav-right-btn" v-if="isStatusActive && !selectedFile">
                  <label class="form-check-inline checkbox"
                         v-b-tooltip.hover="{customClass: 'ps-tooltip', title:'Click to view images', placement:'left'}">
                    <input class="form-check-input" name="pinimage" v-model="pinImage" type="checkbox">
                    <span class="icon"><i class='bx bx-check'></i></span><span class="text">Pin Images</span>
                  </label>
                </div>
                <div
                    v-if="!isAutoSaveEnable && (currentTab === 'vehicleDetails' || currentTab.includes('itemList')) && isStatusActive"
                    class="tabs-nav-right-btn">
                  <button @click="onClickSaveButton" type="button"
                          class="btn btn-primary w-min-sm waves-effect waves-light"
                          style="margin-right:5px">Save
                  </button>
                </div>
                <!-- <div v-if="!isHiddenNewNote" class="tabs-nav-right-btn">
                                    <button @click="addNote" data-toggle="modal" data-target="#noteBoxModal" type="button"
                                            class="btn btn-primary w-min-sm waves-effect waves-light mr-2">
                                        <i class="ti-plus"></i><span> New Note</span>
                                    </button>
                                </div> -->
                <div
                    v-if="!selectedFile && (!isHiddenOptions || (!isShopManagerUser && !isProductionManagerUser && !isEstimatorUser))"
                    class="tabs-nav-right-options">
                  <div class="navbar-nav nav dropdown dropdown-options  show inline">
                    <button type="button"
                            class="btn waves-effect waves-light ex-options-button"
                            id="dropdownMenuLink" data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="true"
                            @click="updateHeightOptionsMenu($event)">Options
                      <span class="dropdown-arrow  pull-right" style="
                                                  box-sizing: border-box;

                                                  width: 32px;
                                                  border-left: 1px solid rgba(27,30,56,0.25);
                                                  "> <i class="fa fa-chevron-down pull-right"></i>
                                                </span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right animated fadeInUp" aria-labelledby="dropdownMenuLink"
                         :class="{'options-menu-height-2': heightOptions != ''}">
                      <a v-if="isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser"
                         @click="showPreviewEstimateModal" class="dropdown-item">
                        {{ isSupplementItemListTab ? 'Preview Supplement' : 'Preview Estimate' }}</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser)  && isInsuranceRepairYes"
                         @click="showPreADJEstimateModal" class="dropdown-item">
                        {{ isSupplementItemListTab ? 'Print Pre-ADJ Supplement' : 'Print Pre-ADJ Estimate' }}</a>
                      <a v-if="isStatusActive && !isFreePlan" @click="printKeyTicket" class="dropdown-item">Print Key
                        Label</a>
                      <a v-if="isStatusActive && isAudaContractedCompany && (isEstimateItemList || isSupplementItemListTab)"
                         class="dropdown-item has-child">
                        <span>AUDANET</span>
                        <div class="dropdown-menu-child audanet" style="overflow: auto; scrollbar-width: thin;">
                          <ul type="none" class="audanet-child">
                            <li @click="downloadAudaParts()">
                              <a class="cursor-ptr" href="#">Download Parts List</a>
                            </li>
                            <li @click="sendPartsToAudaQuote()">
                              <a class="cursor-ptr" href="#">Update Parts list Pricing</a>
                            </li>
                            <li v-if="isEstimateItemList"
                                @click="downloadAudaQuote()">
                              <a class="cursor-ptr" href="#">Download MAIN Quote</a>
                            </li>
                            <li v-else
                                @click="downloadAudaQuote()">
                              <a class="cursor-ptr" href="#">Download SUP{{ computedSupplementNumber }} Quote</a>
                            </li>
                            <li v-if="properties?.audaUrl != ''"
                                @click="viewInAudaNet()">
                              <a class="cursor-ptr" href="#">View In AUDANET</a>
                            </li>
                          </ul>
                        </div>
                      </a>
                      <a v-if="isStatusActive" @click="addNote" data-toggle="modal" data-target="#noteBoxModalEst"
                         class="dropdown-item">Add Note</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && !isHasTemplates && isStatusActive && !isBlockByAuda"
                         class="dropdown-item has-child"
                         id="add-template"
                         @mouseover="setHeightForAddTemplateMenu"
                         @click="addTemplate">
                        <span>Add Template</span>
                        <!-- <i class="fa fa-angle-right additional-menu-icon"></i> -->
                        <div class="dropdown-menu-child" style="overflow: auto; scrollbar-width: thin;"
                             :style="{maxHeight: addTemplateHeight + 'px'}">
                          <input class="searchInput" type="text" placeholder="Search" autofocus
                                 v-model="searchTemplateInput">
                          <ul v-if="templates.length" class="addTemplateList" type="none">
                            <li v-for="(template, index) of filteredTemplates" :key="template.id">
                              <a @click="addTemplateToEstimate(template)" href="#">{{ template.name }}</a>
                            </li>
                          </ul>
                          <ul type="none" v-else>
                            <li><a>Loading...</a></li>
                          </ul>
                        </div>
                      </a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && isStatusActive"
                         @mouseover="setHeightForSaveTemplateMenu"
                         id="save-template"
                         class="dropdown-item has-child">
                        <span>Save As Template</span>
                        <!-- <i class="fa fa-angle-right additional-menu-icon"></i> -->
                        <div class="dropdown-menu-child" style="width: 300px; overflow: auto; scrollbar-width: thin;"
                             :style="{maxHeight: saveTemplateHeight + 'px'}">
                          <h6 style="margin: 0 10px 10px">Create New Name</h6>
                          <input style="width: calc(100% - 20px)" type="text" placeholder="New Name" autofocus
                                 v-model="searchTemplateInput">
                          <div style="padding: 10px">
                            <button :disabled="!searchTemplateInput" @click="saveAsTemplate" class="pull-right"
                                    style="border: none; background: #3E70C9; color: white; font-size: 10px; padding: 3px 10px;">
                              Save
                            </button>
                          </div>
                          <ul v-if="templates.length" class="saveAsTemplateList" type="none">
                            <li style="padding: 10px 10px 6px"><span>Existing templates</span></li>
                            <li class="li-in-save-as-template" style="padding: 2px 10px; color: #373A3C;"
                                v-for="(template, index) of filteredTemplates" :key="template.id">
                              <span>{{ template.name }}</span>
                            </li>
                          </ul>
                          <ul type="none" v-else>
                            <li><a>Loading...</a></li>
                          </ul>
                        </div>
                      </a>
                      <a v-if="isShowImportPdfForParts && isStatusActive && !isBlockByAuda"
                         class="dropdown-item"
                         @click="importPdfForParts">Import Pricing</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && isHasTemplates && isStatusActive"
                         class="dropdown-item"
                         @click="removeTemplateFromEstimate(computedTemplateId)">Remove Template</a>
                      <a v-if="properties.isFromIag && isStatusActive && vendorInfo && vendorInfo.features  && vendorInfo.features.integrations && vendorInfo.features.integrations.orm"
                         @click.prevent="goToSendToOrm" class="dropdown-item">Send To
                        ORM</a>
                      <!--                      <a v-if="properties.isFromEio" @click.prevent="goToSendToEio" class="dropdown-item">Send To EIO</a>-->

                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive "
                         @click="goToSendToSuppliers" class="dropdown-item"> Send To
                        Supplier</a>
                      <a v-if="showClaimLinqButton && properties.isCanSendToClaimlinq && isStatusActive"
                         @click="sendToClaimLinq" class="dropdown-item"> Send To ClaimLinq</a>
                      <a v-if="isShowSendToInsurer"
                         @click="sendToInsurerMain" class="dropdown-item"> Send to Insurer</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
                         @click="sendToCustomer" class="dropdown-item"> Send To
                        Customer</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
                         @click="createSupplement(null)" class="dropdown-item"> Add Supplement</a>
                      <a v-if="isStatusActive && vendorInfo && vendorInfo.webtrimAuth && vendorInfo.webtrimAuth.active"
                         @click="addToWebtrim" class="dropdown-item">Add to WEBTRIM</a>
                      <!--                                            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 0" @click="markAs(0)" class="dropdown-item"> Mark As Draft</a>-->
                      <!--                                            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 1" @click="markAs(1)" class="dropdown-item"> Mark As Sent</a>-->
                      <!--                                            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 2" @click="markAs(2)" class="dropdown-item"> Mark As On Hold</a>-->
                      <!--                                            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 3" @click="markAs(3)" class="dropdown-item"> Mark As Closed</a>-->
                      <a v-if='isViewRunDamageAssmnt && isAIDamageAvailableByCount() && !wasAiRequestSent'
                         @click="runDamageAssmnt()" class="dropdown-item text-primary p-1 clickable">Run Damage
                        Assmnt</a>
                      <a v-if='isViewRunDamageAssmnt && isAIDamageAvailableByCount() && wasAiRequestSent'
                         @click="runDamageAssmnt()" class="dropdown-item text-primary p-1 clickable">Rerun Damage
                        Assmnt</a>
                      <a v-if='isShowAuthOption && !isBlockByAuda'
                         @click="authoriseEstimate(true)" class="dropdown-item text-primary p-1 clickable">Authorise
                        Estimate</a>
                      <a v-if='!isAuthorisePage[currentItemListId] && isStatusActive && isItemListTab && isSupplementItemListTab && !isBlockByAuda'
                         @click="authoriseEstimate(true)" class="dropdown-item text-primary p-1 clickable">Authorise
                        Supplement</a>
                      <a v-if='isStatusActive' @click="openNewTask" class="dropdown-item text-primary p-1 clickable">Add
                        New Task</a>
                      <a @click="copyEstimateModal" class="dropdown-item">Copy Estimate</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isShowMarkAsRead && isStatusActive"
                         @click="markAsRead" class="dropdown-item">
                        Mark As Read</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && invoice.id > 0"
                         @click="createInvoice" class="dropdown-item"> Go To Invoice</a>
                      <a v-else-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && isStatusActive"
                         @click="createInvoice" class="dropdown-item"> Create Invoice</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && isExcess && excess_invoice.id > 0"
                         @click="createExcessInvoice"
                         class="dropdown-item"> Go To
                        Excess Invoice</a>
                      <a v-else-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser)  && isExcess && isStatusActive"
                         @click="createExcessInvoice" class="dropdown-item"> Create
                        Excess Invoice</a>
                      <a v-if="isSupplementItemListTab && (isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
                         @click="$refs.deleteSuppModal.show()" class="dropdown-item">Delete Supplement</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="error.exists" class="alert alert-danger-outline alert-dismissible fade in ma-1-25 mb-0"
                 role="alert">
              <button type="button" @click="dismissError()" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Error!</strong> please fix following before submitting the form,
              <ul>
                <li v-for="msg in error.messages" @click="getFocus(msg.id)" :class="{ 'cursor-ptr': msg.id }"
                    v-html="msg.value"></li>
              </ul>
            </div>
            <div
                :class="selectedFile && currentTab === 'files' ? 'tab-content tab-content-without-padding' : classTabContent">
              <div v-if="currentTab === 'vehicleDetails'" id="estimate-details" role="tabpanel">
                <div class="row">
                  <div class="col-md-4" style="padding-right: 0">
                    <!-- <div class="box box-block bg-white"> -->
                    <div class="card">
                      <div class="card-header bg-navyblue justify-content-between">
                        <strong style="flex-grow: 1;">Vehicle Owner</strong>
                        <div
                            v-if="isExcess && (isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser)"
                            style="background-color: #5d78fd; color: white; border-radius: 3px; padding: 5px 10px">
                          Excess: {{ card?.insurance?.excess | formatMoney }}
                        </div>
                        <div
                            v-else-if="isExcessToNil && (isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser)"
                            style="background-color: #5d78fd; color: white; border-radius: 3px; padding: 5px 10px">
                          Excess: {{ 0 | formatMoney }}
                        </div>
                      </div>
                      <div class="card-block rs-scroll rs-scroll--x bg-white">
                        <div class="form-group row">
                          <label for="owner" class="col-sm-4 col-4 col-form-label">Vehicle Owner</label>
                          <div class="col-sm-8 col-8">
                            <input style="opacity: 1" type="text" v-model="card.customer.name" class="form-control"
                                   id="owner" placeholder="Name" disabled="disabled">
                          </div>
                        </div>

                        <div class="form-group row owner-type-checkboxes">
                          <label for="mobile" class="col-sm-4 col-4 col-form-label">Owner Type</label>
                          <div class="col-sm-8 col-8">
                            <div class="checkbox-group">
                              <div class="checkbox-p">
                                <label class="form-check-inline radio" style="margin-top: 5px">
                                  <input v-model="card.customer.customer_type"
                                         class="form-check-input" type="radio" name="customer_type"
                                         id="individual_customer_type" value="I"
                                         @change="autoUpdateCardCustomer" :disabled="isTechnicalUser || true">
                                  <span class="icon"><i class='bx bx-check'></i></span><span
                                    class="text">Individual</span>
                                </label>
                              </div>
                              <div class="checkbox-p">
                                <label class="form-check-inline radio" style="margin-top: 5px">
                                  <input v-model="card.customer.customer_type"
                                         class="form-check-input" type="radio" name="customer_type"
                                         id="business_customer_type" value="B"
                                         @change="autoUpdateCardCustomer" :disabled="isTechnicalUser || true">
                                  <span class="icon"><i class='bx bx-check'></i></span><span
                                    class="text">Business</span>
                                </label>
                              </div>
                              <div class="checkbox-p">
                                <label class="form-check-inline radio" style="margin-top: 5px">
                                  <input v-model="card.customer.customer_type"
                                         class="form-check-input" type="radio" name="customer_type"
                                         id="business_fleet_customer_type" value="F"
                                         @change="autoUpdateCardCustomer" :disabled="isTechnicalUser || true">
                                  <span class="icon"><i class='bx bx-check'></i></span><span style="min-width: 121px"
                                                                                             class="text">Business Fleet</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="card.customer.customer_type === 'F' && !isTechnicalUser"
                             class="form-group row">
                          <label class="col-sm-4 col-4 col-form-label">Business ABN</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" :disabled="!card.customer.customer_id"
                                   v-model="card.customer.abn" class="form-control" :readonly="!isStatusActive"
                                   placeholder="Business ABN"
                                   @change="autoUpdateBusinessABN">
                          </div>
                        </div>

                        <div v-if="card.customer.customer_type === 'F'" class="form-group row">
                          <label class="col-sm-4 col-4 col-form-label">Vehicle Driver</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.vehicleDriverName" class="form-control"
                                   placeholder="Vehicle Driver" :readonly="!isStatusActive"
                                   :disabled="!card.customer.customer_id"
                                   @change="autoUpdateContacts">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="mobile" class="col-sm-4 col-4 col-form-label">Contact Number 1</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.contactNumber1" class="form-control" id="mobile"
                                   placeholder="Phone Number" :readonly="!isStatusActive"
                                   style="padding-right: 30px"
                                   :disabled="!card.customer.customer_id"
                                   @change="autoUpdateContacts">
                            <i v-if="card.contactNumber1" @click="onClickNumber(card.contactNumber1)"
                               class='bx bxs-phone-call'></i>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="phone" class="col-sm-4 col-4 col-form-label">Contact Number 2</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.contactNumber2"
                                   style="padding-right: 30px"
                                   class="form-control" id="phone"
                                   placeholder="Phone Number" :readonly="!isStatusActive"
                                   @change="autoUpdateContacts">
                            <i v-if="card.contactNumber2" @click="onClickNumber(card.contactNumber2)"
                               class='bx bxs-phone-call'></i>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="fax" class="col-sm-4 col-4 col-form-label">Fax</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.customer.fax" class="form-control" id="fax"
                                   placeholder="Fax Number" :readonly="!isStatusActive"
                                   :disabled="!card.customer.customer_id"
                                   @change="autoUpdateCardCustomer">
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="email" class="col-sm-4 col-4 col-form-label">Email Address</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.contactEmail" class="form-control" placeholder="Email"
                                   :disabled="!card.customer.customer_id || !isStatusActive"
                                   @input="checkEmail"
                                   @blur="checkEmail2"
                                   @change="changedEmailAddress">
                            <small v-if="!isCheckedEmail" class="form-text show-help-for-body">
                              Please enter a valid email address
                            </small>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="address" class="col-sm-4 col-4 col-form-label">Search Address</label>
                          <div class="col-sm-8 col-8">
                            <google-location type="text" v-model="card.customer.address" id="address"
                                             placeholder="Search for an Address"
                                             @onPlaceChange="changedCardCustomerAddress"
                                             :isDisabled="!card.customer.customer_id || !isStatusActive">
                            </google-location>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="level_unit_lot" class="col-sm-4 col-4 col-form-label">Level/Unit/Lot Nbr</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.customer.level_unit_lot" class="form-control"
                                   id="level_unit_lot" placeholder="Lot, Unit, or Level number"
                                   :disabled="!card.customer.customer_id" :readonly="!isStatusActive"
                                   @change="autoUpdateCardCustomer">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="street_name" class="col-sm-4 col-4 col-form-label">Street Nbr/Name</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.customer.street_name" class="form-control" id="street_name"
                                   placeholder="Street Number or Name"
                                   :disabled="!card.customer.customer_id" :readonly="!isStatusActive"
                                   @change="autoUpdateCardCustomer">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="suburb" class="col-sm-4 col-4 col-form-label">Suburb</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.customer.suburb" :readonly="!isStatusActive"
                                   class="form-control" id="suburb" placeholder="Suburb"
                                   :disabled="!card.customer.customer_id"
                                   @change="autoUpdateCardCustomer">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="state" class="col-sm-4 col-4 col-form-label">State</label>
                          <div class="col-sm-8 col-8">
                            <multiselect
                                id="state"
                                ref="vehicleOwnerAddressState"
                                v-model="computedCustomerState"
                                :options="addressStates"
                                :showLabels="false"
                                :option-height="29"
                                :max-height="203"
                                :close-on-select="true"
                                placeholder="Select State"
                                track-by="key"
                                label="value"
                                style="opacity: 1"
                                :disabled="!card.customer.customer_id || !isStatusActive"
                                @select="autoUpdateCardCustomer"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="postcode" class="col-sm-4 col-4 col-form-label">Postcode</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.customer.postcode" class="form-control" id="postcode"
                                   placeholder="Postcode"
                                   :disabled="!card.customer.customer_id" :readonly="!isStatusActive"
                                   @change="autoUpdateCardCustomer">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="country" class="col-sm-4 col-4 col-form-label">Country</label>
                          <div class="col-sm-8 col-8">
                            <multiselect
                                id="country"
                                ref="vehicleOwnerAddressCountry"
                                v-model="computedCustomerCountry"
                                :options="addressCountries"
                                :showLabels="false"
                                :option-height="29"
                                :max-height="203"
                                :close-on-select="true"
                                placeholder="Select Country"
                                track-by="key"
                                label="value"
                                :disabled="!card.customer.customer_id || !isStatusActive"
                                style="opacity: 1"
                                @select="autoUpdateCardCustomer"
                            >
                            </multiselect>
                          </div>
                        </div>

                        <!--                                                <div v-if="card.customer.customer_type === 'B'" class="form-group row">-->
                        <!--                                                    <label for="abn" class="col-lg-4 col-form-label">Business ABN</label>-->
                        <!--                                                    <div class="col-lg-8">-->
                        <!--                                                        <input type="text" v-model="card.customer.abn" class="form-control" id="abn" placeholder="Business ABN" :disabled="!card.customer.customer_id"-->
                        <!--                                                               @change="autoUpdateCardCustomer">-->
                        <!--                                                    </div>-->
                        <!--                                                </div>-->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 wrapper-vehicle-block" style="padding-right: 0">
                    <div>

                    </div>
                    <!-- Vehicle block -->
                    <vehicle-block
                        ref="vehicle-block"
                        :card="card"
                        :vehiclePaintCodes="vehiclePaintCodes"
                        :loadingData='loadingEstimate'
                        :propsIsAutoSave="isAutoSave"
                        :propsEstimateMethodology="estimateRates.estimate_methodology"
                        :propsEstimate="estimate"
                        :isEstimateEdit="true"
                        :loadResAi="loadResAi"
                        @loadPaintCodes="loadPaintCodes"
                        @setUpdateData="setUpdateData"
                        @changedColour="changedColour"
                        @changePaintMaterial="changePaintMaterial"
                        @addNewVehiclePaintCode="addNewVehiclePaintCode"
                        @onRunVehicleIdentifier="onRunVehicleIdentifier"
                        :properties="properties"
                    ></vehicle-block>
                  </div>
                  <div class="col-md-4 pr-0" style="min-height: 780px">
                    <div v-if="isMobileOnly" style="height: 10px; width: 100%; background: #e3e4e7; margin-bottom: 7px;"
                         class=""></div>
                    <tabs :is-need-save-tabs="false" @changed="changedSubTabs" class="estimates-edit-sub-tabs"
                          :options="{useUrlFragment: false, defaultTabHash: 'estimates-values' }">
                      <!--                      <tab name="Estimates Values" id="estimates-values">-->
                      <!--                        <div class="card">-->
                      <!--                          <div class="card-block rs-scroll rs-scroll&#45;&#45;x bg-white" style="padding-top: 5px !important;">-->
                      <!--                            <div class="row shop-bold">-->
                      <!--                              <label class="col-sm-7">Remove & Replace</label>-->
                      <!--                              <label class="col-sm-5">{{ calculatedAdjTotal('RR') | formatMoney }}</label>-->
                      <!--                            </div>-->
                      <!--                            <div class="row shop-bold">-->
                      <!--                              <label class="col-sm-7">Repair</label>-->
                      <!--                              <label class="col-sm-5">{{ calculatedAdjTotal('Repair') | formatMoney }}</label>-->
                      <!--                            </div>-->
                      <!--                            <div class="row shop-bold">-->
                      <!--                              <label class="col-sm-7">Paint</label>-->
                      <!--                              <label class="col-sm-5">{{ calculatedAdjTotal('Paint') | formatMoney }}</label>-->
                      <!--                            </div>-->
                      <!--                            <div class="row shop-bold">-->
                      <!--                              <label class="col-sm-7">Misc</label>-->
                      <!--                              <label class="col-sm-5">{{ calculatedAdjTotal('Materials') + calculatedAdjTotal('Sublet') + calculatedAdjTotal('Other') + calculatedAdjTotal('PDR') | formatMoney }}</label>-->
                      <!--                            </div>-->
                      <!--                            <div class="row shop-bold">-->
                      <!--                              <label class="col-sm-7">Parts</label>-->
                      <!--                              <label class="col-sm-5">{{ calculatedAdjTotal('Part') | formatMoney }}</label>-->
                      <!--                            </div>-->
                      <!--&lt;!&ndash;                            <div class="row shop-bold">&ndash;&gt;-->
                      <!--&lt;!&ndash;                              <label class="col-sm-7">Estimate Amount</label>&ndash;&gt;-->
                      <!--&lt;!&ndash;                              <label class="col-sm-5">{{ computedEstimateAmount | formatMoney }}</label>&ndash;&gt;-->
                      <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
                      <!--&lt;!&ndash;                            <div class="row shop-light">&ndash;&gt;-->
                      <!--&lt;!&ndash;                              <label class="col-sm-7">Part Mark-Up Profit</label>&ndash;&gt;-->
                      <!--&lt;!&ndash;                              <label&ndash;&gt;-->
                      <!--&lt;!&ndash;                                  class="col-sm-5">{{
                        &ndash;&gt;-- >
                        < !-- &lt; ! & ndash;                                  (estimateAmount.parts_markup_profit === '') ? '$0.00' : estimateAmount.parts_markup_profit & ndash;&gt;-- >
                        < !-- &lt; ! & ndash;
                      }}</label>&ndash;&gt;-->
                      <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
                      <!--&lt;!&ndash;                            <div class="row shop-light">&ndash;&gt;-->
                      <!--&lt;!&ndash;                              <label class="col-sm-7">Labour Profit</label>&ndash;&gt;-->
                      <!--&lt;!&ndash;                              <label class="col-sm-5"></label>&ndash;&gt;-->
                      <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
                      <!--                          </div>-->
                      <!--                        </div>-->
                      <!--                      </tab>-->
                      <tab name="Summary" id="estimateSummary">
                        <div class="card">
                          <div class="card-block rs-scroll rs-scroll--x bg-white tab-padding-top-0px">
                            <div class="row shop-light">
                              <label class="col-sm-7">File Number</label>
                              <label class="col-sm-5">
                                <div class="form-control" style="height: 32px">
                                  <router-link :to="'/files/view/' + card_id">
                                    <span
                                        v-b-tooltip.hover="{customClass: 'ps-tooltip', title: `File Number`, placement: 'left'}"
                                        style="font-weight: bold">{{ card.card_number }}</span>
                                  </router-link>
                                </div>
                              </label>
                            </div>
                            <div
                                v-for="estItem in itemsList"
                                :key="estItem.id"
                                class="row shop-light">
                              <label class="col-sm-7">
                                Date Created
                                <template v-if="estItem.type == 'supplement'">{{ estItem.number }}
                                </template>
                              </label>
                              <div class="col-sm-5 additional-data-picker-block" style="margin-bottom: 10px;">
                                <date-picker :is-disabled="!isStatusActive"
                                             @input="saveItemsList(estItem.id, {estimate: {dateCreated: estItem.dateCreated}})"
                                             v-model="estItem.dateCreated"></date-picker>
                              </div>
                            </div>
                            <template v-if="isBlockByAuda">
                              <div class="estimate-summary-table"
                                   style="margin-bottom: 15px">
                                <div class="estimate-summary-table-head form-group row d-flex">
                                  <div class="estimate-summary-table-head-item col-lg-6">{{ estimate_number }}
                                  </div>
                                  <div class="estimate-summary-table-head-item col-lg-3">
                                  </div>
                                  <div class="estimate-summary-table-head-item col-lg-3">Total</div>
                                </div>
                                <div class="estimate-summary-table-body">
                                  <div class="estimate-summary-table-body-elem form-group row">
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-title col-lg-6">
                                      <span>Labours</span>
                                    </div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3">
                                    </div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3">
                                      {{ estimate?.audanet?.labourTotal | formatMoney }}
                                    </div>
                                  </div>
                                  <div class="estimate-summary-table-body-elem form-group row">
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-title col-lg-6">
                                      <span>Paints</span>
                                    </div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3">
                                    </div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3">
                                      {{ estimate?.audanet?.paintTotal | formatMoney }}
                                    </div>
                                  </div>
                                  <div class="estimate-summary-table-body-elem form-group row">
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-title col-lg-6">
                                      <span>Parts</span>
                                    </div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3">
                                    </div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3">
                                      {{ estimate?.audanet?.partTotal | formatMoney }}
                                    </div>
                                  </div>
                                  <div class="estimate-summary-table-body-elem form-group row">
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-title col-lg-6">
                                      <span>Sublets</span>
                                    </div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3">
                                    </div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3">
                                      {{ estimate?.audanet?.subletTotal | formatMoney }}
                                    </div>
                                  </div>
                                  <div
                                      class="estimate-summary-table-body-elem estimate-summary-table-body-elem-bold form-group row"
                                      style="border-bottom: 0">
                                    <div class="estimate-summary-table-body-elem-item col-lg-7"
                                         style="border-bottom: 0"></div>
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-border-bottom col-lg-2">
                                      GST
                                    </div>
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-border-bottom col-lg-3">
                                      {{ estimate?.audanet?.gst | formatMoney }}
                                    </div>
                                  </div>
                                  <div
                                      class="estimate-summary-table-body-elem estimate-summary-table-body-elem-bold form-group row"
                                      style="border-bottom: 0">
                                    <div class="estimate-summary-table-body-elem-item col-lg-7"
                                         style="border-bottom: 0"></div>
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-border-bottom col-lg-2">
                                      Total
                                    </div>
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-border-bottom col-lg-3">
                                      {{ estimate?.audanet?.quoteTotal | formatMoney }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              <div class="estimate-summary-table" v-for="(itemList, ind) in itemsList" :key="ind"
                                   style="margin-bottom: 15px">
                                <div class="estimate-summary-table-head form-group row d-flex">
                                  <div class="estimate-summary-table-head-item col-lg-6">{{ itemList.number }}
                                    <i v-if="!isShowNotCompressed[itemList.id]"
                                       @click="onClickCompressBtn(itemList.id, true)" class="fa fa-chevron-down"
                                       style="cursor: pointer; line-height: 2px;"></i>
                                    <i v-else class="fa fa-chevron-up" @click="onClickCompressBtn(itemList.id, false)"
                                       style="cursor: pointer; line-height: 2px;"></i>
                                  </div>
                                  <div class="estimate-summary-table-head-item col-lg-3">
                                    <span v-if="isEstimateMethodologyDollars"></span>
                                    <span v-else>Hrs</span>
                                  </div>
                                  <div class="estimate-summary-table-head-item col-lg-3">Total</div>
                                </div>
                                <div class="estimate-summary-table-body">
                                  <template v-if="isShowNotCompressed[itemList.id]">
                                    <div class="estimate-summary-table-body-elem form-group row">
                                      <div
                                          class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-title col-lg-6">
                                        Remove & Replace
                                      </div>
                                      <div class="estimate-summary-table-body-elem-item col-lg-3">
                                        <span v-if="isEstimateMethodologyDollars"></span>
                                        <span v-else>{{ calculatedTotalHrs(itemList, 'RR') }}</span>
                                      </div>
                                      <div class="estimate-summary-table-body-elem-item col-lg-3">
                                        {{ calculatedAdjTotal(itemList, 'RR') | formatMoney }}
                                      </div>
                                    </div>
                                    <div class="estimate-summary-table-body-elem form-group row">
                                      <div
                                          class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-title col-lg-6">
                                        Repair
                                      </div>
                                      <div class="estimate-summary-table-body-elem-item col-lg-3">
                                        <span v-if="isEstimateMethodologyDollars"></span>
                                        <span v-else>{{ calculatedTotalHrs(itemList, 'Repair') }}</span>
                                      </div>
                                      <div class="estimate-summary-table-body-elem-item col-lg-3">
                                        {{ calculatedAdjTotal(itemList, 'Repair') | formatMoney }}
                                      </div>
                                    </div>
                                    <div class="estimate-summary-table-body-elem form-group row">
                                      <div
                                          class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-title col-lg-6">
                                        Paint
                                      </div>
                                      <div class="estimate-summary-table-body-elem-item col-lg-3">
                                        <span v-if="isEstimateMethodologyDollars"></span>
                                        <span v-else>{{ calculatedTotalHrs(itemList, 'Paint') }}</span>
                                      </div>
                                      <div class="estimate-summary-table-body-elem-item col-lg-3">
                                        {{ calculatedAdjTotal(itemList, 'Paint') | formatMoney }}
                                      </div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="estimate-summary-table-body-elem form-group row">
                                      <div
                                          class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-title col-lg-6">
                                        <span v-if="isEstimateMethodologyDollars">Labour</span>
                                        <span v-else>Labour Hours</span>
                                      </div>
                                      <div class="estimate-summary-table-body-elem-item col-lg-3">
                                        <span v-if="isEstimateMethodologyDollars"></span>
                                        <span
                                            v-else>{{
                                            totalHrsFormat(calculatedTotalHrs(itemList, 'RR', true) + calculatedTotalHrs(itemList, 'Repair', true) + calculatedTotalHrs(itemList, 'Paint', true))
                                          }}</span>
                                      </div>
                                      <div class="estimate-summary-table-body-elem-item col-lg-3">
                                        <template v-if="isBlockByAuda">
                                          {{ estimate?.audanet?.labourTotal | formatMoney }}
                                        </template>
                                        <template v-else>
                                          {{
                                            calculatedAdjTotal(itemList, 'RR') + calculatedAdjTotal(itemList, 'Repair') + calculatedAdjTotal(itemList, 'Paint') | formatMoney
                                          }}
                                        </template>
                                      </div>
                                    </div>
                                  </template>
                                  <div class="estimate-summary-table-body-elem form-group row">
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-title col-lg-6">
                                      Misc (Sublet/Other/PDR)
                                    </div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3"></div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3">{{
                                        calculatedAdjTotal(itemList, 'Materials') + calculatedAdjTotal(itemList, 'Sublet') + calculatedAdjTotal(itemList, 'Other') + calculatedAdjTotal(itemList, 'PDR') | formatMoney
                                      }}
                                    </div>
                                  </div>
                                  <div class="estimate-summary-table-body-elem form-group row">
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-title col-lg-6">
                                      Parts
                                    </div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3"></div>
                                    <div class="estimate-summary-table-body-elem-item col-lg-3">
                                      {{ calculatedAdjTotal(itemList, 'Part') | formatMoney }}
                                    </div>
                                  </div>
                                  <div class="estimate-summary-table-body-elem form-group row" style="border-bottom: 0">
                                    <div class="estimate-summary-table-body-elem-item col-lg-7"></div>
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-border-bottom col-lg-2">
                                      GST
                                    </div>
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-border-bottom col-lg-3">
                                      {{ calculatedTotalAll(itemList,) * 0.1 | formatMoney }}
                                    </div>
                                  </div>
                                  <div
                                      class="estimate-summary-table-body-elem estimate-summary-table-body-elem-bold form-group row"
                                      style="border-bottom: 0">
                                    <div class="estimate-summary-table-body-elem-item col-lg-7"
                                         style="border-bottom: 0"></div>
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-border-bottom col-lg-2">
                                      Total
                                    </div>
                                    <div
                                        class="estimate-summary-table-body-elem-item estimate-summary-table-body-elem-item-border-bottom col-lg-3">
                                      {{
                                        calculatedTotalAll(itemList,) * 0.1 + calculatedTotalAll(itemList,) | formatMoney
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </tab>
                      <tab name="Production Time" id="productionTime">
                        <div class="card">
                          <div
                              v-if="properties && properties.production && properties.production.definitions && properties.production.definitions.categories"
                              class="card-block rs-scroll rs-scroll--x bg-white tab-padding-top-0px">
                            <div class="row shop-light" style="height: 50px">
                              <label class="col-sm-6">Repair Category</label>
                              <div class="col-sm-6">
                                <multiselect
                                    :options="computedCategories"
                                    v-model="repairCategory"
                                    :showLabels="false"
                                    :option-height="29"
                                    :max-height="203"
                                    @input="onRepairCategoryChange"
                                    :close-on-select="true"
                                    placeholder="Select"
                                    :disabled="!isStatusActive"
                                >
                                  <template #singleLabel="{ option }">
                                    <span style="top: 3px; position: relative" class="categories-menu-color-icon"
                                          :style="{backgroundColor: getGroup(option).color}"></span> <span
                                      style="top: 0px">{{ getGroup(option).name }}</span>
                                  </template>
                                  <template #option="{ option }">
                                    <span style="top: 3px; position: relative" class="categories-menu-color-icon"
                                          :style="{backgroundColor: getGroup(option).color}"></span> <span
                                      style="top: 0px">{{ getGroup(option).name }}</span>
                                  </template>
                                </multiselect>
                              </div>
                            </div>
                            <div class="row shop-light production-time-input">
                              <label class="col-sm-6">Weld On Panels</label>
                              <label class="col-sm-6 d-flex">
                                <label class="form-check-inline checkbox">
                                  <input
                                      v-model="productionTime.isCheckWeld"
                                      class="form-check-input" type="checkbox" @change="onProductionCheckboxesChange">
                                  <span class="icon"><i class='bx bx-check'></i></span>
                                </label>
                                <input
                                    style="margin-right: 7px; max-width: 55px"
                                    type="text"
                                    @change="autoUpdateProductionTime"
                                    @keypress="onlyNumber"
                                    v-model="productionTime.weldQty"
                                    class="form-control input-field"
                                    placeholder="Qty"
                                />
                                <input
                                    type="text"
                                    class="form-control input-field"
                                    placeholder="0 Days"
                                    :readonly="true"
                                    :value="properties.production.definitions.numberOfDays.weld + ' Days'"
                                />
                              </label>
                            </div>
                            <div class="row shop-light production-time-input">
                              <label class="col-sm-6">Mechanical</label>
                              <label class="col-sm-6 d-flex">
                                <label class="form-check-inline checkbox">
                                  <input v-model="productionTime.isCheckMechanical" class="form-check-input"
                                         type="checkbox" @change="onProductionCheckboxesChange">
                                  <span class="icon"><i class='bx bx-check'></i></span>
                                </label>
                                <input
                                    type="text"
                                    class="form-control input-field"
                                    placeholder="0 Days"
                                    :readonly="true"
                                    :value="properties.production.definitions.numberOfDays.mechanical + ' Days'"
                                />
                              </label>
                            </div>
                            <div class="row shop-light production-time-input">
                              <label class="col-sm-6">Hail</label>
                              <label class="col-sm-6 d-flex">
                                <label class="form-check-inline checkbox">
                                  <input v-model="productionTime.isCheckHail" class="form-check-input" type="checkbox"
                                         @change="onProductionCheckboxesChange">
                                  <span class="icon"><i class='bx bx-check'></i></span>
                                </label>
                                <input
                                    type="text"
                                    class="form-control input-field"
                                    placeholder="0 Days"
                                    :readonly="true"
                                    :value="properties.production.definitions.numberOfDays.hail + ' Days'"
                                />
                              </label>
                            </div>
                            <div class="row shop-light production-time-input">
                              <label class="col-sm-6">Electirical</label>
                              <label class="col-sm-6 d-flex">
                                <label class="form-check-inline checkbox">
                                  <input v-model="productionTime.isCheckElectrical" class="form-check-input"
                                         type="checkbox" @change="onProductionCheckboxesChange">
                                  <span class="icon"><i class='bx bx-check'></i></span>
                                </label>
                                <input
                                    type="text"
                                    class="form-control input-field"
                                    placeholder="0 Days"
                                    :readonly="true"
                                    :value="properties.production.definitions.numberOfDays.electrical + ' Days'"
                                />
                              </label>
                            </div>
                            <div class="row shop-light production-time-input">
                              <label class="col-sm-6">PPF of Wrap</label>
                              <label class="col-sm-6 d-flex">
                                <label class="form-check-inline checkbox">
                                  <input v-model="productionTime.isCheckPpf" class="form-check-input" type="checkbox"
                                         @change="onProductionCheckboxesChange">
                                  <span class="icon"><i class='bx bx-check'></i></span>
                                </label>
                                <input
                                    type="text"
                                    class="form-control input-field"
                                    placeholder="0 Days"
                                    :readonly="true"
                                    :value="properties.production.definitions.numberOfDays.ppf + ' Days'"
                                />
                              </label>
                            </div>
                            <div class="row shop-light production-time-input">
                              <label class="col-sm-6">Accessories (Outsc)</label>
                              <label class="col-sm-6 d-flex">
                                <label class="form-check-inline checkbox">
                                  <input v-model="productionTime.isCheckAccessories" class="form-check-input"
                                         type="checkbox" @change="onProductionCheckboxesChange">
                                  <span class="icon "><i class='bx bx-check'></i></span>
                                </label>
                                <input
                                    type="text"
                                    class="form-control input-field"
                                    placeholder="0 Days"
                                    :readonly="true"
                                    :value="properties.production.definitions.numberOfDays.accessories + ' Days'"
                                />
                              </label>
                            </div>
                            <div class="row shop-bold" style="margin-top: 10px">
                              <label class="col-sm-6">Approximate Nbr Days</label>
                              <label class="col-sm-6 d-flex">
                                {{ computedApproximateDays }} Days
                              </label>
                            </div>

                          </div>
                        </div>
                      </tab>
<!--                      <tab name="Booking" id="booking">-->
<!--                        <div class="card">-->
<!--                          <div class="card-block rs-scroll rs-scroll&#45;&#45;x bg-white tab-padding-top-0px">-->
<!--                            <div class="row shop-light" style="height: 50px">-->
<!--                              <label class="col-sm-6">On-site Estimate Booking Date</label>-->
<!--                              <div class="col-sm-6">-->
<!--                                <date-picker-->
<!--                                    v-model="plannerBoard.onSite.onsiteEstimateBookingDate"-->
<!--                                    :disabled-dates="disabledDates"-->
<!--                                    @onChange="saveOnsiteData"  :is-disabled="!isStatusActive" :placeHolderText="'Date'">-->
<!--                                </date-picker>-->
<!--                                <p v-if="plannerBoard.onSite.isRebooked" style="font-weight: bold; font-size: 12px; line-height: 16px; margin-bottom: 0px; margin-top: 7px;">Re-booked</p>-->
<!--                              </div>-->
<!--                            </div>-->

<!--                            <div class="row shop-light" style="height: 41px">-->
<!--                              <label class="col-sm-6">Attended Estimate Booking</label>-->
<!--                              <div class="col-sm-6 d-flex">-->
<!--                                <div class="checkbox-p">-->
<!--                                  <label class="form-check-inline checkbox d-flex">-->
<!--                                    <input class="form-check-input" type="checkbox" name="nonAttReason"-->
<!--                                           v-model="isAttendedBookingYes"-->
<!--                                           @change="checkIsAttendYes(isAttendedBookingYes)"-->
<!--                                           :disabled="!isStatusActive || !plannerBoard.onSite.id"-->
<!--                                    >-->
<!--                                    <span :class="{'disabled-field': !isStatusActive || !plannerBoard.onSite.id}" class="icon"><i class='bx bx-check'></i></span><span class="text">Yes</span>-->
<!--                                  </label>-->
<!--                                </div>-->
<!--                                <div class="checkbox-p">-->
<!--                                  <label class="form-check-inline checkbox d-flex">-->
<!--                                    <input class="form-check-input" type="checkbox" name="nonAttReason"-->
<!--                                           hidden-->
<!--                                           v-model="isAttendedBookingNo"-->
<!--                                           @change="checkIsAttendNo(isAttendedBookingNo)"-->
<!--                                           :disabled="!isStatusActive || !plannerBoard.onSite.id">-->
<!--                                    <span :class="{'disabled-field': !isStatusActive || !plannerBoard.onSite.id}" class="icon"><i class='bx bx-check'></i></span><span class="text">No</span>-->
<!--                                  </label>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->

<!--                            <div class="row shop-light" style="height: 41px">-->
<!--                              <label class="col-sm-6">Non-attendance reason</label>-->
<!--                              <div class="col-sm-6">-->
<!--                                <multiselect-->
<!--                                    :options="properties.estimateBooking && properties.estimateBooking.reasons ? properties.estimateBooking.reasons : []"-->
<!--                                    v-model="onSiteReason"-->
<!--                                    @input="saveOnsiteData(false)"-->
<!--                                    :disabled="isDisabledOnSiteSelects || !plannerBoard.onSite.id"-->
<!--                                    :showLabels="false"-->
<!--                                    placeholder=""-->
<!--                                    :option-height="29"-->
<!--                                    :max-height="203"-->
<!--                                    :close-on-select="true"-->
<!--                                    class="board-multiselect-width"-->
<!--                                />-->
<!--                              </div>-->
<!--                            </div>-->

<!--                            <div class="row shop-light" style="height: 41px">-->
<!--                              <label class="col-sm-6">Call back Attempts</label>-->
<!--                              <div class="col-sm-6">-->
<!--                                <multiselect-->
<!--                                    :options="properties.estimateBooking && properties.estimateBooking.attempts ? properties.estimateBooking.attempts : []"-->
<!--                                    v-model="onSiteAttempt"-->
<!--                                    @input="saveOnsiteData(false)"-->
<!--                                    :disabled="isDisabledOnSiteSelects || !plannerBoard.onSite.id"-->
<!--                                    :showLabels="false"-->
<!--                                    placeholder=""-->
<!--                                    :option-height="29"-->
<!--                                    :max-height="203"-->
<!--                                    :close-on-select="true"-->
<!--                                    class="board-multiselect-width"-->
<!--                                />-->
<!--                              </div>-->
<!--                            </div>-->

<!--                            <div class="row shop-light" style="height: 41px">-->
<!--                              <label class="col-sm-6">Follow Up Action</label>-->
<!--                              <div class="col-sm-6">-->
<!--                                <multiselect-->
<!--                                    class="board-multiselect-width"-->
<!--                                    v-model="onSiteFollowUpAction"-->
<!--                                    :disabled="!isStatusActive || !plannerBoard.onSite.id"-->
<!--                                    :options="['default', 'rebooked', 'cancelled', 'calling']"-->
<!--                                    :max-height="203"-->
<!--                                    :showLabels="false"-->
<!--                                    :allowEmpty="false"-->
<!--                                    :close-on-select="true"-->
<!--                                    @input="saveOnsiteData(false)"-->
<!--                                >-->
<!--                                  <template #singleLabel="{ option }">-->
<!--                                    {{capitalizeFirstLetter(option)}}-->
<!--                                  </template>-->
<!--                                  <template #option="{ option }">-->
<!--                                    {{capitalizeFirstLetter(option)}}-->
<!--                                  </template>-->
<!--                                </multiselect>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </tab>-->
                      <tab :name="isBusinessTypeBikeRepairer ? 'Rental Bike':'Rental Car'" id="rentalCar">
                        <div class="card" v-if="estimate.rental">
                          <div class="card-block rs-scroll rs-scroll--x bg-white tab-padding-top-0px">
                            <div class="row shop-light">
                              <label class="col-sm-6">Rental Required</label>
                              <label class="col-sm-6 d-flex">
                                <div style="width: 75px" class="checkbox-p">
                                  <label class="form-check-inline radio">
                                    <input class="form-check-input"
                                           type="radio"
                                           name="card_is_total_loss"
                                           v-model="estimate.rental.isRequired"
                                           :value="true"
                                           :disabled="isTechnicalUser || !isStatusActive">
                                    <span class="icon"><i class='bx bx-check'></i></span><span class="text">Yes</span>
                                  </label>
                                </div>
                                <div style="width: 50px" class="checkbox-p">
                                  <label class="form-check-inline radio">
                                    <input class="form-check-input"
                                           type="radio"
                                           name="card_is_total_loss"
                                           v-model="estimate.rental.isRequired"
                                           :value="false"
                                           :disabled="isTechnicalUser || !isStatusActive"
                                    >
                                    <span class="icon"><i class='bx bx-check'></i></span><span class="text">No</span>
                                  </label>
                                </div>
                              </label>
                            </div>
                            <div class="row shop-light rental-margin-input">
                              <label class="col-sm-6">Rental Type</label>
                              <label class="col-sm-6">
                                <multiselect
                                    :options="['Internal - Fleet Car', 'Rental Company']"
                                    v-model="estimate.rental.type"
                                    :showLabels="false"
                                    :option-height="29"
                                    :max-height="203"
                                    open-direction="bottom"
                                    :close-on-select="true"
                                    placeholder="Select"
                                    :disabled="!isStatusActive || !estimate.rental.isRequired"
                                    style="opacity: 1; height: 32px;"
                                    id="rentalRequired"
                                >
                                </multiselect>
                              </label>
                            </div>
                            <template v-if="estimate.rental.type == 'Internal - Fleet Car'">
                              <div class="row shop-light rental-margin-input">
                                <label class="col-sm-6">Hider Name</label>
                                <label class="col-sm-6 d-flex">
                                  <input
                                      type="text"
                                      v-model="estimate.rental.hirerName"
                                      style="margin-bottom: 0"
                                      class="form-control input-field"
                                      :readonly="!isStatusActive || !estimate.rental.isRequired"
                                      placeholder=""
                                  />
                                </label>
                              </div>
                              <div class="row shop-light rental-margin-input">
                                <label class="col-sm-6">Hire Start Date</label>
                                <label class="col-sm-6 d-flex">
                                  <date-picker
                                      v-model="estimate.rental.hireStart"
                                      :isDisabled="!isStatusActive || !estimate.rental.isRequired"
                                      place-holder-text="Date"
                                  ></date-picker>
                                </label>
                              </div>
                              <div class="row shop-light rental-margin-input">
                                <label class="col-sm-6">Hire End Date</label>
                                <label class="col-sm-6 d-flex">
                                  <date-picker
                                      v-model="estimate.rental.hireEnd"
                                      :isDisabled="!isStatusActive || !estimate.rental.isRequired"
                                      place-holder-text="Date"
                                  ></date-picker>
                                </label>
                              </div>
                              <div class="row shop-light rental-margin-input rental-input-no-disabled">
                                <label class="col-sm-6">Total Hire Days</label>
                                <label class="col-sm-6 d-flex">
                                  <span style="padding-left: 10px">0</span>
                                </label>
                              </div>
                            </template>
                            <template v-else-if="estimate.rental.type == 'Rental Company'">
                              <div class="row shop-light rental-margin-input">
                                <label class="col-sm-6">Rental Company</label>
                                <label class="col-sm-6" style="margin-bottom: 3px">
                                  <advanced-search
                                      :searchLabel="'Rental Company'"
                                      :searchData="[]"
                                      :searchKey="'name'"
                                      :placeholderText="'Rental Company'"
                                      :sortByName="'name'"
                                  >
                                  </advanced-search>
                                </label>
                              </div>
                              <div class="row shop-light rental-margin-input">
                                <label class="col-sm-6">Date Lead Sent</label>
                                <label class="col-sm-6 d-flex">
                                  <date-picker
                                      v-model="estimate.rental.leadDate"
                                      :isDisabled="!isStatusActive || !estimate.rental.isRequired"
                                  ></date-picker>
                                </label>
                              </div>
                            </template>
                          </div>
                        </div>
                      </tab>
                      <tab
                          v-if="!(isDisplayBoardUser || isDetailerUser || isStripperFitterUser || isPaintTechnicianUser || isPanelTechnicianUser || isPDRTechnicianUser)"
                          name="Booking" id="booking">
                        <div class="estimage-line"></div>
                        <div style="margin-top: 0px">
                          <div class="form-group row">
                            <label class="col-sm-4 col-4 col-form-label">On-site Estimate Booking Date</label>
                            <div class="col-sm-8 col-8">
                              <date-picker v-model="plannerBoard.onSite.onsiteEstimateBookingDate"
                                           @iconClicked="goToOnSiteEvent" :isShowIcon="true" :is-disabled="true"
                                           :placeHolderText="'Date'" class="on-site-booking-picker">
                              </date-picker>
                              <p v-if="plannerBoard.onSite.isRebooked"
                                 style="font-weight: bold; font-size: 12px; line-height: 16px; margin-bottom: 0px; margin-top: 7px;">
                                Re-booked</p>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-sm-4 col-4 col-form-label">
                              Attended Estimate Booking
                            </label>
                            <div class="col-sm-8 col-8 d-flex insurer-block-mobile">
                              <div class="checkbox-p">
                                <label class="form-check-inline checkbox d-flex">
                                  <input class="form-check-input" type="checkbox" name="nonAttReason"
                                         v-model="isAttendedBookingYes"
                                         @change="checkIsAttendYes(isAttendedBookingYes)"
                                         :disabled="!isStatusActive || isDisabledFieldsByUserRole"
                                  >
                                  <span class="icon"><i class='bx bx-check'></i></span><span class="text">Yes</span>
                                </label>
                              </div>
                              <div class="checkbox-p">
                                <label class="form-check-inline checkbox d-flex">
                                  <input class="form-check-input" type="checkbox" name="nonAttReason"
                                         hidden
                                         v-model="isAttendedBookingNo"
                                         @change="checkIsAttendNo(isAttendedBookingNo)"
                                         :disabled="!isStatusActive || isDisabledFieldsByUserRole">
                                  <span class="icon"><i class='bx bx-check'></i></span><span class="text">No</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-4 col-4" style="padding-left: 0px">
                              <span style="display: block" class="col-form-label">Non-attendance reason</span>
                            </div>
                            <div class="col-sm-8 col-8">
                              <multiselect
                                  :options="properties.estimateBooking && properties.estimateBooking.reasons ? properties.estimateBooking.reasons : []"
                                  v-model="onSiteReason"
                                  :showLabels="false"
                                  placeholder=""
                                  @input="saveOnsiteData"
                                  :option-height="29"
                                  :max-height="203"
                                  :close-on-select="true"
                                  :disabled="isDisabledOnSiteSelects"
                                  class="board-multiselect-width"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-4 col-4" style="padding-left: 0px">
                              <span style="display: block" class="col-form-label">Call back Attempts </span>
                            </div>
                            <div class="col-sm-8 col-8">
                              <multiselect
                                  :options="properties.estimateBooking && properties.estimateBooking.attempts ? properties.estimateBooking.attempts : []"
                                  v-model="onSiteAttempt"
                                  :showLabels="false"
                                  placeholder=""
                                  :option-height="29"
                                  @input="saveOnsiteData"
                                  :max-height="203"
                                  :close-on-select="true"
                                  :disabled="isDisabledOnSiteSelects"
                                  class="board-multiselect-width"
                              />
                            </div>
                          </div>
                        </div>
                      </tab>
                      <tab name="Scheduling" id="scheduling">
                        <div class="card ex-card ex-invice-information" v-if="!isTechnicalUser">
                          <div class="card-block bg-white">
                            <div class="form-group row">
                              <label class="col-sm-4 col-4 col-form-label">Approximate Production Days</label>
                              <div class="col-sm-8 col-8">
                                <input
                                    @keypress="onlyNumber"
                                    :value="computedApproximateDays ? computedApproximateDays + ' Days' : '0 Days'"
                                    :disabled="true"
                                    class="form-control"/>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label class="col-sm-4 col-4 col-form-label">Date Arrived</label>
                              <div class="col-sm-8 col-8">
                                <date-picker :is-disabled="!isStatusActive || isDisabledFieldsByUserRole"
                                             v-model="arrivedDate"
                                             @onChange="autoUpdateArrivedDate"
                                             :placeHolderText="'Date Arrived'">
                                </date-picker>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label class="col-sm-4 col-4 col-form-label">Date Booked (Start)</label>
                              <div class="col-sm-8 col-8">
                                <date-picker v-model="booking_date"
                                             id="date_in"
                                             :is-disabled="!isStatusActive || isDisabledFieldsByUserRole"
                                             @onChange="autoUpdateBookingDate"
                                             :placeHolderText="'Date Booked (Start)'">
                                </date-picker>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label class="col-sm-4 col-4 col-form-label">Date Completed</label>
                              <div class="col-sm-8 col-8">
                                <date-picker v-model="completion_date"
                                             :is-disabled="!isStatusActive || isDisabledFieldsByUserRole"
                                             id="date_out"
                                             @onChange="autoUpdateCompletionDate"
                                             :placeHolderText="'Date Completed'">
                                </date-picker>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label class="col-sm-4 col-4 col-form-label">Date Picked Up</label>
                              <div class="col-sm-8 col-8">
                                <date-picker :is-disabled="!isStatusActive || isDisabledFieldsByUserRole"
                                             v-model="pickUpDate"
                                             @onChange="autoUpdatePickUpDate"
                                             :placeHolderText="'Date Picked Up'">
                                </date-picker>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label class="col-sm-4 col-4 col-form-label">Pick Up Time</label>
                              <div class="col-sm-8 col-8">
                                <vue-timepicker
                                    v-model="pickUpTime"
                                    :disabled="!isStatusActive || isDisabledFieldsByUserRole"
                                    :placeholder="'HH:MM'"
                                    format="hh:mm A"
                                    @close="(val)=>autoUpdatePickUpTime(val, false)"
                                    @change="(val)=>autoUpdatePickUpTime(val, true)"
                                    class="cards-edit-timepicker"
                                />
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-sm-4 col-4" style="padding-left: 0px">
                                <span style="display: block" class="col-form-label">Boards</span>
                                <span style="color: rgba(0, 0, 0, 0.5); font-size: 12px;">Add & remove the file to different boards</span>
                              </div>
                              <div class="col-sm-8 col-8">
                                <multiselect
                                    v-model="currentBoards"
                                    :options="['Vehicle In Board', 'Departure Board', 'Bookings Board']"
                                    :showLabels="false"
                                    placeholder=""
                                    :option-height="29"
                                    :max-height="203"
                                    @select="addCardToBoardFromMultiselect"
                                    @remove="removeCardToBoardFromMultiselect"
                                    :close-on-select="true"
                                    :disabled="!isStatusActive || isDisabledFieldsByUserRole"
                                    :multiple="true"
                                    class="board-multiselect-width scheduling-boards-multiselect"
                                />
                              </div>
                            </div>

                            <div class="form-group row"
                                 v-if="currentBoards && currentBoards.includes('Bookings Board')">
                              <div class="col-sm-4 col-4" style="padding-left: 0px">
                                <span style="display: block" class="col-form-label">Booking Board Category</span>
                              </div>
                              <div class="col-sm-8 col-8">
                                <multiselect
                                    :options="categoryOptions"
                                    v-model="computedBookingBoardCategory"
                                    :showLabels="false"
                                    placeholder=""
                                    :option-height="29"
                                    :max-height="203"
                                    track-by="id"
                                    label="name"
                                    @select="changedBookingCategory"
                                    :disabled="!isStatusActive || isDisabledFieldsByUserRole"
                                    class="board-multiselect-width"
                                >
                                  <template #singleLabel="{ option }">
                                    <span style="transform: translateY(3px);" class="categories-menu-color-icon"
                                          :style="{backgroundColor: option.color}"></span>
                                    <span>{{ option.name }}</span>
                                  </template>
                                  <template #option="{ option }">
                                    <span style="transform: translateY(3px);" class="categories-menu-color-icon"
                                          :style="{backgroundColor: option.color}"></span>
                                    <span>{{ option.name }}</span>
                                  </template>
                                </multiselect>
                              </div>
                            </div>

                            <div class="form-group row"
                                 v-if="boardDeparture && (boardDeparture.updatedDate || boardDeparture.departureDate)">
                              <label class="col-sm-4 col-4 col-form-label">Added to Departure Board</label>
                              <div class="col-sm-8 col-8">
                                <date-picker
                                    v-model="boardDeparture.departureDate || boardDeparture.updatedDate"
                                    :isDisabled="true"
                                    :placeHolderText="'Added to Departure Board'">
                                </date-picker>
                              </div>
                            </div>
                            <div class="form-group row"
                                 v-if="boardIn && boardIn.updatedDate">
                              <label class="col-sm-4 col-4 col-form-label">Added to Vehicle in Board</label>
                              <div class="col-sm-8 col-8">
                                <date-picker style="opacity: 1; border-radius: 3px;"
                                             v-model="boardIn.updatedDate"
                                             :isDisabled="true"
                                             :placeHolderText="'Added to Vehicle in Board'">
                                </date-picker>
                              </div>
                            </div>

                            <template
                                v-if="!(isDisplayBoardUser || isDetailerUser || isStripperFitterUser || isPaintTechnicianUser || isPanelTechnicianUser || isPDRTechnicianUser)">

                              <div class="estimage-line"></div>

                              <div style="margin-top: 40px">
                                <div class="form-group row">
                                  <label class="col-sm-4 col-4 col-form-label">On-site Estimate Booking Date</label>
                                  <div class="col-sm-8 col-8">
                                    <date-picker v-model="plannerBoard.onSite.onsiteEstimateBookingDate"
                                                 :is-disabled="true" @iconClicked="goToOnSiteEvent" :isShowIcon="true"
                                                 :placeHolderText="'Date'" class="on-site-booking-picker">
                                    </date-picker>
                                    <p v-if="plannerBoard.onSite.isRebooked"
                                       style="font-weight: bold; font-size: 12px; line-height: 16px; margin-bottom: 0px; margin-top: 7px;">
                                      Re-booked</p>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label class="col-sm-4 col-4 col-form-label">
                                    Attended Estimate Booking
                                  </label>
                                  <div class="col-sm-8 col-8 d-flex insurer-block-mobile">
                                    <div class="checkbox-p">
                                      <label class="form-check-inline checkbox d-flex">
                                        <input class="form-check-input" type="checkbox" name="nonAttReason"
                                               v-model="isAttendedBookingYes"
                                               @change="checkIsAttendYes(isAttendedBookingYes)"
                                               :disabled="!isStatusActive || isDisabledFieldsByUserRole"
                                        >
                                        <span class="icon"><i class='bx bx-check'></i></span><span
                                          class="text">Yes</span>
                                      </label>
                                    </div>
                                    <div class="checkbox-p">
                                      <label class="form-check-inline checkbox d-flex">
                                        <input class="form-check-input" type="checkbox" name="nonAttReason"
                                               hidden
                                               v-model="isAttendedBookingNo"
                                               @change="checkIsAttendNo(isAttendedBookingNo)"
                                               :disabled="!isStatusActive || isDisabledFieldsByUserRole">
                                        <span class="icon"><i class='bx bx-check'></i></span><span
                                          class="text">No</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-4 col-4" style="padding-left: 0px">
                                    <span style="display: block" class="col-form-label">Non-attendance reason</span>
                                  </div>
                                  <div class="col-sm-8 col-8">
                                    <multiselect
                                        :options="properties.estimateBooking && properties.estimateBooking.reasons ? properties.estimateBooking.reasons : []"
                                        v-model="onSiteReason"
                                        :showLabels="false"
                                        placeholder=""
                                        @input="saveOnsiteData"
                                        :option-height="29"
                                        :max-height="203"
                                        :close-on-select="true"
                                        :disabled="isDisabledOnSiteSelects"
                                        class="board-multiselect-width"
                                    />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-4 col-4" style="padding-left: 0px">
                                    <span style="display: block" class="col-form-label">Call back Attempts </span>
                                  </div>
                                  <div class="col-sm-8 col-8">
                                    <multiselect
                                        :options="properties.estimateBooking && properties.estimateBooking.attempts ? properties.estimateBooking.attempts : []"
                                        v-model="onSiteAttempt"
                                        :showLabels="false"
                                        placeholder=""
                                        :option-height="29"
                                        @input="saveOnsiteData"
                                        :max-height="203"
                                        :close-on-select="true"
                                        :disabled="isDisabledOnSiteSelects"
                                        class="board-multiselect-width"
                                    />
                                  </div>
                                </div>
                              </div>
                            </template>

                            <div class="medium-rectangle-b-promo-block">

                            </div>
                          </div>
                        </div>
                      </tab>
                    </tabs>
                    <div style="display: block" class="card ex-card wizard-bottom"
                         :class="{'progress-top': selectedVehicleSubTab == 'parts', 'progress-bottom': selectedVehicleSubTab == 'parts'}">
                      <small-form-wizard
                          title="Progress"
                          :current-status-id="card.card_status"
                          :statuses="card.statuses"
                          :progress="cardProgressSmall.widthActivePercent"
                          @change="onChangeCardProgress"
                          @full-clicked="activityTabChange"
                      />
                    </div>

                    <div class="medium-rectangle-b-promo-block">
                      <advert-banner
                          v-if="!isMobile"
                          :bannerType="2"
                      />
                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8 reset-padd">
                    <!-- Insurance block -->
                    <insurance-block
                        :card="card"
                        :assessors="assessors"
                        :estimates="itemsList"
                        :insurers="insurers"
                        @updateInsurance="autoUpdateInsurance"
                        @setRates="setRatesAfterInsuranceChanged"
                        @setDefaultValues="setDefaultValues"
                        @updateTotalLoss="autoUpdateVehicleTotalLoss"
                        :isDisabledIsurerName="properties.isFromIag || properties.isFromEio || properties.isFromAudaBridge || properties.isFromAudaNet"
                    ></insurance-block>
                  </div>
                  <div class="col-md-4 p-0 reset-padd padd-left-15">
                    <div class="card">
                      <div class="card-header bg-navyblue">
                        <strong>Rates</strong>
                      </div>
                      <estimate-rates
                          :estimateRates="estimateRates"
                          :defaultValues="defaultValues"
                          :card="card"
                          :properties="properties"
                          :isShowPaintMaterialNotification="isShowPaintMaterialNotification"
                          :isShowNewPaintColourNotification="isShowNewPaintColourNotification"
                          :isInsuranceRepairYes="isInsuranceRepairYes"
                          @autoUpdateRates="autoUpdateRates"
                          @loadTimesForItemPart="loadTimesForItemPart"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="currentTab === 'notes'" id="card-notes" role="tabpanel">
                <card-notes
                    ref="cardNotes"
                    :notes="notes"
                    :card_id="card.card_id"
                    @loadNotes="loadNotes"
                    @saveNote="saveNote">
                </card-notes>
              </div>
              <div v-show="currentTab === 'itemList'+(itemList.id)"
                   v-for="(itemList, itemIndex) in itemsList"
                   :key="'itemList'+(itemList.id)"
                   role="tabpanel">
                <assessment-auth
                    v-if="isAuthorisePage[itemList.id] && !isBlockByAuda"
                    :properties="properties"
                    :isFromIag="properties.isFromIag"
                    :isAutoSave="isAutoSave"
                    :estimateRatesUpdater="estimateRatesUpdater"
                    :timesForItemPart="computedTimesForItemPart"
                    :isDisabledRates="estimateRates.insurer_rate_id === 0 || !isStatusActive || isDisabledRates || isDisabledRatesRR"
                    :vehicleBody="card.vehicle.body"
                    :isAuthorisePage="isAuthorisePage[itemList.id]"
                    :estimate="itemList"
                    :iagOrmItems="iagOrmItems"
                    :card="card"
                    @changeEstimateParts="v => $set(itemList, 'parts', v)"
                    :estimateId="itemList.id"
                    @confirmedAuth="loadItemListAfterAuthorisation"
                    :currentTab="$route.params.subTab && $route.params.itemsListId == itemList.id? $route.params.subTab: 'RR'"
                    :isShowPaintSetupCalculation="itemList.isShowPaintSetupCalculation"
                    :isShowEnvironmentLevyCalculation="itemList.isShowEnvironmentLevyCalculation"
                    :isSentToIntegrationSystem="estimate.isSentToIntegrationSystem"
                    :isEstimateForButterfly="estimate.isEstimateForButterfly"
                    :isInsuranceRepairYes="isInsuranceRepairYes"
                    :isRSEstimateMethodology="isRSEstimateMethodology"
                    :isEstimateMethodologyZurich="isZurichEstimateMethodology"
                    :isEstimateMethodologyCustom="isEstimateMethodologyCustom"
                    :insurance="card.insurance"
                    :estimateMethodology="estimateRates.estimate_methodology"
                    :estimateParts="itemList.parts"
                    :rates="estimateRates"
                    :assessors="assessors"
                    :isVisibleToPDRTech2="itemList.isVisibleToPDRTech"
                    :removeEstimateParts="removeEstimateParts"
                    @loadTimesForItemPart="loadTimesForItemPart"
                    @autoSaveMessageUpdate="value => autoSaveMessage = value"
                    @updateRates="updateRates"
                    @saveItems="v => saveItemsList(itemList.id, v)"
                    @updateCalculation="updateCalculation"
                    @cancelAuthoriseEstimate="authoriseEstimate(false)"
                    @updateShowImportPdfParts="updateShowImportPdfParts"
                    @beforeDebouncedUnsavedChanges="beforeDebouncedUnsavedChanges"
                />
                <item-list
                    v-else
                    :ref="'itemList'+(itemList.id)"
                    :insurers="insurers"
                    :properties="properties"
                    :forcedSelectCard="forcedSelectCard"
                    :isFromIag="properties.isFromIag"
                    :isAutoSave="isAutoSave"
                    :selectedSchemeParts="isCanShowSchemeParts ? computedSelectedSchemeParts : []"
                    :timesForItemPart="computedTimesForItemPart"
                    :estimateRatesUpdater="estimateRatesUpdater"
                    :isBusinessTypeBikeRepairer="isBusinessTypeBikeRepairer"
                    :vehicleBody="card.vehicle.body"
                    :estimate="itemList"
                    :images="images"
                    @changeSubParts="changeSubParts"
                    :iagOrmItems="iagOrmItems"
                    :ordersUpdater="ordersUpdater"
                    :manualOrdersUpdater="manualOrdersUpdater"
                    :card="card"
                    :estimateId="itemList.id"
                    :currentTab="$route.params.subTab && $route.params.itemsListId == itemList.id? $route.params.subTab: (selectedCard[itemList.id] ? selectedCard[itemList.id] : 'RR')"
                    :isShowPaintSetupCalculation="itemList.isShowPaintSetupCalculation"
                    :isViewRunDamageAssmnt="isViewRunDamageAssmnt"
                    :isShowEnvironmentLevyCalculation="itemList.isShowEnvironmentLevyCalculation"
                    :isSentToIntegrationSystem="estimate.isSentToIntegrationSystem"
                    :isEstimateForButterfly="estimate.isEstimateForButterfly"
                    :isInsuranceRepairYes="isInsuranceRepairYes"
                    :isRSEstimateMethodology="isRSEstimateMethodology"
                    :isEstimateMethodologyLTARNTAR="isEstimateMethodologyLTARNTAR"
                    :isEstimateMethodologyZurich="isZurichEstimateMethodology"
                    :isEstimateMethodologyCustom="isEstimateMethodologyCustom"
                    :insurance="card.insurance"
                    :estimateMethodology="estimateRates.estimate_methodology"
                    :estimateParts="itemList.parts"
                    :rates="estimateRates"
                    :isVisibleToPDRTech2="itemList.isVisibleToPDRTech"
                    :removeEstimateParts="removeEstimateParts"
                    @del-assessment="onDelAssessment"
                    @rerun-assessment="runDamageAssmnt"
                    @loadTimesForItemPart="loadTimesForItemPart"
                    @selectedCard="v => selectedCard[itemList.id] = v"
                    @autoSaveMessageUpdate="value => autoSaveMessage = value"
                    @saveItems="v => saveItemsList(itemList.id, v)"
                    @updateCalculation="updateCalculation"
                    @updateShowImportPdfParts="updateShowImportPdfParts"
                    @beforeDebouncedUnsavedChanges="beforeDebouncedUnsavedChanges"
                    @addToSupplement="addToSupplement"
                    :isCanShowSchemeParts="isCanShowSchemeParts"
                    @update-vehicle="handleVehicleUpdate"
                    @reload-estimate="handleReloadEstimate"
                />
              </div>
              <div v-if="currentTab === 'images'" id="upload-images" role="tabpanel">
                <button v-if="(!isTechnicalUser || !isStatusActive) && isShowBigImage"
                        style="position: absolute; z-index: 9999999999; top: 80px; transform: translateX(10px);"
                        class="btn btn-primary mx-0 waves-effect waves-light" @click="pinImageOnBigImageView">
                  Pin Images
                </button>
                <div>
                  <vue-dropzone
                      v-if="isStatusActive"
                      v-on:vdropzone-file-added="addImgUpload"
                      v-on:vdropzone-success="successImgUpload"
                      v-on:vdropzone-complete="completeImgUpload"
                      v-on:vdropzone-sending="sendImgUpload"
                      ref="imgUpDrop"
                      id="imgUploadDrop"
                      class="dropify-wrapper dropzoneContainer"
                      style="height: auto;"
                      :options="imageUploadDropzoneOptions"
                      :useCustomSlot="true">
                    <div class="dropify-message " style="transform: translateY(0%);">
                      <template v-if="isMobile">
                        <i @click="openCapture" class='bx bx-camera drop-clickable file-icon'></i>
                        <p @click="openCapture" class="drop-down-text drop-clickable">Take a Photo</p>
                      </template>
                      <template v-else>
                        <i @click="addReload" class='bx bx-cloud-upload'></i>
                        <p class="drop-down-text">Drag and Drop Images Here</p>
                      </template>
                      <p class="text-or mb-0-5">Or</p>
                      <div class="text-sm-center mb-1 ex-image-upload-buttons">
                        <button @click.prevent="clickBrowseDropzoneImages($event)" type="button"
                                class="drop-clickable btn btn-primary waves-effect waves-light browse-btn browse-btn-images">
                          Browse Images
                        </button>
                        <button @click.prevent="clickCancelDropzoneImages($event)" type="button"
                                class="btn btn-secondary waves-effect waves-light cancel-btn">Cancel
                        </button>
                      </div>
                    </div>
                  </vue-dropzone>
                </div>

                <div class="row additional-estimate-images-block">
                  <image-lightbox
                      ref="imageLightbox"
                      :isPreviewImage="'true'"
                      :fromComponent="'estimate'"
                      :position="'below_drag_area'"
                      :imageList="imageSource"
                      :vehicle="card.vehicle"
                      :estimateNumber="estimate?.estimate_number"
                      :showContextMenu="true"
                      :boardInId="boardInId"
                      :isShowBigImage="isShowBigImage"
                      @moveToCategory="moveToCategory"
                      @showOrHideGallery="showOrHideGallery"
                      :boardDepartureId="boardDepartureId"
                      :is-delete="true"
                      @updateCategoryFunc="updateImageCategory"
                      @removeImage="deleteImage"
                      :path="''"
                  ></image-lightbox>
                </div>
              </div>
              <div v-if="currentTab === 'files'" id="upload-files" role="tabpanel">
                <vue-context ref="rightClickMenuForFiles" @open="contextOpen" @close="contextClose">
                  <ul slot-scope="item">
                    <li v-if="item.data && !item.data.isCardAccess" @click="moveToCardFiles(item.data)">Move to File
                      Docs
                    </li>
                    <li v-if="item.data && !item.data.isCardAccess" @click="copyToCardFiles(item.data)">Copy to File
                      Docs
                    </li>
                    <li v-if="item.data &&  item.data.isCardAccess" @click="removeFromCardFiles(item.data)">Remove from
                      File Docs
                    </li>
                    <li v-if="item && item.data && !item.data.isEdit" @click="editFile(item.data)">Edit Doc Name</li>
                    <!--                    <li v-if="item && item.data && item.data.isEdit" @click="editFile(item.data)">Stop Edit Doc Name</li>-->
                    <li v-if="item.data &&  item.data.isPdf" @click="openFileViewer(item.data)">View PDF</li>
                    <li @click="remTableFile(item.data.id)">Delete Doc</li>
                  </ul>
                </vue-context>
                <!--                              <card-files @beforeDebouncedAutoSave="beforeDebouncedAutoSave"></card-files>-->
                <div class="row">
                  <div class="w-100 card-files card-files-wrapper" v-if="!selectedFile">
                    <div class="row nav-title pagination-block-bottom">
                      <div class="col-md-8 p-0">
                        <b-table
                            class="rs-scroll rs-scroll--y noselect"
                            responsive
                            bordered
                            :items="files"
                            :fields="fields"
                            :current-page="cardsCurrentPage"
                            :per-page="cardsPerPage"
                            @row-contextmenu="openMenuForFiles"
                        >
                          <template v-slot:cell(name)="data">
                            <input v-if="data.item.isEdit" v-model="data.item.name2" @change="saveFile(data.item)"
                                   class="form-control"/>
                            <span v-else-if="data.item.isPdf" @click="openFileViewer(data.item)" class="file-name-span">{{
                                data.item.name
                              }}</span>
                            <a v-else class="file-name-span" :download="data.item.name" :href="data.item.url"
                               target="_blank">{{ data.item.name }}</a>
                          </template>
                          <template v-slot:cell(type)="data">
                            <multiselect
                                v-if="data.item.isEdit"
                                :options="fileTypeOptions.map(opt => {return opt.value})"
                                v-model="data.item.type"
                                :showLabels="false"
                                :option-height="29"
                                class="type-multiselect"
                                :max-height="150"
                                @input="saveFile(data.item)"
                                :close-on-select="true"
                                placeholder="Type"
                                :disabled="!isStatusActive"
                            >
                              <template #singleLabel="{ option }">
                                <span>{{ getFileTypeLabel(option) }}</span>
                              </template>
                              <template #option="{ option }">
                                <span>{{ getFileTypeLabel(option) }}</span>
                              </template>
                            </multiselect>
                            <span v-else>{{ getFileTypeLabel(data.item.type) }}</span>
                          </template>
                          <template v-slot:cell(uploaded_by)="data">
                            <span class="uploaded-by">{{ data.item.user }}</span>
                          </template>
                          <template v-slot:cell(sortDate)="data">
                            <span class="uploaded-date">{{ data.item.date }} </span>
                          </template>
                          <template v-slot:cell(fileSize)="data">
                            <span class="file-size">{{ data.item.fileSize | formatFileSize }}</span>
                          </template>
                          <template v-slot:cell(action)="data">
                            <div class="d-flex">
                              <i
                                  @click="editFile(data.item)"
                                  v-b-tooltip.hover="{customClass: 'ps-tooltip', title: `Edit doc name and type`, placement: 'left'}"
                                  class='bx bx-edit-alt'
                                  style="color: #5E79FF; font-size: 22px; margin-right: 5px; transform: translateY(-1px); cursor: pointer">
                              </i>
                              <i
                                  v-if="data.item && data.item.isPdf"
                                  @click="getPdfViewerParameters(); selectedFile = data.item"
                                  class='bx bxs-file-pdf'
                                  v-b-tooltip.hover="{customClass: 'ps-tooltip', title: `View PDF`, placement: 'left'}"
                                  style="color: #bd5008; font-size: 22px; margin-right: 5px; transform: translateY(-1px); cursor: pointer"></i>
                              <a v-if="isShopManagerUser || isProductionManagerUser || isEstimatorUser || isPDRTechnicianUser"
                                 @click="remTableFile(data.item.id)"
                                 class="trash-icon"
                                 v-b-tooltip.hover="{customClass: 'ps-tooltip', title: 'Delete File', placement:'leftbottom'}"
                              >
                                <svg width="18px" height="20px" viewBox="0 0 18 20" version="1.1"
                                     xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink">
                                  <!-- Generator: sketchtool 60.1 (101010) - https://sketch.com -->
                                  <desc>Created with sketchtool.</desc>
                                  <g id="UI-Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Dashboard-Redesign-(Detail-Cards)Files"
                                       transform="translate(-1264.000000, -933.000000)" fill="#FF5E5E"
                                       fill-rule="nonzero">
                                      <g id="Group-4" transform="translate(265.000000, 933.000000)">
                                        <g id="trash" transform="translate(999.000000, 0.000000)">
                                          <path
                                              d="M6,2 L6,1 C6,0.44771525 6.44771525,0 7,0 L11,0 C11.5522847,0 12,0.44771525 12,1 L12,2 L16,2 C17.1045695,2 18,2.8954305 18,4 L18,5 C18,6.1045695 17.1045695,7 16,7 L15.867,7 L15.187,17.2 C15.081727,18.775582 13.773095,20 12.194,20 L5.826,20 C4.24834545,20 2.94028051,18.7780028 2.833,17.204 L2.137,7 L2,7 C0.8954305,7 0,6.1045695 0,5 L0,4 C0,2.8954305 0.8954305,2 2,2 L6,2 Z M16,4 L2,4 L2,5 L16,5 L16,4 Z M4.141,7 L4.828,17.068 C4.86376888,17.5927957 5.29998676,18.0001655 5.826,18 L12.194,18 C12.7207338,18 13.1572356,17.5915853 13.192,17.066 L13.862,7 L4.142,7 L4.141,7 Z M7,8 C7.55228475,8 8,8.44771525 8,9 L8,16 C8,16.5522847 7.55228475,17 7,17 C6.44771525,17 6,16.5522847 6,16 L6,9 C6,8.44771525 6.44771525,8 7,8 Z M11,8 C11.5522847,8 12,8.44771525 12,9 L12,16 C12,16.5522847 11.5522847,17 11,17 C10.4477153,17 10,16.5522847 10,16 L10,9 C10,8.44771525 10.4477153,8 11,8 Z"
                                              id="Shape"></path>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                              </a>
                            </div>
                          </template>
                        </b-table>
                        <!--                                    <table class="table">-->
                        <!--                                      <thead class="bg-navyblue">-->
                        <!--                                      <tr>-->
                        <!--                                        &lt;!&ndash;<th>Select</th>&ndash;&gt;-->
                        <!--                                        <th>Doc Name</th>-->
                        <!--                                        <th>Uploaded By</th>-->
                        <!--                                        <th class="text-center">Date</th>-->
                        <!--                                        <th class="text-center">Delete</th>-->
                        <!--                                      </tr>-->
                        <!--                                      </thead>-->
                        <!--                                      <tbody>-->
                        <!--                                      <tr v-for="(file, index) in files">-->
                        <!--                                        &lt;!&ndash;<td><input type="checkbox" /></td>&ndash;&gt;-->
                        <!--                                        <td><a :href="file.url" target="_blank">{{file.name}}</a></td>-->
                        <!--                                        <td>{{file.user}}</td>-->
                        <!--                                        <td class="text-center">{{file.date}}</td>-->
                        <!--                                        <th class="text-center"><i @click="remTableFile(index)" class="ti-trash clickable"></i></th>-->
                        <!--                                      </tr>-->
                        <!--                                      </tbody>-->
                        <!--                                    </table>-->
                      </div>
                      <div class="col-md-4">
                        <div>
                          <vue-dropzone
                              v-if="isStatusActive"
                              v-on:vdropzone-removed-file="removeFileDropzone"
                              v-on:vdropzone-file-added="addFileUpload"
                              v-on:vdropzone-complete="completeFileUpload"
                              v-on:vdropzone-sending="sendFileUpload"
                              v-on:vdropzone-success="successFileUpload"
                              ref="fileUpDrop"
                              id="fileUploadDrop"
                              class="dropify-wrapper dropzoneContainer"
                              style="height: auto;"
                              :options="fileUploadDropzoneOptions"
                              :useCustomSlot=true>
                            <div class="dropify-message" style="transform: translateY(0%);">
                              <i class='bx bx-cloud-upload'></i>
                              <p class="dnd-title">Drag and Drop Doc Here</p>
                              <p class="text-or mb-0-5 dnd-or">Or</p>
                              <div class="text-sm-center mb-1 ex-image-upload-buttons">
                                <button type="button"
                                        class="btn btn-primary waves-effect waves-light browse-btn browse-btn-files">
                                  Browse Docs
                                </button>
                                <button @click="clickCancelDropzoneFiles" type="button"
                                        class="btn btn-secondary waves-effect waves-light cancel-btn">Cancel
                                </button>
                              </div>
                            </div>

                          </vue-dropzone>
                        </div>
                        <button type="button" style="width: calc(100% - 30px); margin: 10px 0px 0px 15px;"
                                @click="isShowScanner = !isShowScanner"
                                class="btn btn-primary w-min-sm waves-effect waves-light">
                          Select Scanner
                        </button>
                        <div v-if="isShowScanner" class="scanner-items">
                          <template v-if="getActivePcs(pcs) && getActivePcs(pcs).length">
                            <div
                                v-for="pc in getActivePcs(pcs)"
                                :key="pc.id"
                                @click="selectPc(pc)"
                                class="scanner-item"
                                :class="{'selected-scanner-item': pc.id == selectedPcId}"
                            >
                              {{ pc.pc_name }}
                            </div>
                          </template>
                          <template v-else>
                            <div class="scanner-item">No Active Scanners</div>
                          </template>
                        </div>
                        <div class="current-scanner" v-else-if="selectedPcId">
                          Current Scanner: {{ selectedPcName }}
                        </div>
                      </div>
                    </div>
                    <block-pagination
                        :role="'Docs'"
                        :count="files.length"
                        :countFiltered="files.length"
                        :currentPage="cardsCurrentPage"
                        @changedCurrentPage="value => cardsCurrentPage = value"
                        :perPage="cardsPerPage"
                        @changedPerPage="value => cardsPerPage = value"
                    >
                    </block-pagination>
                  </div>
                  <template v-else>
                    <pdf-viewer :documentHeight="documentHeight" :documentWidth="documentWidth"
                                :documentPath="selectedFile && selectedFile.url ? selectedFile.url : ''"
                                @closePdf="onClosePdf"></pdf-viewer>
                  </template>
                </div>
              </div>
              <!--                            <div v-if="supplement_number === 0 && currentTab === 'supplements'" id="supplements" role="tabpanel">-->
              <!--                                <estimate-supplements-->
              <!--                                        :supplements="supplements"-->
              <!--                                        :total-supplements="totalSupplements"-->
              <!--                                        @removeSupplement="removeSupplement"-->
              <!--                                />-->
              <!--                            </div>-->
              <div v-if="currentTab === 'activity'" id="activity" role="tabpanel">
                <div class="row sticky" :style="`top: ${topSticky}px`">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 additional-card-progress-scroll">
                    <rs-form-wizard
                        :current-status="card.card_status"
                        :statuses="card.statuses"
                        :progress="cardProgress.widthActivePercent"
                        @change="onChangeCardProgress"
                    />
                  </div>


                  <div class="col-md-12">
                    <div class="border-top"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-10 col-xl-8">
                    <div class="row activity-list-header px-0">
                      <div class="col-xs-6">
                        <h4>ACTIVITY LIST</h4>
                      </div>
                      <div class="col-md-6">
                        <div class="navbar-nav nav dropdown dropdown-options show inline float-right mr-0">
                                                    <span class="btn waves-effect waves-light ex-options-button"
                                                          data-toggle="dropdown"
                                                          aria-haspopup="true"
                                                          aria-expanded="true">
                                                            {{ activitySortTypeText }}
                                                            <span class="dropdown-arrow  pull-right"
                                                                  style="box-sizing: border-box; width: 30px; border-left: 1px solid rgba(27, 30, 56, 0.25);">
                                                            <i class="fa fa-chevron-down pull-right"></i>
                                                </span>
                                                    </span>
                          <div class="dropdown-menu dropdown-menu-right animated fadeInUp">
                            <a @click="changeActivitySortBy(activitySortTypes.email)"
                               class="dropdown-item text-primary p-1 clickable"><i class="fa fa-envelope-o"
                                                                                   aria-hidden="true"></i>
                              {{ activitySortTypes.email }}</a>
                            <a v-if="isSmsAvailable" @click="changeActivitySortBy(activitySortTypes.sms)"
                               class="dropdown-item text-primary p-1 clickable"><i class="fa fa-envelope-o"
                                                                                   aria-hidden="true"></i>
                              {{ activitySortTypes.sms }}</a>
                            <a @click="changeActivitySortBy(activitySortTypes.external)"
                               class="dropdown-item text-primary p-1 clickable"><i class="fa fa-external-link"
                                                                                   aria-hidden="true"></i>
                              {{ activitySortTypes.external }}</a>
                            <a @click="changeActivitySortBy(activitySortTypes.assignment)"
                               class="dropdown-item text-primary p-1 clickable"><i class="fa fa-user"
                                                                                   aria-hidden="true"></i>
                              {{ activitySortTypes.assignment }}</a>
                            <a @click="changeActivitySortBy(activitySortTypes.status_change)"
                               class="dropdown-item text-primary p-1 clickable"><i
                                class="fa fa-pencil-square-o" aria-hidden="true"></i>
                              {{ activitySortTypes.status_change }}</a>
                            <a v-if="this.activitySortTypeText != 'Sort By' && this.activitySortTypeText != 'Show All'"
                               @click="changeActivitySortBy(activitySortTypes.show_all)"
                               class="dropdown-item text-primary p-1 clickable"
                               style="padding-left: 28px !important">{{ activitySortTypes.show_all }}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-10 col-xl-8">
                    <activity-list
                        :activity="activity"
                        :newTask="newTask"
                        :isOpenNewTaskForm="isOpenNewTaskForm"
                        :cardId="card.card_id"
                        :isCanReplyTo="properties.smsReply"
                        :estimateId="$route.params.estimate_id"
                        :filteredListAssignedTo="getterVisibleUsers"
                        @loadActivity="loadActivity"
                        @saveTask="saveTask"
                        @saveNewTask="saveNewTask"
                        @closeTask="closeTask"
                        @deleteTask="deleteTask"
                        @deleteActivity="deleteActivity"
                        @closeNewTask="closeNewTask"
                    >
                    </activity-list>
                  </div>
                  <div class="col-xl-4">
                    <div class="desktop-b-promo-block estimare-activiFty-list-b-promo">
                      <advert-banner
                          v-if="!isMobile"
                          :bannerType="4"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <amazon-ads></amazon-ads>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-wizard class="delete-supp-modal" ref="deleteSuppModal" finishButtonText="Ok" @on-complete="removeSupplement">
      <modal-wizard-tab title="Deletion of Supplement">
        <div style="margin-bottom: 15px; margin-top:5px">
          Do you want to Delete this Supplement?
        </div>
      </modal-wizard-tab>
    </modal-wizard>
    <modal-wizard ref="paintMaterialNotificationModal" v-bind:hideCancelButton="true" finishButtonText="Ok"
                  @on-complete="paintMaterialNotificationCompleted" id="paintMaterialNotificationModal">
      <modal-wizard-tab title="Form Check - Notification">
        <template>
          <h5 style="text-align: center; padding: 30px; line-height: 1.6">
            A selection in the Paint Material field has not been made. <br/>
            Please select a value to be saved.
          </h5>
          <div style="padding: 0 20px; line-height: 1.8; margin-bottom:30px">
            Paint Material: This field allows for the system to automatically to apply the paint times and calculate
            materials for vehicles with a shedule number.
          </div>
        </template>
      </modal-wizard-tab>
    </modal-wizard>

    <div class="estimate-preview-visual">
      <modal-wizard ref="previewADJPreEstimateModal" cancelButtonText="Close" finishButtonText="Print PDF"
                    @on-complete="downloadPreAdjEstimate">
        <modal-wizard-tab
            :title="isSupplementItemListTab? ' Print Pre Adjusted Supplement':' Print Pre Adjusted Estimate'"
            description="" title-icon-class="ti-align-right" :tabData="estimateToCustomer">
          <template slot-scope="props">
            <div style="display: none">{{ sctollToTop() }}</div>

            <div class="invoice" style="min-width: auto;">
              <header class="invoice-header">
                <div class="invoice-logo">
                  <img :src="vendorInfo.logo" style="height: 225px; width: 450px;" alt="">
                </div>
                <div class="invoice-info">
                  <h1 class="invoice-title">ESTIMATE</h1>
                  <table class="header-table">
                    <tr>
                      <td class="fz16">{{ props.vendor.business_name }}</td>
                    </tr>
                    <tr>
                      <td>ABN : {{ props.vendor.abn }}</td>
                    </tr>
                    <tr>
                      <td>License: {{ props.vendor.license_number }}</td>
                    </tr>
                    <tr v-if="props.vendor.postal_address">
                      <td>{{ props.vendor.postal_address }}</td>
                    </tr>
                    <tr v-if="!props.vendor.postal_address">
                      <td>{{ props.vendor.postal_street }} {{ props.vendor.postal_suburb }}</td>
                    </tr>
                    <tr v-if="!props.vendor.postal_address">
                      <td>{{ props.vendor.postal_state }} {{ props.vendor.postal_country }}</td>
                    </tr>
                    <tr>
                      <td>Email: {{ props.vendor.email }}</td>
                    </tr>
                    <tr>
                      <td>Phone: {{ props.vendor.phone_area_code }} {{ props.vendor.phone }}</td>
                    </tr>
                  </table>

                  <table class="header-table">
                    <tr>
                      <td><strong>Estimate Number:</strong> <span>{{ props.estimate.estimate_number }}<template
                          v-if="props.estimate.supplement_number && props.estimate.supplement_number>0">-{{
                          props.estimate.supplement_number
                        }}</template></span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Estimator:</strong> <span>{{ props.estimate.estimator }}</span></td>
                    </tr>
                    <tr>
                      <td><strong>Date:</strong> <span>{{ props.estimate.created_on }}</span></td>
                    </tr>
                    <tr>
                      <td><strong>Expiry:</strong> <span>{{ props.estimate.expires_on }}</span></td>
                    </tr>
                  </table>
                </div>
              </header>

              <main class="main-flex">
                <table class="main-table m0 table-fixed owner-vehicle-title">
                  <thead>
                  <tr>
                    <th colspan="2">Vehicle &amp; Owner</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="mobile-disabled">
                    <th>Owner Details</th>
                    <th>Vehicle Details</th>
                  </tr>
                  <tr>
                    <td class="w50 vat">
                      <table class="main-inner owner-details">
                        <tr>
                          <td>Owner Name</td>
                          <td>{{ props.customer.customer_name }}</td>
                        </tr>
                        <tr>
                          <td>Home Phone</td>
                          <td>{{ props.customer.phone }}</td>
                        </tr>
                        <tr>
                          <td>Mobile Phone</td>
                          <td>{{ props.customer.mobile }}</td>
                        </tr>
                        <tr>
                          <td>Email</td>
                          <td>{{ props.customer.email }}</td>
                        </tr>
                        <tr v-if="props.customer.customer_type == 'B'">
                          <td>ABN</td>
                          <td>{{ props.customer.abn }}</td>
                        </tr>
                        <tr>
                          <td>Insurer Name</td>
                          <td>{{ props.insurance.insurer_name }}</td>
                        </tr>
                        <tr>
                          <td>Insurer ABN</td>
                          <td>{{ props.insurance.abn }}</td>
                        </tr>
                        <tr>
                          <td>Claim Number</td>
                          <td>{{ props.insurance.claim_number }}</td>
                        </tr>
                        <tr v-if="props.rates.estimate_methodology == 'ntar'">
                          <td>NTAR Schedule</td>
                          <td></td>
                        </tr>
                      </table>
                    </td>
                    <td class="w50 vat">
                      <table class="vehicle-details">
                        <tr>
                          <td class="w50 vat">
                            <table class="main-inner">
                              <tr>
                                <td>Make</td>
                                <td>{{ props.customer_vehicle.make }}</td>
                              </tr>
                              <tr>
                                <td>Model</td>
                                <td>{{ props.customer_vehicle.model }}</td>
                              </tr>
                              <tr>
                                <td>Series</td>
                                <td v-if="!props.properties.isHideSeries">{{ props.customer_vehicle.series }}</td>
                              </tr>
                              <tr v-if="!isEstimateMethodologyCustom && card.vehicle.series_shedule_number != ''">
                                <td>Schedule Number</td>
                                <td v-if="isRSEstimateMethodology"></td>
                                <td v-else>{{ card.vehicle.series_shedule_number }}</td>
                              </tr>
                              <tr>
                                <td>Transmission</td>
                                <td>{{ props.customer_vehicle.transmission }}</td>
                              </tr>
                              <tr>
                                <td>Paint Code</td>
                                <td>{{ props.customer_vehicle.colour }}</td>
                              </tr>
                            </table>
                          </td>
                          <td class="w50 vat">
                            <table class="main-inner">
                              <tr>
                                <td>Rego</td>
                                <td>{{ props.customer_vehicle.rego_number }}</td>
                              </tr>
                              <tr>
                                <td>VIN Number</td>
                                <td>{{ props.customer_vehicle.vin }}</td>
                              </tr>
                              <tr>
                                <td>Cylinders</td>
                                <td>{{ props.customer_vehicle.cylinders }}</td>
                              </tr>
                              <tr>
                                <td>Build Date</td>
                                <td>{{ props.customer_vehicle.dom }}</td>
                              </tr>
                              <tr>
                                <td>Odometer</td>
                                <td>{{ props.customer_vehicle.odometer }}</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table
                    v-if="props.line_items.lines.RR.length>0 || props.line_items.lines.Paint.length>0 || props.line_items.lines.Repair.length>0"
                    class="main-table m0">
                  <thead>
                  <tr>
                    <th>Repairs</th>
                  </tr>
                  </thead>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.RR.length && props.line_items.summary['RR-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>R&amp;R</th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Hrs</span>
                    </th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Rate</span>
                    </th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.RR">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{ line.hrs_str }}</span>
                    </td>
                    <td class="text-right">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{ line.rate_str }}</span>
                    </td>

                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="rr-subtotal-hrs">
                    <td class="font-bold text-align-right">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Subtotal Hrs</span>
                    </td>
                    <td class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>{{ props.line_items.summary['RR-Hrs-SubTotal-Str'] }}</span>
                    </td>
                    <td></td>

                    <td></td>
                  </tr>
                  <tr class="rr-subtotal-amount">
                    <td></td>

                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['RR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.RR.length && props.line_items.summary['RR-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>R&amp;R</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.RR">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="rr-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['RR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Repair.length && props.line_items.summary['Repair-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Repair</th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Hrs</span>
                    </th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Rate</span>
                    </th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Repair">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else> {{ line.hrs_str }}</span>
                    </td>
                    <td class="text-right">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else> {{ line.rate_str }}</span>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="rr-subtotal-hrs">
                    <td class="font-bold text-align-right">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Subtotal Hrs</span>
                    </td>
                    <td class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>{{ props.line_items.summary['Repair-Hrs-SubTotal-Str'] }}</span>
                    </td>
                    <td></td>

                    <td></td>
                  </tr>
                  <tr class="rr-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Repair-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Repair.length && props.line_items.summary['Repair-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Repair</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Repair">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="rr-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Repair-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Paint.length && props.line_items.summary['Paint-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Paint</th>
                    <th class="text-center">Paint Material</th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Hrs</span>
                    </th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Rate</span>
                    </th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Paint">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.paint_type_str }}</td>
                    <td class="text-center">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{ line.hrs_str }}</span>
                    </td>
                    <td class="text-right">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{ line.rate_str }}</span>
                    </td>

                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-hrs">
                    <td colspan="2" class="text-right color-dark-grey">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Subtotal Hrs</span>
                    </td>
                    <td class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>{{ props.line_items.summary['Paint-Hrs-SubTotal-Str'] }}</span>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td colspan="2" class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right">{{ props.line_items.summary['Paint-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Paint.length && props.line_items.summary['Paint-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Paint</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Paint">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Paint-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table
                    v-if="!isBlockByAuda && (!!props.line_items.lines.Paint.length || !!props.line_items.lines.Repair.length || !!props.line_items.lines.RR.length)"
                    class="repairs-total main-table main-total-table"
                >
                  <tbody>
                  <tr v-if="props.line_items.summary['Labour-Hrs-Str'] != '' && !isEstimateMethodologyDollars">
                    <td class="font-bold text-align-right">Total Labour Hours</td>
                    <td class="text-align-right">{{ props.line_items.summary['Labour-Hrs-Str'] }}</td>
                  </tr>
                  <tr>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-align-right">{{ props.line_items.summary['Labour-Cost-Str'] }}</td>
                  </tr>
                  </tbody>
                </table>

                <table class="main-table estimate-parts border-t" v-if="!!props.line_items.lines.Part.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Parts</th>
                    <th colspan="2">Part No</th>
                    <th class="text-center">Qty</th>
                    <th class="text-center">Unit Price</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Part">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td colspan="2" class="font-bold" style="word-break: break-all;">{{ line.part_num }}</td>
                    <td class="font-bold text-center">{{ line.qty }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="parts-subtotal-hrs">
                    <td></td>

                    <td></td>
                    <td></td>
                    <td colspan="2" class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Part-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-parts border-t" v-if="!!props.line_items.lines.Materials.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Materials</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Materials">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="parts-subtotal-hrs">
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Materials-Total-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-other border-t"
                       v-if="!!props.line_items.lines.Sublet.length && props.line_items.summary['Sublet-Hrs-SubTotal-Str'] != ''">
                  <thead class="th-fz12">
                  <tr>
                    <th>Sublet</th>
                    <th class="text-center">Repairer</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Rate</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Sublet">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.repairer }}</td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-hrs">
                    <td class="text-right color-dark-grey" colspan="2">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Subtotal Hrs</span>
                    </td>
                    <td class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>{{ props.line_items.summary['Sublet-Hrs-SubTotal-Str'] }}</span>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Sublet-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-other border-t"
                       v-if="!!props.line_items.lines.Sublet.length && props.line_items.summary['Sublet-Hrs-SubTotal-Str'] == ''">
                  <thead class="th-fz12">
                  <tr>
                    <th>Sublet</th>
                    <th class="text-center">Repairer</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Sublet">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.repairer }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-amount">
                    <td class="text-right font-bold" colspan="2">Subtotal Amount</td>
                    <td class="text-center">{{ props.line_items.summary['Sublet-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-sublet m0 border-t" v-if="!!props.line_items.lines.Other.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Other</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Other">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Other-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <!--PDR-->
                <table class="main-table estimate-pdr m0 border-t"
                       v-if="props.line_items.lines.PDR && props.line_items.lines.PDR.length>0">
                  <thead class="th-fz12">
                  <tr>
                    <th>PDR</th>
                    <th class="text-center">Material</th>
                    <th class="text-center">Action</th>
                    <th class="text-center">Qty</th>
                    <th class="text-center">Price</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(line, index) in props.line_items.lines.PDR" :key="index">
                    <td>
                      <div style="white-space: pre-line; align-text-top;">{{ line.name }}</div>
                      <div v-if="line.comment">Comment : {{ line.comment }}</div>
                    </td>
                    <td class="text-center align-text-top">
                      <template v-if="line.type === 'Panel'">{{ line.material }}</template>
                    </td>
                    <td class="text-center  align-text-top">
                      <template v-if="line.type === 'Panel'">{{ line.action|valuePDRMaterial }}</template>
                    </td>
                    <td class="text-center  align-text-top">{{ line.qty }}</td>
                    <td class="text-right  align-text-top">{{ line.price_str }}</td>
                    <td class="text-right  align-text-top">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['PDR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table  m0">
                  <thead>
                  </thead>
                  <tbody></tbody>
                </table>
                <table class="parts-total main-table main-total-table">
                  <tbody>
                  <tr v-if="!isBlockByAuda && props.line_items.countSubtotal && props.line_items.countSubtotal > 1">
                    <td class="color-dark-grey right">Total</td>
                    <td class="right">{{ props.line_items.summary.Total_str }}</td>
                  </tr>
                  <tr>
                    <td class="font-bold text-right border-bottom">GST</td>
                    <td class="text-right border-bottom">{{ props.line_items.summary.GST_str }}</td>
                  </tr>
                  <tr>
                    <td class="color-dark-grey right"><strong>Total Inc GST</strong></td>
                    <td class="color-dark-grey right"><strong>{{ props.line_items.summary.GrandTotal_str }}</strong>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </main>
              <footer>
                <table class="footer-table" v-if="props.terms !== '' || !props?.note_terms">
                  <thead>
                  <tr>
                    <th>Terms</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td v-html="props.terms"></td>
                  </tr>
                  </tbody>
                </table>
                <table class="footer-table" v-if="props?.note_terms">
                  <thead>
                  <tr>
                    <th>Estimate Note</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td v-html="props.note_terms"></td>
                  </tr>
                  </tbody>
                </table>
              </footer>
            </div>
          </template>
        </modal-wizard-tab>
      </modal-wizard>
    </div>

    <div class="estimate-preview-visual">
      <modal-wizard ref="previewEstimateModal" cancelButtonText="Close" finishButtonText="Print PDF"
                    @on-complete="downloadEstimate">
        <modal-wizard-tab :title="isSupplementItemListTab? 'Preview Supplement':'Preview Estimate'" description=""
                          title-icon-class="ti-align-right" :tabData="estimateToCustomer">
          <template slot-scope="props">
            <div style="display: none">{{ sctollToTop() }}</div>

            <div class="invoice" style="min-width: auto;">
              <header class="invoice-header">
                <div class="invoice-logo">
                  <img :src="vendorInfo.logo" style="height: 225px; width: 450px;" alt="">
                </div>
                <div class="invoice-info">
                  <h1 class="invoice-title">ESTIMATE</h1>
                  <table class="header-table">
                    <tr>
                      <td class="fz16">{{ props.vendor.business_name }}</td>
                    </tr>
                    <tr>
                      <td>ABN : {{ props.vendor.abn }}</td>
                    </tr>
                    <tr>
                      <td>License: {{ props.vendor.license_number }}</td>
                    </tr>
                    <tr v-if="props.vendor.postal_address">
                      <td>{{ props.vendor.postal_address }}</td>
                    </tr>
                    <tr v-if="!props.vendor.postal_address">
                      <td>{{ props.vendor.postal_street }} {{ props.vendor.postal_suburb }}</td>
                    </tr>
                    <tr v-if="!props.vendor.postal_address">
                      <td>{{ props.vendor.postal_state }} {{ props.vendor.postal_country }}</td>
                    </tr>
                    <tr>
                      <td>Email: {{ props.vendor.email }}</td>
                    </tr>
                    <tr>
                      <td>Phone: {{ props.vendor.phone_area_code }} {{ props.vendor.phone }}</td>
                    </tr>
                  </table>

                  <table class="header-table">
                    <tr>
                      <td><strong>Estimate Number:</strong> <span>{{ props.estimate.estimate_number }}<template
                          v-if="props.estimate.supplement_number && props.estimate.supplement_number>0">-{{
                          props.estimate.supplement_number
                        }}</template></span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Estimator:</strong> <span>{{ props.estimate.estimator }}</span></td>
                    </tr>
                    <tr>
                      <td><strong>Date:</strong> <span>{{ props.estimate.created_on }}</span></td>
                    </tr>
                    <tr>
                      <td><strong>Expiry:</strong> <span>{{ props.estimate.expires_on }}</span></td>
                    </tr>
                  </table>
                </div>
              </header>

              <main class="main-flex">
                <table class="main-table m0 table-fixed owner-vehicle-title">
                  <thead>
                  <tr>
                    <th colspan="2">Vehicle &amp; Owner</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="mobile-disabled">
                    <th>Owner Details</th>
                    <th>Vehicle Details</th>
                  </tr>
                  <tr>
                    <td class="w50 vat">
                      <table class="main-inner owner-details">
                        <tr>
                          <td>Owner Name</td>
                          <td>{{ props.customer.customer_name }}</td>
                        </tr>
                        <tr>
                          <td>Home Phone</td>
                          <td>{{ props.customer.phone }}</td>
                        </tr>
                        <tr>
                          <td>Mobile Phone</td>
                          <td>{{ props.customer.mobile }}</td>
                        </tr>
                        <tr>
                          <td>Email</td>
                          <td>{{ props.customer.email }}</td>
                        </tr>
                        <tr v-if="props.customer.customer_type == 'B'">
                          <td>ABN</td>
                          <td>{{ props.customer.abn }}</td>
                        </tr>
                        <tr>
                          <td>Insurer Name</td>
                          <td>{{ props.insurance.insurer_name }}</td>
                        </tr>
                        <tr>
                          <td>Insurer ABN</td>
                          <td>{{ props.insurance.abn }}</td>
                        </tr>
                        <tr>
                          <td>Claim Number</td>
                          <td>{{ props.insurance.claim_number }}</td>
                        </tr>
                        <tr v-if="props.rates.estimate_methodology == 'ntar'">
                          <td>NTAR Schedule</td>
                          <td></td>
                        </tr>
                      </table>
                    </td>
                    <td class="w50 vat">
                      <table class="vehicle-details">
                        <tr>
                          <td class="w50 vat">
                            <table class="main-inner">
                              <tr>
                                <td>Make</td>
                                <td>{{ props.customer_vehicle.make }}</td>
                              </tr>
                              <tr>
                                <td>Model</td>
                                <td>{{ props.customer_vehicle.model }}</td>
                              </tr>
                              <tr>
                                <td>Series</td>
                                <td v-if="!props.properties.isHideSeries">{{ props.customer_vehicle.series }}</td>
                              </tr>
                              <tr v-if="!isEstimateMethodologyCustom && card.vehicle.series_shedule_number != ''">
                                <td>Schedule Number</td>
                                <td v-if="isRSEstimateMethodology"></td>
                                <td v-else>{{ card.vehicle.series_shedule_number }}</td>
                              </tr>
                              <tr>
                                <td>Transmission</td>
                                <td>{{ props.customer_vehicle.transmission }}</td>
                              </tr>
                              <tr>
                                <td>Paint Code</td>
                                <td>{{ props.customer_vehicle.colour }}</td>
                              </tr>
                            </table>
                          </td>
                          <td class="w50 vat">
                            <table class="main-inner">
                              <tr>
                                <td>Rego</td>
                                <td>{{ props.customer_vehicle.rego_number }}</td>
                              </tr>
                              <tr>
                                <td>VIN Number</td>
                                <td>{{ props.customer_vehicle.vin }}</td>
                              </tr>
                              <tr>
                                <td>Cylinders</td>
                                <td>{{ props.customer_vehicle.cylinders }}</td>
                              </tr>
                              <tr>
                                <td>Build Date</td>
                                <td>{{ props.customer_vehicle.dom }}</td>
                              </tr>
                              <tr>
                                <td>Odometer</td>
                                <td>{{ props.customer_vehicle.odometer }}</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table
                    v-if="props.line_items.lines.RR.length>0 || props.line_items.lines.Paint.length>0 || props.line_items.lines.Repair.length>0"
                    class="main-table m0">
                  <thead>
                  <tr>
                    <th>Repairs</th>
                  </tr>
                  </thead>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.RR.length && props.line_items.summary['RR-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>R&amp;R</th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Hrs</span>
                    </th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Rate</span>
                    </th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.RR">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{ line.hrs_str }}</span>
                    </td>
                    <td class="text-right">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{ line.rate_str }}</span>
                    </td>

                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="rr-subtotal-hrs">
                    <td class="font-bold text-align-right">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Subtotal Hrs</span>
                    </td>
                    <td class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>{{ props.line_items.summary['RR-Hrs-SubTotal-Str'] }}</span>
                    </td>
                    <td></td>

                    <td></td>
                  </tr>
                  <tr class="rr-subtotal-amount">
                    <td></td>

                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['RR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.RR.length && props.line_items.summary['RR-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>R&amp;R</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.RR">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="rr-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['RR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Repair.length && props.line_items.summary['Repair-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Repair</th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Hrs</span>
                    </th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Rate</span>
                    </th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Repair">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{ line.hrs_str }}</span>
                    </td>
                    <td class="text-right">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{ line.rate_str }}</span>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="rr-subtotal-hrs">
                    <td class="font-bold text-align-right">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Subtotal Hrs</span>
                    </td>
                    <td class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>{{ props.line_items.summary['Repair-Hrs-SubTotal-Str'] }}</span>
                    </td>
                    <td></td>

                    <td></td>
                  </tr>
                  <tr class="rr-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Repair-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Repair.length && props.line_items.summary['Repair-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Repair</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Repair">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="rr-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Repair-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Paint.length && props.line_items.summary['Paint-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Paint</th>
                    <th class="text-center">Paint Material</th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Hrs</span>
                    </th>
                    <th class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Rate</span>
                    </th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Paint">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.paint_type_str }}</td>
                    <td class="text-center">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{ line.hrs_str }}</span>
                    </td>
                    <td class="text-right">
                      <span
                          v-if="isEstimateMethodologyDollars || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{ line.rate_str }}</span>
                    </td>

                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-hrs">
                    <td colspan="2" class="text-right color-dark-grey">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Subtotal Hrs</span>
                    </td>
                    <td class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>{{ props.line_items.summary['Paint-Hrs-SubTotal-Str'] }}</span>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td colspan="2" class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right">{{ props.line_items.summary['Paint-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Paint.length && props.line_items.summary['Paint-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Paint</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Paint">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Paint-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table
                    v-if="!isBlockByAuda && (!!props.line_items.lines.Paint.length || !!props.line_items.lines.Repair.length || !!props.line_items.lines.RR.length)"
                    class="repairs-total main-table main-total-table"
                >
                  <tbody>
                  <tr v-if="props.line_items.summary['Labour-Hrs-Str'] != '' && !isEstimateMethodologyDollars">
                    <td class="font-bold text-align-right">Total Labour Hours</td>
                    <td class="text-align-right">{{ props.line_items.summary['Labour-Hrs-Str'] }}</td>
                  </tr>
                  <tr>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-align-right">{{ props.line_items.summary['Labour-Cost-Str'] }}</td>
                  </tr>
                  </tbody>
                </table>

                <table class="main-table estimate-parts border-t" v-if="!!props.line_items.lines.Part.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Parts</th>
                    <th colspan="2">Part No</th>
                    <th class="text-center">Qty</th>
                    <th class="text-center">Unit Price</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Part">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td colspan="2" class="font-bold" style="word-break: break-all;">{{ line.part_num }}</td>
                    <td class="font-bold text-center">{{ line.qty }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="parts-subtotal-hrs">
                    <td></td>

                    <td></td>
                    <td></td>
                    <td colspan="2" class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Part-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-parts border-t" v-if="!!props.line_items.lines.Materials.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Materials</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Materials">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span v-if="isShowHrsMaterialsPreview(line)">{{ line.hrs_str }}</span>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="parts-subtotal-hrs">
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Materials-Total-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-other border-t"
                       v-if="!!props.line_items.lines.Sublet.length && props.line_items.summary['Sublet-Hrs-SubTotal-Str'] != ''">
                  <thead class="th-fz12">
                  <tr>
                    <th>Sublet</th>
                    <th class="text-center">Repairer</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Rate</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Sublet">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.repairer }}</td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-hrs">
                    <td class="text-right color-dark-grey" colspan="2">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>Subtotal Hrs</span>
                    </td>
                    <td class="text-center">
                      <span v-if="isEstimateMethodologyDollars"></span>
                      <span v-else>{{ props.line_items.summary['Sublet-Hrs-SubTotal-Str'] }}</span>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Sublet-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-other border-t"
                       v-if="!!props.line_items.lines.Sublet.length && props.line_items.summary['Sublet-Hrs-SubTotal-Str'] == ''">
                  <thead class="th-fz12">
                  <tr>
                    <th>Sublet</th>
                    <th class="text-center">Repairer</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Sublet">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.repairer }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-amount">
                    <td class="text-right font-bold" colspan="2">Subtotal Amount</td>
                    <td class="text-center">{{ props.line_items.summary['Sublet-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-sublet m0 border-t" v-if="!!props.line_items.lines.Other.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Other</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Other">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Other-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <!--PDR-->
                <table class="main-table estimate-pdr m0 border-t"
                       v-if="props.line_items.lines.PDR && props.line_items.lines.PDR.length>0">
                  <thead class="th-fz12">
                  <tr>
                    <th>PDR</th>
                    <th class="text-center">Material</th>
                    <th class="text-center">Action</th>
                    <th class="text-center">Qty</th>
                    <th class="text-center">Price</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(line, index) in props.line_items.lines.PDR" :key="index">
                    <td>
                      <div style="white-space: pre-line; align-text-top;">{{ line.name }}</div>
                      <div v-if="line.comment">Comment : {{ line.comment }}</div>
                    </td>
                    <td class="text-center align-text-top">
                      <template v-if="line.type === 'Panel'">{{ line.material }}</template>
                    </td>
                    <td class="text-center  align-text-top">
                      <template v-if="line.type === 'Panel'">{{ line.action|valuePDRMaterial }}</template>
                    </td>
                    <td class="text-center  align-text-top">{{ line.qty }}</td>
                    <td class="text-right  align-text-top">{{ line.price_str }}</td>
                    <td class="text-right  align-text-top">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="!isBlockByAuda">
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['PDR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table  m0">
                  <thead>
                  </thead>
                  <tbody></tbody>
                </table>
                <table class="parts-total main-table main-total-table">
                  <tbody>
                  <tr v-if="!isBlockByAuda && props.line_items.countSubtotal && props.line_items.countSubtotal > 1">
                    <td class="color-dark-grey right">Total</td>
                    <td class="right">{{ props.line_items.summary.Total_str }}</td>
                  </tr>
                  <tr>
                    <td class="font-bold text-right border-bottom">GST</td>
                    <td class="text-right border-bottom">{{ props.line_items.summary.GST_str }}</td>
                  </tr>
                  <tr>
                    <td class="color-dark-grey right"><strong>Total Inc GST</strong></td>
                    <td class="color-dark-grey right"><strong>{{ props.line_items.summary.GrandTotal_str }}</strong>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </main>
              <footer style="display: flex; flex-direction: row; gap: 10px">
                <table class="footer-table" v-if="props.terms !== '' || !props?.note_terms">
                  <thead>
                  <tr>
                    <th>Terms</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td v-html="props.terms"></td>
                  </tr>
                  </tbody>
                </table>
                <table class="footer-table" v-if="props?.note_terms">
                  <thead>
                  <tr>
                    <th>Estimate Note</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td v-html="props.note_terms"></td>
                  </tr>
                  </tbody>
                </table>
              </footer>
            </div>
          </template>
        </modal-wizard-tab>
      </modal-wizard>
    </div>
    <modal-wizard class="delete-supp-modal" ref="warningAuthorisationModal" finishButtonText="Continue"
                  @on-complete="showWarningModalForAuthoriseEstimate()">
      <modal-wizard-tab title="Authorisation - WARNING">
        <div style="margin-bottom: 15px; margin-top:5px">
          This Estimate has been submit to
          <template v-if="properties.isFromIag">ORM</template>
          <template v-else-if="properties.isFromClaimLinq">ClaimLinq</template>
          <template v-else-if="properties.isFromEio">Estimage Online</template>
          <template v-else-if="properties.isFromAudaBridge || properties.isFromAudaNet">AudaNet</template>
          <br>Are you sure you want to manually authorise?
        </div>
      </modal-wizard-tab>
    </modal-wizard>
    <modal-wizard ref="copyEstimateModal" cancelButtonText="Cancel" finishButtonText="Create"
                  @on-complete="completeCopyEstimate" class="copy-card-modal">
      <modal-wizard-tab title="Copy Estimate" description="" title-icon-class="ti-align-right">
        <div class="copy-card-modal-text">Do you want to Copy this Estimate {{ estimate_number }} and all of its
          details?
        </div>
        <div class="copy-card-modal-block">
          <div class="copy-card-modal-block-top">
            <div class="col-md-6">
              <span class="">Select an existing Estimate Nbr to copy {{ estimate_number }} into</span>
            </div>
            <div class="col-md-6">
              <multiselect
                  v-model="copyEstimate.copyToCard"
                  :options="computedEstimateForcopyEstimate"
                  :showLabels="false"
                  :option-height="29"
                  :max-height="203"
                  :close-on-select="true"
                  placeholder="Select Estimate Number"
                  track-by="cardId"
                  class="copy-estimate-multiselect"
                  label="label"
                  :searchable="true"
              />
            </div>
          </div>
          <span class="copy-card-modal-text-middle">Optional</span>
          <div class="copy-card-modal-block-top">
            <div class="col-md-6 copy-card-modal-block copy-card-text-align">
              <span class="">Copy Images</span>
              <span class="">Copy Docs</span>
            </div>
            <div class="col-md-4 copy-card-modal-block">
              <label class="pin-job modal-checkbox-position">
                <input type="checkbox" v-model="copyEstimate.isCopyImages"/>
                <span class="pin_content pin-checkmark modal-pin"><i
                    class='bx bx-check'></i></span>
              </label>
              <label class="pin-job modal-checkbox-position">
                <input type="checkbox" v-model="copyEstimate.isCopyFiles"/>
                <span class="pin_content pin-checkmark modal-pin"><i
                    class='bx bx-check'></i></span>
              </label>
            </div>
          </div>
        </div>
      </modal-wizard-tab>
    </modal-wizard>
    <transition name="slide-fade">
      <div v-if="pinImage" class="image-pin-area rs-scroll rs-scroll--transparent">
        <div>
          <div class="vissible-sm">
            <label class="pin-image">Pin Images
              <input type="checkbox" name="pinimage" v-model="pinImage">
              <span class="pin-checkmark"></span>
            </label>
          </div>
          <vue-dropzone
              v-on:vdropzone-file-added="addImgUpload"
              v-on:vdropzone-complete="completeImgUpload"
              v-on:vdropzone-sending="sendImgUpload"
              v-on:vdropzone-success="successImgUpload"
              ref="imgUpDrop"
              id="imgUploadDrop2"
              class="dropify-wrapper dropzoneContainer"
              style="height: auto;"
              :options="itemsListImageUploadDropzoneOptions"
              :useCustomSlot="true">
            <div class="dropify-message" style="transform: translateY(0%);">
              <img src="../../assets/img/layouts/bx-cloud-upload.svg"/>
              <p>Drag or Drop File</p>
            </div>
          </vue-dropzone>
        </div>
        <image-lightbox
            :isPreviewImage="'true'"
            :fromComponent="'estimate'"
            :position="'pin_images'"
            :isShowBigImage="isShowBigImage"
            @updateCategoryFunc="updateImageCategory"
            :imageList="imageSource"
            @removeImage="deleteImage"
            @selectImageGallery="selectImageGallery"
            :isAlreadyShowGallery="isShowGallery"
            :path="''"
            :showContextMenu="true"
            class="pin-image-lightbox"
        ></image-lightbox>
      </div>
    </transition>
    <!--        <div v-if="drag.debug" style="padding: 10px; border: 1px solid #E9E9E9; border-radius: 4px; margin: 10px; background-color: #F9F9F9; position: fixed; bottom: 5px; right: 5px;">-->
    <!--            <div><strong>Drag Debug</strong></div>-->
    <!--            <div>sourceItem: {{ drag.sourceItem.prt }} id: {{ drag.sourceItem.id }}</div>-->
    <!--            <div>targetItem: {{ drag.targetItem.name }} id: {{ drag.targetItem.id }}</div>-->
    <!--            <div>sourceIndex: {{ drag.sourceIndex }}</div>-->
    <!--            <div>targetIndex: {{ drag.targetIndex }}</div>-->
    <!--            <div>isDragOverEmptyItem: {{ isDragOverEmptyItem }}</div>-->
    <!--        </div>-->
    <modal-note
        ref="noteModal"
        modal-id="noteBoxModalEst"
        :note-id="note_id"
        :note="note"
        :type="note_type"
        @save="saveNote"
    ></modal-note>

    <div class="car-scheme-window" :class="{'active': activeCarScheme && !isShowGallery}">
      <car-scheme
          @close="activeCarScheme = false"
          :body="card.vehicle.body"
          @selectedPart="selectedSchemePart"
          :estimateMethodology="estimateRates.estimate_methodology"
      ></car-scheme>
    </div>
  </div>
</template>

<style>
.copy-estimate-multiselect .multiselect__option {
  word-wrap: break-word;
  white-space: normal;
}

.copy-estimate-multiselect .multiselect__content-wrapper {
  max-width: 203px !important;
}

.estimates-edit .on-site-booking-picker input {
  opacity: 1 !important;
}

/* Scheduling tab helpers */
/* .estimage-line {
  width: 100%;
  height: 10px;
  right: 0;
  display: block;
  position: absolute;
  background: #e3e4e7;
} */

.categories-menu-color-icon {
  display: inline-block;
  height: 15px;
  width: 15px;
  border-radius: 3px;
  margin-right: 10px !important;
}

.V3 .estimates-edit-page span.vue__time-picker.cards-edit-timepicker input.display-time {
  padding-left: 10px;
}

.V3 .estimates-edit-page span.vue__time-picker.cards-edit-timepicker .controls {
  right: 15px;
}

.V3 .estimates-edit .multiselect--disabled {
  opacity: 1 !important;
}

.V3 .estimates-edit .multiselect--disabled .multiselect__select {
  display: none !important;
}

.options-menu-height-2 {
  width: 178px !important;
}

.options-menu-height-2 .dropdown-item {
  min-height: 26px !important;
  padding: 6px 14px 6px 14px !important;
}

.options-menu-height-2 .dropdown-menu-child {
  right: 176px !important;
}

.selected-scanner-item {
  background-color: rgba(94, 121, 255, 0.1);
  color: #5E79FF;
  font-weight: bold;
}

.scanner-item {
  padding: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, .15);
  border-radius: 3px;
  font-weight: bold;
  cursor: pointer;
}

.scanner-item:hover {
  background-color: rgba(94, 121, 255, 0.1);
  color: #5E79FF;
  font-weight: bold;
}

.scanner-items {
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, .15);
  border-bottom: none;
  width: calc(100% - 30px);
  margin-left: 15px;
}

.current-scanner {
  font-weight: bold;
  padding: 10px;
}

.hide-estimate-block {
  opacity: 0 !important;
}

.V3 .estimates-edit .owner-type-checkboxes label.radio > input[type="radio"]:checked:disabled + span.icon i {
  color: white;
}

.V3 .estimates-edit .owner-type-checkboxes label.radio > input[type="radio"]:checked:disabled + span.icon {
  background-color: #5E79FF;
}

.V3 .estimates-edit label.radio > input[type="radio"]:disabled + span.icon:hover {
  cursor: not-allowed;
}

.show-help-for-body {
  font-size: 95% !important;
  color: red;
  margin-top: .75rem !important;
}

.progress-top {
  margin-top: 40px !important;
}

.progress-bottom {
  margin-bottom: 57px !important;
}

.delete-supp-modal .modal-dialog {
  width: 370px;
}

.modal-cancel-authority .modal-dialog {
  width: 370px;
}

/*.multiselect__select {*/
/*    display: inline-block;*/
/*    font: normal normal normal 14px/1 FontAwesome;*/
/*    font-size: inherit;*/
/*    text-rendering: auto;*/
/*    -webkit-font-smoothing: antialiased;*/
/*}*/

/*.multiselect__select:before {*/
/*    content: "\f107";*/
/*    border: none;*/
/*}*/

.show-help-for-paint-material {
  font-size: 95% !important;
  color: red;
  margin-top: .75rem !important;
}

.nav-link span.tag {
  top: auto !important;
}

.send-to-report td {
  width: 11%;
}

#estimate-item-list .tab-special tbody tr:hover .form-control {
  background: #F9F9F9 !important;
}

#estimate-item-list .tab-special tbody tr:hover select.form-control {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAArElEQVRIS+2T0Q3CMAxEXzdgk3YEmIgRSjfoRjACbMII6CSQQhrHzkclkOKvNrresy/uwM417OxPB7gJ94h+P6ILsAJPo9UDcAYWa5TaJct8Bu7AqQCR+RWY3gDpN1UDyOAGjAVIav4AjtaU3pqWIOry03nVXEIPIE0O0Zlicc2jgByi95B5CyCF6NnMPL/lSETpN4pLZa1t0xa5f2lE0DpBxPNL0wFuZP8f0Qs+eB0Z+AOfuQAAAABJRU5ErkJggg==") right center no-repeat !important;
}

#estimate-item-list .tab-special tbody tr .form-control:focus {
  background: #FFFFFF !important;
}

#estimate-item-list .tab-special tbody tr:hover select.form-control option {
  background: #FFFFFF !important;
}

#estimate-item-list .tab-special tbody tr:hover select.form-control option:hover {
  background: #F3F3F3 !important;
  color: #35495E !important;
  font-weight: 700;
}

#estimate-item-list .tab-special tbody tr select.form-control:focus {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAArElEQVRIS+2T0Q3CMAxEXzdgk3YEmIgRSjfoRjACbMII6CSQQhrHzkclkOKvNrresy/uwM417OxPB7gJ94h+P6ILsAJPo9UDcAYWa5TaJct8Bu7AqQCR+RWY3gDpN1UDyOAGjAVIav4AjtaU3pqWIOry03nVXEIPIE0O0Zlicc2jgByi95B5CyCF6NnMPL/lSETpN4pLZa1t0xa5f2lE0DpBxPNL0wFuZP8f0Qs+eB0Z+AOfuQAAAABJRU5ErkJggg==") right center no-repeat !important;
}

#estimate-item-list .tab-special select.form-control:focus {
  border: 1px solid #5E6571;
}

.wizard-nav.wizard-nav-pills li .wizard-icon-circle {
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
  cursor: pointer;
}

.wizard-nav.wizard-nav-pills li .stepTitle {
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
  cursor: pointer;
}

.wizard-nav.wizard-nav-pills li.active .stepTitle {
  color: #4F5D71 !important;
}

.wizard-nav.wizard-nav-pills li:hover .wizard-icon-circle {
  border-color: #4F5D71 !important;
}

.wizard-nav.wizard-nav-pills li:hover .stepTitle {
  color: #4F5D71 !important;
}

.wizard-nav.wizard-nav-pills li.active:hover .stepTitle {
  color: #4F5D71 !important;
}

.wizard-nav.wizard-nav-pills .wizard-icon-container {
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

.image-pin-area {
  position: fixed;
  width: 220px;
  height: calc(100% - 60px);
  overflow-y: auto;
  display: block;
  background: linear-gradient(180deg, #1C1F3A 0%, #161931 53.69%, #282C48 100%);
  left: 0;
  z-index: 999999;
  top: 60px;
  padding: 15px;
}

.image-pin-area .dropzone {
  padding: 7px;
}

.image-pin-area .dropzone .dz-preview {
  margin: 6px;
}

.image-pin-area .dropify-wrapper {
  height: auto;
}

.image-pin-area .col-sm-3 {
  width: 100%;
  padding: 0;
}

.image-pin-area .col-sm-3 .box.box-block.bg-grey {
  padding: 0;
}

.image-pin-area .col-sm-3 .box.box-block.bg-grey .wrap.img-fluid {
  width: 100%;
  height: auto;
}

.pin-image {
  display: flex;
  align-items: center;
  position: relative;
  color: #34495E;
  height: 27px;
  font-weight: 600;
  font-size: 13px;
  padding-top: 8px;
  padding-left: 35px;
  margin-bottom: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

@media screen and (max-width: 991px) {
  .pin-image {
    margin-bottom: 15px;
  }
}

/* Hide the browser's default checkbox */
.pin-image input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.V3 .estimates-edit-page .pin-checkmark {
  position: absolute;
  top: 5px;
  left: 0;
  height: 25px;
  width: 25px;
  border: 1px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background-color: #F8F4F4;
  border: 1px solid #DFDFDF;
}

/* On mouse-over, add a grey background color */
.V3 .estimates-edit-page .pin-image:hover input ~ .pin-checkmark {
  background-color: #CCCCCC;
  border-color: #CCCCCC;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

/* When the checkbox is checked, add a blue background */
.V3 .estimates-edit-page .pin-image input:checked ~ .pin-checkmark {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

/* Style the checkmark/indicator */
.V3 .estimates-edit-page .pin-image .pin-checkmark:after {
  /*top: 4px;*/
  /*left: 4px;*/
  /*width: 5px;*/
  /*height: 5px;*/
  /*border-radius: 50%;*/
  /*background: white;*/
}

.vissible-sm {
  display: none;
}

@media screen and (max-width: 991px) {
  .vissible-sm {
    display: block;
  }
}

#paintMaterialNotificationModal div.modal-content {
  width: 70%;
  margin-left: 15%;
}

/* Style to be used with invoice-view and invoice-excess */

/* HEADER TABLE */
.invoice-info {
  padding-right: 5px;

  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;

  margin-bottom: 10px;
}

.invoice-title {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 24px;
  margin: 0 0 20px;
}

.invoice .header-table {
  margin: 0 0 20px
}

.invoice .header-table td {
  color: #1C1F39;
}

/* CONTENT TABLE */
.invoice .main-table thead th,
.invoice .main-table tbody th {
  padding: 8px 15px;
  background: rgba(27, 30, 56, 0.12);
}

.invoice .main-table td, .invoice .main-table th {
  text-align: left;
  border-bottom: 1px solid white;

}

.invoice .main-table thead th {
  padding: 8px 15px;
  font-size: 13px;
  font-weight: 700;
}

.invoice .main-table tbody th, .invoice .main-table tfoot th {
  padding: 8px 15px;
  color: #3F3F3F;
  font-size: 12px;
  font-weight: 700;
}

.invoice .main-table thead th {
  border-radius: 3px;
}

.invoice .main-table tbody th:first-child {
  border-radius: 3px 0 0 3px;
}

.invoice .main-table tbody th:last-child {
  border-radius: 0 3px 3px 0;
}

/* Owner details */
.invoice .main-table .vehicle-details td,
.invoice .main-table .main-inner td {
  border: none;
  color: #1C1F39;
}

.invoice .main-table .main-inner td:first-child {
  min-width: 110px;
  width: 40%;
  font-weight: 700;
}

.invoice .main-table tbody td,
.invoice .main-table tfoot td {
  padding: 5px 15px;
  color: #1C1F39;
  font-size: 12px;
  /* font-weight: 400; */
}

.invoice .main-table tbody tr:first-child td,
.invoice .main-table tfoot td:first-child td {
  /* padding-top: 5px; */
}

.invoice .repairs-total tbody td {
  padding: 5px 15px;
  border: none;
}

.invoice .main-total-table {
  margin-bottom: 20px;
  width: auto !important;
  float: right;
}

.invoice .main-total-table tr:last-child td {
  border-bottom: 0
}

.latest_amount_table td.border-bottom,
.invoice td.border-bottom {
  position: relative;
  border-bottom: 1px solid rgba(27, 30, 56, 0.25);
}

.latest_amount_table td:last-child.border-bottom::after,
.invoice td:last-child.border-bottom::after {
  content: "+";
  position: absolute;
  font-size: 22px;
  bottom: -17px;
  right: -5px;
}

.latest_amount_table td:last-child.border-bottom::after {
  bottom: -8px;
}

.invoice-view .main-table tfoot td.subtotal-right {
  text-align: right;
  padding-right: 25px;
  font-weight: 700;
}

.hasSubContext {
  position: relative;
  padding-right: 5px !important;
}

.icon-right {
  transform: translate(100%, -3px) !important;
  font-size: 21px !important;
}

@media screen and (max-width: 400px) {
  .estimate-preview-visual .tab-content {
    padding: 10px 0 !important;
  }
}

.estimates-edit .tab-content-without-padding {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

@media screen and (min-width: 1598px) {
  .sticky {
    background-color: white;
    z-index: 111;
    top: 204px;
    position: sticky;
    position: -webkit-sticky;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1598px) {
  .sticky {
    background-color: white;
    z-index: 111;
    top: 242px;
    position: sticky;
    position: -webkit-sticky;
  }
}

.ghost-items {
  display: flex;
  width: 100%;
  background-color: #F9F9F9 !important;
  border: 2px solid rgba(94, 121, 255, 0.5) !important;
  box-shadow: 0 0 0 0.3rem rgba(94, 121, 255, 0.25);
  border-radius: 3px;
  box-sizing: border-box;
}

.ghost-items a {
  color: #5E6571;
  font-family: "Nunito Sans", sans-serif;
  font-size: 12px;
  font-stretch: 100%;
  background: white;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
  width: calc(100% - 1.5rem);
  line-height: 32px;
  padding: 0 2px;
  display: block;
  margin: .75rem;
}

.ghost-items a:hover {
  color: #5E6571;
}

.ghost-items a > div {
  display: none !important;
}

.ghost-items::after {
  content: "";
}

.ghost-items-2 {
  /*display: flex;*/
  width: 96%;
  background-color: #F9F9F9 !important;
  border: 2px solid rgba(94, 121, 255, 0.5) !important;
  box-shadow: 0 0 0 0.3rem rgba(94, 121, 255, 0.25);
  border-radius: 3px;
  box-sizing: border-box;
  margin-left: 4px;
}

.V3 .estimates-edit-page .page-header .page-header-nav-pin-images {
  bottom: 22px;
}

.additional-data-picker-block .vc-popover-content-wrapper {
  position: fixed !important;
  z-index: 99999;
}

@media screen and (max-width: 767px) {
  .additional-data-picker-block .vc-popover-content-wrapper {
    position: inherit !important;
    z-index: 99999;
    transform: translate3d(-50px, 10px, 0px) !important;
  }
}

.rs-scroll-new-y::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.V3 .estimates-edit-page .medium-rectangle-b-promo img {
  width: 300px !important;
  height: 250px !important;
}
</style>

<style scoped>
.additional-estimate-images-block {
  margin-bottom: 30px;
}

.copy-card-modal >>> .modal-dialog {
  max-width: 600px;
}

.copy-card-modal >>> .modal-body {
  height: 230px;
}

.copy-card-modal >>> .copy-card-modal-block {
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
}

.pin-job:hover input ~ .pin-checkmark {
  border-color: #5E79FF;
  outline: 1px solid #5E79FF !important;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

.copy-card-modal >>> .copy-card-modal-block .modal-checkbox-position {
  margin-bottom: 36px !important;
}

.pin-job input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.pin-checkmark {
  position: absolute;
  top: 5px;
  left: 0;
  height: 25px;
  width: 25px;
  border: 1px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background-color: white;
}

.pin-job input:checked ~ .pin-checkmark i {
  display: block;
}

.pin-job input:checked ~ .pin-checkmark {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

.bx-qr:hover {
  color: #5e79ff;
  cursor: pointer;
}

.card-files >>> .file-type {
  min-width: 195px;
}

.type-multiselect >>> .multiselect__tags {
  min-width: 150px;
}

.pagination-block-bottom .table-responsive {
  padding-bottom: 145px !important;
}

.V3.compact-sidebar .car-scheme-window.active {
  position: fixed;
  left: 75px;
  top: 5px;
  z-index: 10001;
  transition: all 1s;
}

.V3 .car-scheme-window.active {
  position: fixed;
  left: 225px;
  top: 5px;
  z-index: 10001;
  transition: all 1s;
}

.car-scheme-window {
  position: fixed;
  left: -800px;
  top: 5px;
  z-index: 10001;
  transition: all 1s;
}

.page-header-nav-car-icon {
  width: 40px;
  height: 40px;
  border: 2px solid rgba(128, 128, 128, 0.5);
  line-height: 36px;
  padding: 0 3px;
  cursor: pointer;
  border-radius: 3px;
}

.page-header-nav-car-icon:hover {
  border-color: #5E79FF;
}

.disabled-field:hover {
  cursor: not-allowed !important;
}

.nav-chevron-block div {
  display: none !important;
}

.nav-chevron-block div.active {
  display: block !important;
}

.nav-chevron-block {
  position: sticky;
  top: 142px;
  z-index: 1001;
}

.nav-chevron-block .bx {
  font-size: 25px;
}

.nav-chevron-block div {
  padding: 10px 5px;
  display: inline;
  background-color: white;
}

.nav-chevron-block div:first-child {
  position: absolute;
  padding-right: 10px;
  top: 0px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 35%, rgba(0, 212, 255, 0) 100%);
}

.nav-chevron-block div:last-child {
  padding-left: 10px;
  position: absolute;
  top: 0px;
  right: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 65%, rgba(255, 255, 255, 1) 100%);
}

.bxs-phone-call {
  position: absolute;
  top: 5px;
  right: 25px;
  font-size: 22px;
  color: #1d4898;
  cursor: pointer;
}

.tabs-nav-right-search .search-filter >>> .custom-dropdown {
  top: 37px;
  left: -85px;
  padding-top: 2px;
}

.search-filter >>> input::placeholder {
  color: #a6a6a6;
  font-weight: 700;
}

.tabs-nav-right-search .search-filter >>> .form-control:focus {
  outline: 0 !important;
}

.tabs-nav-right-search .search-filter >>> .search-filter__input {
  font-size: 13px !important;
  font-weight: 800;
  color: black;
}

.tabs-nav-right-search .search-filter >>> .search-filter__box {
  border: 3px solid #5e77fd;
  border-radius: 7px;
}

.search-filter >>> .search-filter__box__focused {
  border: 3px solid rgba(94, 121, 255, 0.5) !important;
  box-shadow: 0 0 0 0.2rem rgb(94 121 255 / 25%) !important;
  background-color: white !important;
}

.tab-padding-top-0px {
  padding-top: 0px !important;
}

.estimate-summary-table-head {
  background-color: #e1e2e5;
  border-radius: 3px;
  height: 30px;
  margin-bottom: 0px !important;
}

.estimate-summary-table-head-item {
  line-height: 30px;
  font-weight: 700;
}

.estimate-summary-table-body-elem {
  padding-top: 3px;
  padding-bottom: 3px;
  border-bottom: 1px solid rgba(27, 30, 56, .25);
}

.estimate-summary-table-body-elem {
  margin-bottom: 0px !important;
}

.estimate-summary-table-body-elem-item {
  font-size: 12px;
}

.estimate-summary-table-body-elem-item-title {
  font-weight: 700;
}

.estimate-summary-table-body-elem-bold {
  font-weight: 900;
}

.estimate-summary-table-body-elem-item-border-bottom {
  border-bottom: 1px solid rgba(27, 30, 56, .25);
  padding-top: 3px;
  padding-bottom: 3px;
}

.input-margin-bottom-3px {
  margin-bottom: 3px;
}

.production-time-input >>> .input-field {
  margin-bottom: 3px;
}

.production-time-input span {
  margin-top: 3px;
}

.rental-margin-input {
  margin-bottom: 3px;
}

.right-col {
  margin-top: 5px;
  margin-right: 8px;
}

@media (max-width: 1500px) {
  .right-col {
    margin-top: 15px;
  }
}

@media (orientation: landscape) {
  .claim-number-vertical-display {
    display: inline;
  }
}

@media (orientation: portrait) {
  .claim-number-vertical-display {
    display: none;
  }
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 30px;
}

.tabs-absolute-right-notes-btn {
  margin-right: 160px;
}

.tab-content {
  padding: 10px 0;
}

.color-dark-grey {
  color: #3F3F3F !important
}

.fz16 {
  font-size: 16px !important
}

.w50 {
  width: 50%
}

.vat {
  vertical-align: top
}

.m0 {
  margin: 0 !important
}

.border-b {
  border-bottom: 1px solid silver !important
}

.border-t {
  border-top: 1px solid silver !important
}

.bg-white {
  background: #FFFFFF !important
}

.th-fz12 th {
  font-size: 12px !important
}

.invoice {
  width: 820px;
  margin: 25px auto
}

.invoice-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.invoice .main-table {
  margin: 0 0 20px;
  width: 100%;
  border-collapse: collapse
}

.invoice .main-table tr.empty-row td, .invoice .main-table tr.empty-row th {
  height: 20px
}

.invoice .main-table .vehicle-details {
  width: 100%
}

.invoice .parts-required {
  margin-bottom: 0
}

.invoice .parts-required td:nth-child(1), .invoice .parts-required th:nth-child(1) {
  width: 355px
}

.invoice .parts-required td:last-child, .invoice .parts-required th:last-child {
  width: 70px
}

.invoice .estimate-repairs td:first-child, .invoice .estimate-repairs th:first-child {
  width: 550px
}

.invoice .estimate-repairs td:nth-child(2), .invoice .estimate-repairs th:nth-child(2) {
  width: 55px
}

.invoice .estimate-repairs td:last-child, .invoice .estimate-repairs th:last-child {
  width: 70px
}

.invoice .estimate-other td:first-child, .invoice .estimate-other th:first-child {
  width: 550px
}

.invoice .estimate-other td:nth-child(2), .invoice .estimate-other th:nth-child(2) {
  width: 55px
}

.invoice .estimate-other td:last-child, .invoice .estimate-other th:last-child {
  width: 70px
}

.invoice .estimate-sublet td:first-child,
.invoice .estimate-sublet th:first-child,
.invoice .estimate-pdr th:first-child {
  width: 605px
}

.invoice .estimate-sublet td:last-child,
.invoice .estimate-sublet th:last-child {
  width: 70px
}

.invoice .estimate-parts td:first-child, .invoice .estimate-parts th:first-child {
  width: 400px
}

.invoice .estimate-parts td:nth-child(2), .invoice .estimate-parts th:nth-child(2) {
  width: 150px
}

.invoice .estimate-parts td:nth-child(3), .invoice .estimate-parts th:nth-child(3) {
  width: 55px
}

.invoice .estimate-parts td:last-child, .invoice .estimate-parts th:last-child {
  width: 70px
}

.invoice .estimate-pdr th:first-child {
  width: 605px
}

.invoice .estimate-pdr th:nth-child(2),
.invoice .estimate-pdr th:nth-child(3) {
  width: 9rem;
}

.invoice .estimate-pdr th:nth-child(5),
.invoice .estimate-pdr th:last-child {
  width: 86px;
}

.invoice .parts-total td:last-child {
  width: 70px;
  padding-left: 15px
}

.invoice .tax-subtotal-hrs td:first-child {
  width: 560px
}

footer {
  clear: both
}

.footer-table {
  width: 100%;
  /* border-top: 1px solid silver;
  border-bottom: 1px solid silver */
  border: 1px solid silver;
  border-radius: 10px;
  border-collapse: separate;
  overflow: hidden;
}

.footer-table td, .footer-table th {
  text-align: left
}

.footer-table th {
  padding: 16px 8px 10px;
  font-size: 12px
}

.footer-table td {
  padding: 0 8px 16px;
  font-size: 11px;
  color: #595959
}

#parts-details {
  margin-top: -11px;
}

#parts-details .btn-outline-primary:hover {
  background-color: #E0EAF6;
  color: #0275D8;
}

#parts-details .btn-outline-primary.active:hover {
  background-color: #3E70C9;
}

.timeline {
  padding-left: 15px;
}

.V3 .estimates-edit .dropzoneContainer {
  margin: 5px 15px;
  width: auto;
  border: 1px dashed rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background: white !important;
  min-width: 125px;
}

.V3 .estimates-edit .dropify-wrapper .dropify-message span.file-icon:before {
  content: '\E800';
  font-weight: 800;
  font-size: 37px;
  color: #5E79FF;
}

.V3 .estimates-edit .dropify-wrapper .dropify-message .drop-down-text {
  font-family: "Nunito Sans";
  color: #1C1F39;
  font-size: 13px;
  font-weight: bold;
}

.btnNotBorder {
  border-color: #FAFAFA !important;
}

.btnNotBorder:hover {
  background-color: #FAFAFA !important;
  color: #142742 !important;
}

.btnNotBorder .fa-sort-down {
  left: unset !important;
  margin: 0 !important;
  top: 5px !important;
  font-size: 14px !important;
  width: 20px !important;
  height: auto !important;
}

.dropdownLinks-container {
  flex-direction: column;
  position: absolute;
  border: none;
  background-color: #FAFAFA;
  right: 20px;
  top: 28px;
  height: auto;
  padding: 0;
  margin: 0;
}

.dropdownLinks-links {
  position: relative;
  background: white;
  border: 1px solid #B8B8B8;
}

.dropdownLinks-links:after,
.dropdownLinks-links:before {
  bottom: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.dropdownLinks-links:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #FFFFFF;
  border-width: 5px;
  right: 12px;
  background-clip: padding-box;
}

.dropdownLinks-links:before {
  border-color: rgba(184, 184, 184, 0);
  border-bottom-color: #B8B8B8;
  border-width: 6px;
  right: 11px;
  background-clip: padding-box;
}

.activtyPopupIcon {
  position: unset !important;
  margin: 0 !important;
  font-size: 10px !important;
}

.box-block-grey {
  background: #F1F1F1;
}

.select-parts-check-all {
  font-weight: 500;
  margin-top: 8px;
}

.select-parts-check-all input {
  transform: translateX(calc(50% + 2px));
}

.select-parts-check-all label {
  transform: translateX(8px);
}

#SelectImages4 {
  background: #F1F1F1;
  margin-top: -15px;
  margin-bottom: 30px;
}

.vertical-top {
  vertical-align: top;
}

.vertical-middle {
  vertical-align: middle;
}

.autosave {
  color: #eb7c31;
  font-size: 15px;
  margin-left: 50px;
  font-weight: 900;
  text-transform: uppercase;
}

.autosave.autosave-saved {
  color: #5d78fd
}

.autosave.autosave-not-mobile {
  float: right;
  font-size: 16px;
  margin-right: 400px;
  margin-top: 12px;
}

.vue-form-wizard.xs {
  padding-bottom: 0px !important;
  overflow: auto;
}

.wizard-nav {
  overflow: hidden;
}

.vue-form-wizard .wizard-nav-pills a, .vue-form-wizard .wizard-nav-pills li {
  max-width: 89px;
}

.vue-form-wizard .wizard-nav-pills {
  flex-wrap: nowrap;
}

.vue-form-wizard.xs .wizard-icon-circle {
  width: 30px !important;
  height: 30px !important;
}

#activity .wizard-progress-with-circle {
  background-color: rgba(27, 30, 56, 0.12);
  border-radius: 5px;
  /* to keep border radius */
  overflow: hidden;
}

#activity .vue-form-wizard .wizard-tab-content {
  min-height: 1px;
  padding-bottom: 0;
  border-top: 1px solid transparent;
  margin-top: 0px;
  padding: 5px;
}


.wizard-icon.ti-check {
  font-weight: bold;
}

.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  height: 2px !important;
  top: 19px !important;
}

.vue-form-wizard.xs .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 12px !important;
  color: #5E79FF;
}

.wizard-navigation {
  overflow-x: auto;
}

#activity .wizard-navigation {
  float: left;
  margin-top: 18px;
  margin-left: 0;
}

.vue-form-wizard .wizard-icon-circle .wizard-icon-container {
  border-radius: 50%;
}

#activity .vue-form-wizard .wizard-header {
  padding: 15px 30px;
  padding-bottom: 0px;
}

#activity .wizard-icon-circle ~ .stepTitle {
  font-size: 12px;
  font-weight: 600;
  padding: 5px 38px;
}

.card-block {
  position: relative;
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 10px;
}

@media screen and (max-width: 991px) {
  .tabs-absolute-right {
    position: relative;
    top: 0px;
    right: 0;
    z-index: 99;
    float: left;
  }
}

.styled-tabs {
  width: 302px;
  border: 1px solid #142742;
  border-radius: 3px;
}

.styled-tabs .nav-link {
  width: 150px;
  text-align: center;
  border: none;
  color: #142742;
  font-size: 14px;
  font-weight: bold;
  padding: 0.3em 0;
}

.styled-tabs .nav-item .active {
  background: #142742;
  color: #FFFFFF;
}

.styled-tabs .nav-item .active:focus {
  background: #142742;
  color: #FFFFFF;
}

.slide-fade-enter-active {
  transition: all .2s ease;
}

.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(-10px);
  opacity: 0;
}

table.main-total-table td.right {
  text-align: right;
}

.estimate_amount {
  border: 1px solid rgba(0, 0, 0, .125);
}

.header_estim_amount h4 {
  width: 60%;
  margin-bottom: 0px;
}

.header_estim_amount h4.amountValue {
  width: 40%;
  margin-bottom: 0px;
}

.header_estim_amount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, .125);
}

.body_estim_amount {
  padding: 0 10px;
}

.body_estim_amount > ul > li > span:first-child {
  width: 60%;
}

.body_estim_amount > ul > li > span:last-child {
  width: 40%;
}

.body_estim_amount > ul > li {
  display: flex;
  padding: 5px 0;
  justify-content: space-between;
  align-items: center;
}

.body_estim_amount > ul {
  margin-bottom: 0;
  padding: 0;
}

.filterAssigned:before {
  top: -19px;
  border-color: transparent transparent transparent #BDBDBD;
  border-width: 9px;
  left: 30px;
}

.filterAssigned:after {
  top: -18px;
  border-color: transparent transparent transparent #FFFFFF;
  border-width: 9px;
  left: 30px;
}

.filterAssigned:after, .filterAssigned:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  transform: rotate(-90deg);
}

.saveAsTemplateList li {
  border-bottom: none !important;
}

.addTemplateList li {
  border-bottom: none !important;
}

.audanet-child li {
  border-bottom: none !important;
}

.dropdown-menu-child.audanet {
  padding-top: 0px;
}

.tabs-component ul > li .loaderAssignTo {
  position: absolute;
  max-width: 30px;
  top: 5px;
  right: -36px;
}

.tabs-component ul > li {
  position: relative;
}

.searchInput {
  width: calc(100% - 20px);
}

.filterAssigned > input {
  border: 1px solid rgba(27, 30, 56, .25);
  padding: 2px 7px;
  /*added*/
  margin: 0px 7px;
  width: 90% !important;
  border-radius: 5px;
}

.filterAssigned > ul > li {
  padding: 5px 10px;
  cursor: pointer;
  font-weight: bold !important;

}

.filterAssigned > ul > li:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
  color: #5E79FF !important;
  border-bottom: 1px solid transparent;
  font-weight: bold !important;
}

.li-in-save-as-template:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
  color: #5E79FF !important;
}

.filterAssigned > ul {
  padding: 0;
  height: auto;
  max-height: 300px;
  overflow: auto;
  margin-top: 4px;
}

.filterAssigned {
  position: absolute;
  left: 0;
  z-index: 9999;
  background-color: #FFFFFF;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 5px 0px;
  transition: 0.4s;
  top: 100%;
  transform: translateY(10px);
  opacity: 0;
  visibility: hidden;
  width: auto;
  min-width: 190px;
  max-width: 300px;
}

.context-level {
  width: 100% !important;
  left: calc(100% + 1px) !important;
}

.openFilterAssigned {
  opacity: 1;
  visibility: visible;
  transform: translateY(0px);
}

@media screen and (max-width: 1000px) and (orientation: landscape) {
  .V3 .page-header {
    position: relative;
    width: 100%;
    z-index: 9999;
    top: 0;
  }

  .V3 .tabs-component {
    position: relative;
    top: 0;
  }

  .V3 .fixed-header .site-header {
    position: relative !important;
  }

  .V3 .tabs-component.tabs-component-mobile,
  .V3 .nav-chevron-block {
    display: none;
  }
}

.V3 .tab-pane {
  background: white;
}

.V3 .container-fluid .row .col-md-3 {
  padding: 0px !important;
}

.V3 .container-fluid .row .col-md-9 {
  padding: 0px !important;
}

.V3 .template-tabs.mt-2 .nav-tabs.nav-tabs-2:first {
  margin-bottom: 0px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

.V3 ul.nav.nav-4 {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  margin-right: 10px;
  scrollbar-width: thin;
}

.V3 ul.nav.nav-4 li {
  position: relative;
}

.V3 ul.nav.nav-4 .nav-item.active {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 ul.nav.nav-4 .nav-item.active a:focus {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 ul.nav.nav-4 .nav-item.active .nav-link {
  color: black;
}

.V3 ul.nav.nav-4 .nav-item.active::after {
  content: "";
  position: absolute;
  left: 0px;
  bottom: 0px;
  height: 100%;
  width: 5px;
  border-radius: 0 5px 5px 0;
  background-color: #5E79FF;;
}

.V3 .tab-pane .col-md-5 .col-md-6 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.V3 .new-estimate-item {
  color: #5E79FF !important;
}

.V3 .new-estimate-item i {
  color: #5E79FF !important;
}

.V3 .search-input {
  background: url('data:image/svg+xml;base64,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') no-repeat center right;
  background-position: right 7px center;
  width: 100%;
}

.V3 .search-input:focus {
  width: 100% !important;
}

.site-content-mobile .tabs-component {
  overflow-x: scroll;
  overflow-y: hidden;
  border-bottom: 5px solid #e3e4e7 !important;
  white-space: nowrap;
}

.site-content-mobile .nav-tabs {
  display: flex;
  align-items: flex-start;
}

.V3 .site-content-mobile .tabs-component .tab-header {
  padding-bottom: 0;
}

.V3 .site-content-mobile .tabs-component::after {
  height: 5px;
  padding-right: 0;
  display: block;
  background-color: white;
}

.site-content-mobile .tab-content .col-md-4,
.site-content-mobile .tab-content .col-md-8 {
  width: 100%;
}

.site-content-mobile .estimate-summary-table-body .estimate-summary-table-body-elem {
  display: flex;
}

.site-content-mobile .estimate-summary-table-head .estimate-summary-table-head-item:nth-child(1) {
  width: 50%;
}

.site-content-mobile .estimate-summary-table-head .estimate-summary-table-head-item:nth-child(2) {
  width: 25%;
}

.site-content-mobile .estimate-summary-table-head .estimate-summary-table-head-item:nth-child(3) {
  width: 25%;
}

.site-content-mobile .estimate-summary-table-body .estimate-summary-table-body-elem::after {
  content: none;
}

.site-content-mobile .estimate-summary-table-body .estimate-summary-table-body-elem-item:nth-child(1) {
  width: 50%;
}

.site-content-mobile .estimate-summary-table-body .estimate-summary-table-body-elem-item:nth-child(2) {
  width: 25%;
}

.site-content-mobile .estimate-summary-table-body .estimate-summary-table-body-elem-item:nth-child(3) {
  width: 25%;
}

@media screen and (max-width: 767px) {
  .V3 .active.ml-2 {
    margin-left: 0 !important;
  }

  .nav-tabs li a {
    white-space: nowrap;
  }

  .tab-content {
    padding-top: 0px;
  }

  .estimate-summary-table-head {
    display: flex;
  }

  .estimate-summary-table-head::after {
    content: none;
  }

  .card .card-block {
    padding-top: 10px !important;
  }

  .card .card-block .shop-light {
    justify-content: space-between;
  }

  .card .card-block .shop-light::after {
    content: none;
  }
}

.V3 .left-side {
  background: #DFEBF8;
  padding-bottom: 110px;
}

.V3 .left-side hr {
  width: 100%;
  border-bottom: 2px solid #C0D8EF;
  margin: 20px 0;
}

.V3 .left-side h3 {
  color: #142742;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.V3 .p-20 {
  padding: 20px;
}

.V3 .mt-3 {
  margin-top: 2.3rem !important;
}

.V3 .btn.btn-primary.mt-1.mb-1 {
  margin-bottom: 0.5rem;
}

.V3 .filed-md {
  display: block;
  width: 100%;
  background: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #DDDDDD;
  padding: 15px;
}

.V3 .filed-md::placeholder {
  color: #818A91;
  font-size: 14px;
  font-weight: 600;
}

.V3 .search-field {
  padding-left: 45px;
}

.V3 .search-label {
  position: absolute;
}

.V3 .search-label i {
  position: relative;
  display: block;
  font-size: 20px;
  color: #818A91;
  transform: translate(15px, 17px);
}

.V3 .left-side-nav {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.V3 .left-side-nav li {
  display: flex;
  justify-content: space-between;
  color: #142742;
  font-size: 14px;
  padding: 13px 20px;
  -webkit-transition: 0.2s linear;
  -moz-transition: 0.2s linear;
  -o-transition: 0.2s linear;
  transition: 0.2s linear;
}

.V3 .left-side-nav li:hover {
  background: #EFF5FA;
  color: #0672C3;
}

.V3 .left-side-nav li.active {
  background: #EFF5FA;
}

.V3 .left-side-nav button {
  cursor: pointer;
  width: 20px;
  padding: 0;
  margin-left: 5px;
}

.V3 .left-side-nav i {
  font-size: 20px;
  margin-left: 10px;
}

.V3 .left-side-nav .ti-write {
  color: #142742;
}

.V3 .left-side-nav .ti-trash {
  color: #D0021B;
}

.V3 .nav-tabs.nav-tabs-2 {
  /* border: none;*/
  /*   height: 50px; */
}

.V3 .estimate-items th {
  height: 48px;
  background-color: rgba(27, 30, 56, 0.1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
}

.V3 .estimates-edit .browse-btn {
  height: 38px;
  width: 126px;
  border-radius: 3px;
  background-color: #5E79FF;
  color: white;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit .cancel-btn {
  box-sizing: border-box;
  height: 39px;
  width: 127px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-images .bx {
  font-size: 37px;
  color: #5E79FF;
}

.V3 .estimates-edit .text-or {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-weight: 700;
  opacity: 0.25;
  font-size: 13px;
}

.V3 .estimates-edit .tab-content {
  padding-left: 0;
}

.V3 .estimates-edit .pin-checkmark {
  background-color: #FFFFFF;
}

.V3 .estimates-edit #upload-files .dnd-or {
  opacity: 0.25;
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-files .dnd-title {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-files i {
  font-size: 37px;
  color: #5E79FF
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 30px;
}

.V3 .estimates-edit-page .col-form-label {
  padding: 8px 0;
}

.V3 .estimates-edit-page .pin-image {
  align-items: center;
  position: relative;
  color: #34495E;
  height: 27px;
  font-weight: 600;
  font-size: 13px;
  padding-top: 8px;
  padding-left: 35px;
  margin-bottom: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

/* Hide the browser's default checkbox */
.V3 .estimates-edit-page .pin-image input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create the checkmark/indicator (hidden when not checked) */
.V3 .estimates-edit-page .pin-checkmark i {
  margin: auto;
  width: 16px;
  display: none;
  font-size: 26px;
  color: white;
  margin-left: -2px;
  margin-top: -2px;
}

/* Show the checkmark when checked */
.V3 .estimates-edit-page .pin-image input:checked ~ .pin-checkmark i {
  display: block;
}

.V3 .estimates-edit-page .card-block {
  padding: 13px;
}

.V3 .estimates-edit-page .shop-bold {
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
}

.V3 .estimates-edit-page .shop-bold .col-sm-7 {
  padding-left: 0;
}

.V3 .estimates-edit-page .shop-light {
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.V3 .estimates-edit-page .shop-light .col-sm-7 {
  padding-left: 0;
}

.V3 .estimates-edit-page .progress {
  border-top: 1px solid rgba(27, 30, 56, 0.25);
  padding-top: 15px;
}

.V3 .estimates-edit-page .progress h2 {
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
}

.V3 .estimates-edit-page .progress .full-activity {
  color: #5E79FF;
  font-size: 13px;
  font-weight: 600;
}

.tabs-absolute-right-notes-btn {
  margin-right: 160px;
}

.button.button.button--light {
  position: relative;
  cursor: pointer;
  border: 0px;
}

.button.button.button--light:active {
  top: 1px;
}

.pdr-menu {
}

.pdr-menu__item {
  position: relative;
}

.pdr-menu__button {
  cursor: pointer;
  border: 0px;
  padding: 0px;
  background: transparent;
}

.pdr-menu__comment {
  position: absolute;
  display: none;
  border-radius: 5px;
  overflow: hidden;
  right: -65%;
  top: 10px;
  background-color: #FFFFFF;

  /* copied from vue-context */
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

}

.pdr-menu__item.has-comment:hover .pdr-menu__comment,
.pdr-menu__item.has-comment:focus .pdr-menu__comment,
.pdr-menu__item.has-comment:active .pdr-menu__comment {
  display: flex;
}

.pdr-menu__comment textarea {
  min-height: 100px;
  width: 174px;
  border: 0px;
  padding: 10px;
}

.pdr-visible-icon {
  position: relative;
}

.disabled.pdr-visible-icon:after {
  display: none;
}

.pdr-visible-icon:after {
  content: '/';
  display: grid;
  place-items: center;
  position: absolute;
  top: -5px;
  left: -1px;
  font-weight: 900;
  font-size: 28px;
  transform: rotate(300deg);
  width: 24px;
  height: 24px;
  overflow: hidden;
  text-shadow: -1px -2px #DDDDDD;
}

.V3 .estimates-edit-page.is-mobile .form-control {
  padding-right: 20px !important;
}

.V3 .estimates-edit-page.is-mobile .nav-4 .nav-link {
  padding: .5rem .35rem;
}

.V3 .estimates-edit-page.is-mobile .nav-4 .nav-link i {
  margin-right: .35rem;
}

.V3 .vh-height-65 {
  overflow-x: hidden;
  overflow-y: auto;
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-p {
  padding-bottom: 10px;
  padding-right: 10px;
}

@media (max-width: 991px) {
  .col-lg-8 {
    float: right;
    width: 66.666667%;
  }
}

.V3 .nav-tabs.nav-tabs-2.is-mobile {
  display: block;
}

.scheduling-boards-multiselect :deep(.multiselect__input) {
  min-width: 0;
}

.error-text {
  color: red !important;
}

.white-text {
  color: white !important;
}

.nav-title {
  padding: 10px 15px 0 15px;
}

.owner-vehicle-title tbody >>> tr td {
  vertical-align: top;
}

.invoice .main-table tbody td, .invoice .main-table tfoot td {
  padding: 5px;
}

@media screen and (max-width: 767px) {
  .nav-title {
    padding: 0 10px 0 15px;
  }
}

@media screen and (max-width: 767px) {
  .reset-padd {
    padding-right: 0px;
  }

  .add-padd-mobile {
    padding-right: 15px;
    padding-left: 15px;
  }

  .padd-left-15 {
    padding-left: 15px !important;
  }

  .checkbox-group {
    flex-direction: column;
  }
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-p {
  padding-bottom: 10px;
  padding-right: 10px;
}

.close-edit-cursor {
  cursor: not-allowed;
}

@media (min-width: 1400px) {
  .numeric-qty {
    min-width: 2.5rem !important;
  }
}

@media screen and (max-width: 991px) {
  .invoice-header {
    flex-direction: column;
  }

  .table-fixed {
    table-layout: fixed;
  }

  .vat {
    display: block;
  }

  .owner-details tr {
    padding-left: 5px;
  }

  .invoice {
    width: 540px;
  }

  .main-flex {
    display: flex;
    flex-direction: column;
  }

  .mobile-disabled {
    display: none;
  }

  .invoice .main-table .vehicle-details td,
  .invoice .main-table .main-inner td {
    padding: 5px 0;
  }
}

@media screen and (max-width: 767px) {
  .invoice-header {
    flex-direction: column;
  }

  .invoice .main-total-table {
    float: left;
  }
}

@media screen and (max-width: 576px) {
  .invoice {
    width: 95%;
  }

  .invoice .main-table thead th {
    padding: 8px 5px;
  }

  .invoice .main-table tbody td, .invoice .main-table tfoot td {
    padding: 5px 0;
  }

  .block-position-wrap {
    flex-wrap: wrap;
    padding-left: 15px;
    justify-content: flex-end;
  }

  .V3 .estimates-edit-page .col-form-label {
    padding-left: 0 !important;
    text-align: left !important;
    min-width: 48px !important;
  }

  .V3 .estimates-edit-page.is-mobile .form-control {
    padding: 0.5rem 5px !important;
  }
}

.V3 .card-header {
  min-height: 48px;
  height: auto;
  align-items: center;
  transform: none;
}


.V3 .card-header {
  padding: 5px 15px !important;
}

.additional-menu-icon {
  position: absolute;
  right: 10px;
  top: 13px;
}

.trash-icon {
  cursor: pointer;
}

.estimate-item-comment {
  position: absolute;
  border-radius: 5px;
  overflow: hidden;
  width: 148px !important;
  height: 121px !important;
  left: 177px !important;
  background-color: #FFFFFF;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 5px 0 rgb(0 0 0 / 12%);
}

.estimate-item-comment textarea {
  height: 119px;
  width: 146px;
  border: none;
  padding: 0.75rem;
  resize: none;
}

.comment-limit-text {
  position: absolute;
  bottom: -5px;
  left: 6px;
  color: #A2ABAE;
}

.save-comment-icon {
  position: absolute;
  bottom: 7px;
  left: 124px;
  font-size: 27px;
  color: #73716C;
}

.save-comment-icon:hover {
  color: #5E79FF;
}

.tabs-nav-right-search-font-weight {
  display: flex;
}

@media screen and (max-width: 1670px) {
  .additional-padding-btn {
    padding-bottom: 10px;
  }
}

.tooltip {
  top: 32px !important;
}

@media screen and (max-width: 1024px) {
  .header-display-name {
    display: none;
  }

  .tabs-nav-right-search-font-weight {
    display: none;
  }
}

.estimate-items-wrapper {
  margin-right: 10px;
  margin-left: 10px;
}

@media (max-width: 767px) {
  .modal {
    top: 30% !important;
  }
}

.estimate-items-title {
  height: 48px;
  background-color: rgba(27, 30, 56, .1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.estimate-items-title-content {
  padding: 0.75rem;
  width: 95px;
  flex-grow: 0;
}

.V3 .estimates-edit-page .medium-rectangle-b-promo-block div {
  width: 300px;
  height: 250px;
}
</style>
